/* eslint-disable */
import { OperationContext } from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Any: { input: any; output: any };
  JSONObject: { input: any; output: any };
  Time: { input: string; output: string };
};

export enum AIDescriptionStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN',
}

export type AddUserToTeam = {
  teamID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export enum AggregationType {
  COUNT = 'COUNT',
  COUNT_SAMPLES = 'COUNT_SAMPLES',
  HISTOGRAM = 'HISTOGRAM',
  LAST = 'LAST',
  MAX = 'MAX',
  MEAN = 'MEAN',
  MEDIAN = 'MEDIAN',
  MIN = 'MIN',
  P10 = 'P10',
  P20 = 'P20',
  P25 = 'P25',
  P30 = 'P30',
  P40 = 'P40',
  P50 = 'P50',
  P60 = 'P60',
  P70 = 'P70',
  P75 = 'P75',
  P80 = 'P80',
  P90 = 'P90',
  P95 = 'P95',
  P99 = 'P99',
  P999 = 'P999',
  P9999 = 'P9999',
  STDEV = 'STDEV',
  SUM = 'SUM',
  SUMSQ = 'SUMSQ',
  TYPE_INVALID = 'TYPE_INVALID',
}

/** AlertAnalysisAggregationDimensionType specifies the type of dimension being aggregated. */
export enum AlertAnalysisAggregationDimensionType {
  /** Monitor label key-value pairs. */
  MONITOR_LABEL = 'MONITOR_LABEL',
  /** Monitor metadata (e.g., monitor_slug). */
  MONITOR_METADATA = 'MONITOR_METADATA',
  /** Alert signal key-value pairs. */
  SIGNAL = 'SIGNAL',
}

/** AlertAnalysisAggregationOptionsInput contains options for how to perform alert aggregation. */
export type AlertAnalysisAggregationOptionsInput = {
  /** If true, aggregate data over time buckets. */
  enableTimeBucketing?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, include monitor_slug as an additional grouping dimension. */
  includeMonitorDimension?: InputMaybe<Scalars['Boolean']['input']>;
  /** Duration of each time bucket (e.g., "15m", "1h", "6h"). Required if enableTimeBucketing is true. */
  timeBucketDuration?: InputMaybe<Scalars['String']['input']>;
};

/** AlertAnalysisLabelMatcherInput defines matching operations for a specific label. */
export type AlertAnalysisLabelMatcherInput = {
  /** The label key to match. */
  key: Scalars['String']['input'];
  /** String matcher for the label value. */
  value: AlertAnalysisStringMatcherInput;
};

/** AlertAnalysisLabelsMatcherInput defines label matching operations for filtering. */
export type AlertAnalysisLabelsMatcherInput = {
  /** Label matchers to apply. */
  labels: Array<AlertAnalysisLabelMatcherInput>;
  /** Minimum number of label matches required for this matcher to be satisfied. */
  minMatches?: InputMaybe<Scalars['Int']['input']>;
};

/** AlertAnalysisStringMatcherInput defines string matching operations for filtering. */
export type AlertAnalysisStringMatcherInput = {
  /** Multiple values for operations like ANY_OF, NONE_OF. */
  multiValue?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The string matching operation to perform. */
  operation: AlertAnalysisStringMatcherOperation;
  /** Single value for operations like EQUAL, NOT_EQUAL, CONTAINS, etc. */
  singleValue?: InputMaybe<Scalars['String']['input']>;
};

/** AlertAnalysisStringMatcherOperation defines the available string matching operations. */
export enum AlertAnalysisStringMatcherOperation {
  /** Matches any of the provided values. */
  ANY_OF = 'ANY_OF',
  /** Contains substring match. */
  CONTAINS = 'CONTAINS',
  /** Exact equality match. */
  EQUAL = 'EQUAL',
  /** Does not match any of the provided values. */
  NONE_OF = 'NONE_OF',
  /** Does not contain substring match. */
  NOT_CONTAINS = 'NOT_CONTAINS',
  /** Not equal match. */
  NOT_EQUAL = 'NOT_EQUAL',
  /** Negated regular expression match. */
  NOT_REGEX_EQUAL = 'NOT_REGEX_EQUAL',
  /** Regular expression match. */
  REGEX_EQUAL = 'REGEX_EQUAL',
}

/** AlertDatastoreSeverity represents the severity level of an alert. */
export enum AlertDatastoreSeverity {
  /** Critical level alert */
  CRITICAL = 'CRITICAL',
  UNKNOWN = 'UNKNOWN',
  /** Warning level alert */
  WARN = 'WARN',
}

/** AlertDatastoreStatus represents the current status of an alert in the datastore. */
export enum AlertDatastoreStatus {
  /** Alert has been resolved */
  RESOLVED = 'RESOLVED',
  /** Alert is currently triggered */
  TRIGGERED = 'TRIGGERED',
  UNKNOWN = 'UNKNOWN',
}

export enum AlertEventType {
  MONITOR_MUTED = 'MONITOR_MUTED',
  MONITOR_RESOLVED = 'MONITOR_RESOLVED',
  MONITOR_RESOLVED_NOTIFICATION_FAILED_TO_SEND = 'MONITOR_RESOLVED_NOTIFICATION_FAILED_TO_SEND',
  MONITOR_RESOLVED_NOTIFICATION_SENT = 'MONITOR_RESOLVED_NOTIFICATION_SENT',
  MONITOR_TRIGGERED = 'MONITOR_TRIGGERED',
  MONITOR_TRIGGERED_NOTIFICATION_FAILED_TO_SEND = 'MONITOR_TRIGGERED_NOTIFICATION_FAILED_TO_SEND',
  MONITOR_TRIGGERED_NOTIFICATION_SENT = 'MONITOR_TRIGGERED_NOTIFICATION_SENT',
  MONITOR_UNMUTED = 'MONITOR_UNMUTED',
  UNKNOWN = 'UNKNOWN',
}

/** AlertFiltersCombineMode specifies how multiple alert filters are combined. */
export enum AlertFiltersCombineMode {
  /** All filters must match (default). */
  AND = 'AND',
  /** At least one filter must match. */
  OR = 'OR',
}

export enum AlertRouteMatcherType {
  EXACT_MATCHER_TYPE = 'EXACT_MATCHER_TYPE',
  REGEXP_MATCHER_TYPE = 'REGEXP_MATCHER_TYPE',
}

export enum AlertState {
  CRITICAL = 'CRITICAL',
  DOWNTIMED = 'DOWNTIMED',
  FIRING = 'FIRING',
  INACTIVE = 'INACTIVE',
  NODATA = 'NODATA',
  PASS = 'PASS',
  PENDING = 'PENDING',
  RESOLVED = 'RESOLVED',
  UNKNOWN = 'UNKNOWN',
  WARNING = 'WARNING',
}

/**
 * AlertsFilters contains filtering options for querying alerts.
 * All filters are ANDed together when multiple are specified.
 */
export type AlertsFilters = {
  /** Filter by config entity name (searches both monitor and SLO names) */
  configEntityName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter alerts by time window. Returns alerts that were active/triggered at any time during the window.
   * This includes alerts whose created_at is within the time window OR whose resolved_at is within the time window.
   */
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** Filter by monitor slug */
  monitorSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by whether the alert is currently muted. If this is unspecified, all alerts are returned. */
  mutedStates?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Filter by alert severity. If multiple severities are provided, they are ORed together */
  severities?: InputMaybe<Array<AlertDatastoreSeverity>>;
  /** Filter by SLO slug */
  sloSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filter alerts by time window. Returns alerts that were active/triggered at any time during the window.
   * This includes alerts whose created_at is within the time window OR whose resolved_at is within the time window.
   */
  startTime?: InputMaybe<Scalars['String']['input']>;
  /** Filter by alert status. If multiple statuses are provided, they are ORed together */
  statuses?: InputMaybe<Array<AlertDatastoreStatus>>;
};

export type AllDashboardsFilter = {
  collectionRefs?: InputMaybe<Array<CollectionRef>>;
  collectionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Exclude grafana dashboards that have been migrated to a native dashboard */
  excludeMigratedGrafana?: InputMaybe<Scalars['Boolean']['input']>;
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If true, search for dashboards that are owned by the filtered collections as well as
   * those linked to the filtered collections.
   */
  includeLinkedCollections?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<LabelInput>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set, only dashboards that are in the customer namespace will be returned. */
  onlyCustomerManaged?: InputMaybe<Scalars['Boolean']['input']>;
  ordering?: InputMaybe<DashboardOrdering>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set, only dashboards owned by this source will be included */
  sources?: InputMaybe<Array<Scalars['String']['input']>>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AllocationInput = {
  percentOfLicense: Scalars['Float']['input'];
};

export type AnalyticsEventInput = {
  eventId: Scalars['String']['input'];
  eventName: Scalars['String']['input'];
  eventTime: Scalars['Time']['input'];
  eventType: Scalars['String']['input'];
  pageData?: InputMaybe<PageDataInput>;
  sessionId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

/** AnalyzeAlertsAggregateInput contains the parameters for the analyzeAlertsAggregate query. */
export type AnalyzeAlertsAggregateInput = {
  /** Aggregation options controlling how alerts are grouped and counted. */
  aggregationOptions?: InputMaybe<AlertAnalysisAggregationOptionsInput>;
  /** Optional filtering options for the aggregation query. Deprecated - use filters and filtersCombineMode instead. */
  filter?: InputMaybe<AnalyzeAlertsListFilterInput>;
  /** Multiple filters for more flexible filtering. When provided, filter field is ignored. */
  filters?: InputMaybe<Array<AnalyzeAlertsListFilterInput>>;
  /** How to combine multiple filters. Defaults to AND if not specified. */
  filtersCombineMode?: InputMaybe<AlertFiltersCombineMode>;
  /** Time range for the query. Both startTime and endTime are required in RFC3339 format. */
  timeRange: NewTimeRange;
};

/**
 * AnalyzeAlertsListFilterInput contains comprehensive filter options for the list alerts query.
 * This uses enhanced filtering capabilities with string matchers and label matchers.
 */
export type AnalyzeAlertsListFilterInput = {
  /** Filter by mute status. When true, only returns muted alerts. When false, only returns non-muted alerts. */
  isMuted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by maximum duration in seconds. Only returns alerts with duration less than or equal to this value. */
  maxDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by minimum duration in seconds. Only returns alerts with duration greater than or equal to this value. */
  minDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by monitor labels using label matching operations. */
  monitorLabels?: InputMaybe<AlertAnalysisLabelsMatcherInput>;
  /** Filter by monitor slug using string matching operations. */
  monitorSlug?: InputMaybe<AlertAnalysisStringMatcherInput>;
  /** Filter by notification policy slug using string matching operations. */
  notificationPolicySlug?: InputMaybe<AlertAnalysisStringMatcherInput>;
  /** Filter by signal labels using label matching operations. */
  signals?: InputMaybe<AlertAnalysisLabelsMatcherInput>;
};

/** AnalyzeAlertsListInput contains the parameters for the analyzeAlertsList query. */
export type AnalyzeAlertsListInput = {
  /** Optional filtering options for the list alerts query. Deprecated - use filters and filtersCombineMode instead. */
  filter?: InputMaybe<AnalyzeAlertsListFilterInput>;
  /** Multiple filters for more flexible filtering. When provided, filter field is ignored. */
  filters?: InputMaybe<Array<AnalyzeAlertsListFilterInput>>;
  /** How to combine multiple filters. Defaults to AND if not specified. */
  filtersCombineMode?: InputMaybe<AlertFiltersCombineMode>;
  /** Time range for the query. Both startTime and endTime are required in RFC3339 format. */
  timeRange: NewTimeRange;
};

export type AnnotationInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type BetweenTimeFilterInput = {
  maxTimestamp: Scalars['String']['input'];
  minTimestamp: Scalars['String']['input'];
};

export type BoolFilterInput = {
  value: Scalars['Boolean']['input'];
};

export type BulkUpdateTeam = {
  addedUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removedUserIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  teamID: Scalars['ID']['input'];
};

export type BulkUpdateTeamsForUser = {
  addedTeamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  removedTeamIDs?: InputMaybe<Array<Scalars['ID']['input']>>;
  userID: Scalars['ID']['input'];
};

export type CloseToTimeFilterInput = {
  timestamp: Scalars['String']['input'];
};

export type CollectionLinkDashboardRefInput = {
  slug: Scalars['String']['input'];
};

/** CollectionLinkEntityReference is a type that specifies a reference to an entity in a collection link. */
export type CollectionLinkEntityReferenceInput = {
  /** The slug of entity being referenced */
  slug: Scalars['String']['input'];
};

/**
 * CollectionLinkInput is an input type that specifies a collection link to create or update.
 * A collection link must reference either a monitor or a dashboard.
 * If a slug is not provided, a new collection link will be created.
 */
export type CollectionLinkInput = {
  collectionRef: CollectionRef;
  dashboardRef?: InputMaybe<CollectionLinkDashboardRefInput>;
  monitorRef?: InputMaybe<CollectionLinkMonitorRefInput>;
};

/** CollectionLinkListFilterInput is an input type that specifies filter criteria for listing collection links. */
export type CollectionLinkListFilterInput = {
  collectionRefs?: InputMaybe<Array<CollectionRef>>;
  dashboardRefs?: InputMaybe<Array<CollectionLinkEntityReferenceInput>>;
  monitorRefs?: InputMaybe<Array<CollectionLinkEntityReferenceInput>>;
  types?: InputMaybe<Array<CollectionLinkType>>;
};

export type CollectionLinkMonitorRefInput = {
  impactsServiceHealth: Scalars['Boolean']['input'];
  slug: Scalars['String']['input'];
};

/** CollectionLinkType is an enum that represents the type of entity that a collection link references. */
export enum CollectionLinkType {
  DASHBOARD = 'DASHBOARD',
  MONITOR = 'MONITOR',
}

/** CollectionRef is used to querying for collections or items in collections. */
export type CollectionRef = {
  slug: Scalars['String']['input'];
  type: CollectionType;
};

export enum CollectionType {
  SERVICE = 'SERVICE',
  SIMPLE = 'SIMPLE',
}

export type CollectionsFilters = {
  /** If set, will also return inactive collections. If not provided that will also include inactive collections. */
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, only collections whose name contains the specified string will be returned. */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** If set, only collections who have the default notification policy set to the specified slug will be returned." */
  notificationPolicySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set, only collections that are in the customer namespace will be returned. */
  onlyCustomerManaged?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, only collections who are unowned will be returned. */
  requireUnowned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter returned collections by a set of team slugs. */
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set, return collections matching the specified types */
  types?: InputMaybe<Array<InputMaybe<CollectionType>>>;
};

export type CommentSearchFilter = {
  authorEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  taggedUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  targetRefMatcher?: InputMaybe<CommentStringMatcherInput>;
  targetTypes?: InputMaybe<Array<TargetType>>;
  textContains?: InputMaybe<Scalars['String']['input']>;
};

/** CommentStringMatcherInput defines string matching operations for filtering. */
export type CommentStringMatcherInput = {
  /** Multiple values for operations like ANY_OF, NONE_OF. */
  multiValue?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The string matching operation to perform. */
  operation: CommentStringMatcherOperation;
  /** Single value for operations like EQUAL, NOT_EQUAL, CONTAINS, etc. */
  singleValue?: InputMaybe<Scalars['String']['input']>;
};

/** CommentStringMatcherOperation defines the available string matching operations. */
export enum CommentStringMatcherOperation {
  /** Matches any of the provided values. */
  ANY_OF = 'ANY_OF',
  /** Contains substring match. */
  CONTAINS = 'CONTAINS',
}

export type CommentsListInput = {
  id: Scalars['ID']['input'];
};

export type ComponentDiscoveryOverrideInput = {
  metric?: InputMaybe<MetricDiscoveryOverrideInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  status?: InputMaybe<ComponentDiscoveryOverrideStatus>;
};

export enum ComponentDiscoveryOverrideStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export type ComponentPresentationDiffInput = {
  eligibility: EligibilityCriteriaInput;
  slug: Scalars['String']['input'];
  status: ComponentPresentationOverrideStatus;
};

export type ComponentPresentationOverrideInput = {
  componentPresentationSlug: Scalars['String']['input'];
  status: ComponentPresentationOverrideStatus;
};

export enum ComponentPresentationOverrideStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export enum ComponentPresentationType {
  EVENTS = 'EVENTS',
  PANELS = 'PANELS',
  UNKNOWN = 'UNKNOWN',
}

export enum ComponentType {
  COMPUTE = 'COMPUTE',
  RPC = 'RPC',
  UNKNOWN = 'UNKNOWN',
}

export enum ConditionLevel {
  CRITICAL = 'CRITICAL',
  UNKNOWN = 'UNKNOWN',
  WARN = 'WARN',
}

/** ConfigEntityType represents the type of entity that generated an alert. */
export enum ConfigEntityType {
  /** Alert generated by a monitor */
  MONITOR = 'MONITOR',
  /** Alert generated by an SLO */
  SLO = 'SLO',
}

export type ConstructedLabelInput = {
  /** The value definitions for the constructed label. */
  valueDefinitions?: InputMaybe<Array<ValueDefinitionInput>>;
};

export enum ConsumptionBudgetStatus {
  ALERT_CRITICAL = 'ALERT_CRITICAL',
  ALERT_WARN = 'ALERT_WARN',
  DROPPING = 'DROPPING',
  NO_BUDGET = 'NO_BUDGET',
  OK = 'OK',
  UNKNOWN = 'UNKNOWN',
}

export enum ConsumptionBudgetThresholdAction {
  ALERT_CRITICAL = 'ALERT_CRITICAL',
  ALERT_WARN = 'ALERT_WARN',
  DROP = 'DROP',
}

export enum ConsumptionBudgetThresholdType {
  DAILY_VOLUME = 'DAILY_VOLUME',
  HOURLY_VOLUME = 'HOURLY_VOLUME',
  INSTANT_RATE = 'INSTANT_RATE',
  MONTHLY_VOLUME = 'MONTHLY_VOLUME',
  ROLLING_1_HOUR_VOLUME = 'ROLLING_1_HOUR_VOLUME',
  ROLLING_3_HOUR_VOLUME = 'ROLLING_3_HOUR_VOLUME',
  WEEKLY_VOLUME = 'WEEKLY_VOLUME',
}

export enum ConsumptionPartitionFilterOperator {
  IN = 'IN',
  NOT_IN = 'NOT_IN',
}

export enum ConsumptionResource {
  LOG_PERSISTED_BYTES = 'LOG_PERSISTED_BYTES',
  LOG_PROCESSED_BYTES = 'LOG_PROCESSED_BYTES',
  METRIC_PERSISTED_SERIES = 'METRIC_PERSISTED_SERIES',
}

export enum ConsumptionTimeSeriesGroupBy {
  CONSUMED_BY_PARTITION = 'CONSUMED_BY_PARTITION',
  CONSUMED_VS_DROPPED = 'CONSUMED_VS_DROPPED',
  DROPPED_BY_PARTITION = 'DROPPED_BY_PARTITION',
}

export enum ConsumptionTimeSeriesView {
  CUMULATIVE = 'CUMULATIVE',
  DAILY = 'DAILY',
  MONTHLY_CUMULATIVE = 'MONTHLY_CUMULATIVE',
  PER_SECOND = 'PER_SECOND',
  ROLLING_1_HOUR = 'ROLLING_1_HOUR',
  ROLLING_3_HOUR = 'ROLLING_3_HOUR',
  WEEKLY = 'WEEKLY',
}

export enum ConsumptionTrendType {
  MONTH_OVER_MONTH = 'MONTH_OVER_MONTH',
  WEEK_OVER_WEEK = 'WEEK_OVER_WEEK',
}

export type CountFilterInput = {
  isMaxExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  isMinExclusive?: InputMaybe<Scalars['Boolean']['input']>;
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type CreateCollection = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Optional slug of notification policy used by this collection */
  policySlug?: InputMaybe<Scalars['String']['input']>;
  /** Optional slug for the collection. If omitted, this will be assigned based on name. */
  slug?: InputMaybe<Scalars['String']['input']>;
  team_slug?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommentInput = {
  taggedUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  text: Scalars['String']['input'];
  threadID: Scalars['ID']['input'];
};

export type CreateCustomComponentInput = {
  dashboard: Scalars['JSONObject']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serviceTemplateVar?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDatasetInput = {
  description: Scalars['String']['input'];
  logConfiguration?: InputMaybe<LogDatasetConfigurationInput>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  traceConfiguration?: InputMaybe<TraceDatasetConfigurationInput>;
  type: DatasetType;
};

export type CreateDerivedLabelInput = {
  /** DerivedLabelSpanTag is used to map span tags to derived labels. */
  derivedLabelSpanTag?: InputMaybe<DerivedLabelSpanTagInput>;
  /** An optional description of the derived label. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** This field specifies the action taken when there's a metric label with the same name as this derived label. */
  existingLabelPolicy?: InputMaybe<DerivedLabelPolicy>;
  /** The name of the derived label. */
  labelName: Scalars['String']['input'];
  metricLabel?: InputMaybe<MetricLabelInput>;
  /** The name of the derived label. */
  name: Scalars['String']['input'];
  /** The unique slug of the derived label. */
  slug: Scalars['String']['input'];
};

export type CreateDiscoveryInput = {
  /** Discovery config for events. */
  events?: InputMaybe<EventDiscoveryInput>;
  /** Discovery config for metrics. */
  metrics?: InputMaybe<MetricsDiscoveryInput>;
  name: Scalars['String']['input'];
};

export type CreateLinkTemplateInput = {
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['ID']['input']>;
  urlTemplate: Scalars['String']['input'];
};

export type CreateLogAllocationConfigInput = {
  dryRun: Scalars['Boolean']['input'];
  logAllocationConfig: LogAllocationConfigInput;
};

export type CreateLogControlConfigInput = {
  dryRun: Scalars['Boolean']['input'];
  logControlConfig: LogControlConfigInput;
};

export type CreateLogIngestConfigInput = {
  dryRun: Scalars['Boolean']['input'];
  logIngestConfig: LogIngestConfigInput;
};

export type CreateLogLookupTableInput = {
  dryRun: Scalars['Boolean']['input'];
  logLookupTable: LogLookupTableInput;
};

export type CreatePersonalAccessTokenInput = {
  expiration: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreatePresentationInput = {
  dashboard?: InputMaybe<PresentationDashboardInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  eligibility: PresentationEligibilityInput;
  events?: InputMaybe<PresentationEventsInput>;
  name: Scalars['String']['input'];
  numPanelsToDisplay?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSavedTraceSearchInput = {
  comparison?: InputMaybe<TraceSearchInput>;
  name: Scalars['String']['input'];
  search: TraceSearchInput;
  slug?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSearchHistoryInput = {
  search: NewSearchHistory;
};

export type CreateServiceAccountInput = {
  labels?: InputMaybe<Array<LabelInput>>;
  name: Scalars['String']['input'];
  permission?: InputMaybe<PermissionAction>;
};

export type CreateSignupInviteInput = {
  email: Scalars['String']['input'];
};

export type CreateThreadInput = {
  taggedUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  target: TargetInput;
  /** This is the initial comment text for the thread */
  text: Scalars['String']['input'];
};

export type CreateTraceBehaviorInput = {
  baseHeadSampleRate?: InputMaybe<Scalars['Float']['input']>;
  baseTailSampleRate?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorSampleOptions?: InputMaybe<TraceBehaviorErrorSampleOptionsInput>;
  fastSampleOptions?: InputMaybe<TraceBehaviorFastSampleOptionsInput>;
  largeTraceSampleOptions?: InputMaybe<TraceBehaviorLargeTraceSampleOptionsInput>;
  name: Scalars['String']['input'];
  slowSampleOptions?: InputMaybe<TraceBehaviorSlowSampleOptionsInput>;
  slug?: InputMaybe<Scalars['ID']['input']>;
  smallTraceSampleOptions?: InputMaybe<TraceBehaviorSmallTraceSampleOptionsInput>;
};

export type CreateTraceMetricsRuleInput = {
  groupBys?: InputMaybe<Array<TraceMetricsGroupByInput>>;
  histogramBucketsSeconds: Array<Scalars['Float']['input']>;
  metricLabels: Array<LabelInput>;
  metricName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scopeFilter?: InputMaybe<ScopeFilterInput>;
  slug?: InputMaybe<Scalars['ID']['input']>;
  traceFilter: TraceSearchFilterInput;
};

export type CreateTraceSearchHistoryInput = {
  comparison?: InputMaybe<TraceSearchInput>;
  search: TraceSearchInput;
};

export type DarkModeInput = {
  darkMode: Scalars['Boolean']['input'];
};

export enum DashboardColumn {
  FAVORITES = 'FAVORITES',
}

export enum DashboardOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export type DashboardOrdering = {
  column: DashboardColumn;
  order: DashboardOrder;
};

export type DatasetAllocationInput = {
  allocation: AllocationInput;
  datasetSlug: Scalars['String']['input'];
  priorities: HighLowPrioritiesInput;
};

export type DatasetEnhancementsInput = {
  traceInput?: InputMaybe<TraceDatasetEnhancementsInput>;
  type: DatasetType;
};

export enum DatasetType {
  DATASET_TYPE_INVALID = 'DATASET_TYPE_INVALID',
  LOGS = 'LOGS',
  TRACES = 'TRACES',
}

export type DatasetsListFilterInput = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<DatasetType>;
};

export enum DatasourceType {
  GRAPHITE = 'GRAPHITE',
  LOGGING = 'LOGGING',
  PROMETHEUS = 'PROMETHEUS',
}

export type DebugLogFilter = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DefaultDatasetInput = {
  allocation: AllocationInput;
  priorities: HighLowPrioritiesInput;
};

export type DeleteAlertNotificationPolicy = {
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAlertReceiver = {
  /** Deprecated, use slug when possible. */
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteCollection = {
  /** Required slug for the collection to delete. */
  slug: Scalars['ID']['input'];
};

/** Input for deleting a collection homepage if it exists. */
export type DeleteCollectionHomepageInput = {
  collectionSlug: Scalars['String']['input'];
};

/** DeleteCollectionLinksInput is an input type that specifies the identity of a collection link to delete. */
export type DeleteCollectionLinksInput = {
  slugs: Array<Scalars['String']['input']>;
};

export type DeleteCustomComponentInput = {
  slug: Scalars['String']['input'];
};

export type DeleteDashboard = {
  slug: Scalars['String']['input'];
};

export type DeleteDatasetInput = {
  slug: Scalars['String']['input'];
};

export type DeleteDerivedLabelInput = {
  slug: Scalars['String']['input'];
};

export type DeleteDiscoveryInput = {
  slug: Scalars['String']['input'];
};

export type DeleteDropRule = {
  slug: Scalars['String']['input'];
};

export type DeleteGrafanaDashboard = {
  slug: Scalars['String']['input'];
};

export type DeleteLinkTemplateInput = {
  slug: Scalars['ID']['input'];
};

export type DeleteMappingRule = {
  slug: Scalars['String']['input'];
};

export type DeleteMonitor = {
  slug: Scalars['String']['input'];
};

export type DeletePersonalAccessTokensInput = {
  slugs: Array<Scalars['ID']['input']>;
};

export type DeletePresentationInput = {
  slug: Scalars['String']['input'];
};

export type DeleteRecordingRule = {
  id: Scalars['ID']['input'];
};

export type DeleteRollupRule = {
  slug: Scalars['String']['input'];
};

export type DeleteSLOInput = {
  slug: Scalars['String']['input'];
};

export type DeleteSavedTraceSearchInput = {
  slug: Scalars['ID']['input'];
};

export type DeleteSearchHistoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteServiceAccountInput = {
  id: Scalars['String']['input'];
};

export type DeleteServiceAccountsInput = {
  ids: Array<Scalars['String']['input']>;
};

export type DeleteTeam = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for deleting a team homepage if it exists. */
export type DeleteTeamHomepageInput = {
  teamSlug: Scalars['String']['input'];
};

export type DeleteTraceBehaviorInput = {
  slug: Scalars['ID']['input'];
};

export type DeleteTraceMetricsRuleInput = {
  slug: Scalars['String']['input'];
};

export type DeleteUserInput = {
  /** Deactivate the user first before deleting, even if they were not deactivated */
  forceDeactivate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};

export type DerivedLabelFilterInput = {
  /** The name of the field in a Prom expression that is being used to filter results */
  name: Scalars['String']['input'];
  /** A glob match of possible values for the field */
  valueGlob: Scalars['String']['input'];
};

export enum DerivedLabelPolicy {
  /** Keep the existing label. */
  KEEP = 'KEEP',
  /** Invalid label policy. */
  LABEL_POLICY_INVALID = 'LABEL_POLICY_INVALID',
  /** Override the existing label. */
  OVERRIDE = 'OVERRIDE',
}

export type DerivedLabelPreviewInput = {
  derivedLabel: CreateDerivedLabelInput;
  endTime: Scalars['Time']['input'];
  startTime: Scalars['Time']['input'];
};

export type DerivedLabelSpanTagInput = {
  /** The name mappings for the span tag. */
  nameMappings?: InputMaybe<Array<DerivedLabelSpanTagNameMappingInput>>;
};

export type DerivedLabelSpanTagNameMappingInput = {
  /** The source tag to be mapped to the derived tag. */
  sourceTag: Scalars['String']['input'];
};

export type DerivedLabelValueMappingInput = {
  /** Defines the source label values that should be mapped into the given target value. */
  sourceValueGlobs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The value that source_value_globs are mapped into. */
  targetValue: Scalars['String']['input'];
};

export type DiscoveryConfigsInput = {
  debugLogFilter?: InputMaybe<DebugLogFilter>;
  discoveryOverrides?: InputMaybe<Array<ComponentDiscoveryOverrideInput>>;
  /** @deprecated replaced with discoveryOverrides */
  overrides?: InputMaybe<Array<ComponentDiscoveryOverrideInput>>;
  rules?: InputMaybe<Array<ObjectMergeRuleInput>>;
  /**
   * The discovery pipeline caches the results of the most recent run
   * as well a few of the results of the most recent dry runs.
   * The discovery pipeline only reads from the cache for dry runs.
   * Setting this field to true will force a dry run to run the entire
   * discovery pipeline even if there is a cached result already.
   * If this is not a dry run, this field does nothing.
   */
  skipCache?: InputMaybe<Scalars['Boolean']['input']>;
  suppressionExemptServices?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum DiscoveryPipelineStatusMessageCode {
  CANDIDATE_EXCEEDS_DIMENSION_COUNT = 'CANDIDATE_EXCEEDS_DIMENSION_COUNT',
  CONFLICTING_MAPPING_VALUES = 'CONFLICTING_MAPPING_VALUES',
  EMPTY_SERVICE_OWNS_ENTITIES = 'EMPTY_SERVICE_OWNS_ENTITIES',
  MULTIPLE_SERVICE_NAMES = 'MULTIPLE_SERVICE_NAMES',
  SOURCE_LABEL_MISSING = 'SOURCE_LABEL_MISSING',
  TOO_MANY_RESULTS = 'TOO_MANY_RESULTS',
  UNIQUE_SOURCE_LABEL_NOT_FOUND = 'UNIQUE_SOURCE_LABEL_NOT_FOUND',
  UNKNOWN = 'UNKNOWN',
}

export enum DiscoveryPipelineStatusMessageSeverity {
  ERROR = 'ERROR',
  INFO = 'INFO',
  UNKNOWN = 'UNKNOWN',
  WARNING = 'WARNING',
}

export enum DiscoveryStatus {
  Added = 'Added',
  Deleted = 'Deleted',
  Modified = 'Modified',
  Unchanged = 'Unchanged',
  Unknown = 'Unknown',
}

export enum DocArtifactSortField {
  CREATED_AT = 'CREATED_AT',
  KEY = 'KEY',
  LABEL_NAME = 'LABEL_NAME',
  UPDATED_AT = 'UPDATED_AT',
}

/**
 * DocArtifactSortOrder is a structured sort input.
 *
 * If field == LABEL_NAME, labelName must be provided to indicate which label to sort by.
 */
export type DocArtifactSortOrder = {
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  field: DocArtifactSortField;
  /** Label name to sort by. Must be set when field is LABEL_NAME. */
  labelName?: InputMaybe<Scalars['String']['input']>;
};

export enum DropRuleMode {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
  PREVIEW = 'PREVIEW',
}

export type DurationFilterInput = {
  maxSeconds: Scalars['Float']['input'];
  minSeconds: Scalars['Float']['input'];
};

export enum EditSource {
  EDITABLE = 'EDITABLE',
  UNEDITABLE_K8S_OWNED = 'UNEDITABLE_K8S_OWNED',
  UNEDITABLE_SLO_GENERATED = 'UNEDITABLE_SLO_GENERATED',
  UNEDITABLE_TF_OWNED = 'UNEDITABLE_TF_OWNED',
}

export type EligibilityCriteriaInput = {
  allowedServices?: InputMaybe<Array<Scalars['String']['input']>>;
  ignoredServices?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredDiscoveries?: InputMaybe<Array<Scalars['String']['input']>>;
  withoutDiscoveries?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EligibleServicesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  eligibility: EligibilityCriteriaInput;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type EmitMetricsCounterInput = {
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum EmitMetricsGaugeAggregationType {
  LAST = 'LAST',
  MAX = 'MAX',
  MIN = 'MIN',
}

export type EmitMetricsGaugeInput = {
  aggregationType: EmitMetricsGaugeAggregationType;
  value: Scalars['String']['input'];
};

export type EmitMetricsHistogramInput = {
  value: Scalars['String']['input'];
};

export type EmitMetricsLabelInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum EmitMetricsMode {
  COUNTER = 'COUNTER',
  GAUGE = 'GAUGE',
  HISTOGRAM = 'HISTOGRAM',
}

export enum EntityNamespace {
  CUSTOMER = 'CUSTOMER',
  INTERNAL = 'INTERNAL',
  MANAGED = 'MANAGED',
}

export type EntityVersionFilters = {
  /** The slug of the entity whose versions to fetch. */
  slug: Scalars['String']['input'];
  /**
   * Optional sources to filter on
   * If multiple sources are provided, the results are "OR'd" together. If used wth other
   * filters, then the filtered results are "AND'd" together.
   */
  sources?: InputMaybe<Array<EntityVersionSource>>;
  /** Optional time range to filter versions within */
  timeRange?: InputMaybe<NewTimeRange>;
  /** The type of the entity whose versions to fetch. */
  type: EntityVersionType;
  /** Sort order for versions, will default to descending */
  versionOrder?: InputMaybe<EntityVersionOrder>;
};

export enum EntityVersionOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum EntityVersionSource {
  API = 'API',
  CHRONOCTL = 'CHRONOCTL',
  TERRAFORM = 'TERRAFORM',
  UI = 'UI',
  UNKNOWN = 'UNKNOWN',
}

export enum EntityVersionType {
  DASHBOARD = 'DASHBOARD',
  LOG_CONTROL_CONFIG = 'LOG_CONTROL_CONFIG',
  LOG_INGEST_CONFIG = 'LOG_INGEST_CONFIG',
  MONITOR = 'MONITOR',
  SLO = 'SLO',
}

export type ErrorCodeDefInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  isSuccess: Scalars['Boolean']['input'];
  value: Scalars['String']['input'];
};

export type EventDiscoveryInput = {
  /** Change events label name to use to discover service names. Values of this label will be used as candidates for service names. */
  serviceNameLabel: Scalars['String']['input'];
};

export enum ExportFormat {
  CHRONOCTL = 'CHRONOCTL',
  TERRAFORM = 'TERRAFORM',
  UNKNOWN = 'UNKNOWN',
}

export enum FavoriteEntityType {
  DASHBOARD = 'DASHBOARD',
  GRAFANA_DASHBOARD = 'GRAFANA_DASHBOARD',
  MONITOR = 'MONITOR',
}

export type FeatureFlagRequest = {
  /** The value type that the flag is expected to return. */
  flagType: FeatureFlagType;
  /** The key by which the flag is defined in LaunchDarkly. */
  key: Scalars['String']['input'];
};

export enum FeatureFlagType {
  BOOL = 'BOOL',
  INT = 'INT',
  STRING = 'STRING',
}

export type FieldNormalizationInput = {
  customFieldNormalization?: InputMaybe<Array<NamedStringNormalizationInput>>;
  message?: InputMaybe<StringNormalizationInput>;
  primaryKey?: InputMaybe<NamedStringNormalizationInput>;
  severity?: InputMaybe<StringNormalizationInput>;
  timestamp?: InputMaybe<TimestampNormalizationInput>;
};

export type GrafanaDashboardFilter = {
  collectionRefs?: InputMaybe<Array<CollectionRef>>;
  collectionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set and set to true, filters to only favorites */
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  labels?: InputMaybe<Array<LabelInput>>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GrafanaDashboardSettings = {
  /**
   * Collection where this dashboard belongs. Saving with a different collection slug will move
   * the dashboard from the old collection to the new collection.
   */
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
  /**
   * Type of the collection containing the dashboard. Optional for backwards compatibility. Defaults to SIMPLE if not
   * specified.
   */
  collectionType?: InputMaybe<CollectionType>;
  /** Labels for dashboards. These correspond to "tags" in grafana. The only valid key is "grafanaTag". */
  labels?: InputMaybe<Array<LabelInput>>;
  /** Name of the dashboard. This maps to a grafana dashboard title. */
  name: Scalars['String']['input'];
  /**
   * Slug is a unique identifier for dashboards. Saving a dashboard without a slug will
   * create a new dashboard and generate a new slug. This field maps to a grafana dashboard uid.
   *
   * If a dashboard with this slug already exists, this will overwrite the dashboard.
   */
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type HighLowPrioritiesInput = {
  highPriorityFilters: Array<InputMaybe<LogSearchFilterInput>>;
  lowPriorityFilters: Array<InputMaybe<LogSearchFilterInput>>;
};

export type ImportGrafanaDashboard = {
  /**
   * Grafana dashboard json. Any differences in name, uid (slug) or tags (labels)
   * in the dashboard json will be overridden by corresponding fields in the settings.
   */
  dashboardJSON: Scalars['String']['input'];
  settings: GrafanaDashboardSettings;
};

export type InputDropRuleValueBasedDrop = {
  enabled: Scalars['Boolean']['input'];
  targetDropValue: Scalars['Float']['input'];
};

export type InputGraphiteLabelPolicy = {
  replace?: InputMaybe<Array<InputMaybe<InputGraphiteLabelPolicyReplace>>>;
};

export type InputGraphiteLabelPolicyReplace = {
  name: Scalars['String']['input'];
  newValue: Scalars['String']['input'];
};

export type InputLabelPolicy = {
  discard?: InputMaybe<Array<Scalars['String']['input']>>;
  keep?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type InputMappingRuleAggregationPolicy = {
  aggregation: AggregationType;
  dropTimestamp: Scalars['Boolean']['input'];
  interval?: InputMaybe<Scalars['String']['input']>;
  storagePolicy?: InputMaybe<InputStoragePolicy>;
};

export type InputRollupRuleLabelReplace = {
  dstLabelName?: InputMaybe<Scalars['String']['input']>;
  keepLabel?: InputMaybe<Scalars['Boolean']['input']>;
  labelValueRegex?: InputMaybe<Scalars['String']['input']>;
  newLabelValue: Scalars['String']['input'];
  srcLabelName: Scalars['String']['input'];
};

export type InputStoragePolicy = {
  resolution: Scalars['String']['input'];
  retention: Scalars['String']['input'];
};

export type K8sContextDiscoveryInput = {
  deployment?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['Time']['input']>;
  includeEventInference?: InputMaybe<Scalars['Boolean']['input']>;
  includeRelatedResources?: InputMaybe<Scalars['Boolean']['input']>;
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  node?: InputMaybe<Scalars['String']['input']>;
  pod?: InputMaybe<Scalars['String']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['Time']['input']>;
};

export type KeyValueParserInput = {
  delimiter: Scalars['String']['input'];
  pairSeparator: Scalars['String']['input'];
  trimSet?: InputMaybe<Scalars['String']['input']>;
};

export type KnownMetricInput = {
  kind: MetricKind;
  metricName: Scalars['String']['input'];
};

export type LabelFilter = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LabelInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type LabelMatcherInput = {
  name: Scalars['String']['input'];
  /** The operator to use in the filter. Must be "=" or "!=". */
  op: LabelMatcherOp;
  value: Scalars['String']['input'];
};

export enum LabelMatcherOp {
  EQUALS = 'EQUALS',
  NOT_EQUALS = 'NOT_EQUALS',
}

export enum LabelMatcherType {
  EXACT_MATCHER_TYPE = 'EXACT_MATCHER_TYPE',
  NOT_EXACT_MATCHER_TYPE = 'NOT_EXACT_MATCHER_TYPE',
  NOT_REGEXP_MATCHER_TYPE = 'NOT_REGEXP_MATCHER_TYPE',
  REGEXP_MATCHER_TYPE = 'REGEXP_MATCHER_TYPE',
}

export type LabelValuesInput = {
  matcher: Scalars['String']['input'];
};

export type LinkInput = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type ListDocArtifactsInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  keyPrefix: Scalars['String']['input'];
  matchers?: InputMaybe<Array<LabelMatcherInput>>;
  order?: InputMaybe<DocArtifactSortOrder>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type LogAllocationConfigInput = {
  datasetAllocations: Array<InputMaybe<DatasetAllocationInput>>;
  defaultDataset: DefaultDatasetInput;
};

export type LogControlConfigInput = {
  rules: Array<LogControlRuleInput>;
};

export type LogControlRuleDropFieldInput = {
  fieldRegex: Scalars['String']['input'];
  parentPath?: InputMaybe<Scalars['String']['input']>;
};

export type LogControlRuleEmitMetricsInput = {
  counter?: InputMaybe<EmitMetricsCounterInput>;
  dropLog: Scalars['Boolean']['input'];
  gauge?: InputMaybe<EmitMetricsGaugeInput>;
  histogram?: InputMaybe<EmitMetricsHistogramInput>;
  labels: Array<EmitMetricsLabelInput>;
  mode: EmitMetricsMode;
  name: Scalars['String']['input'];
};

export type LogControlRuleInput = {
  dropField?: InputMaybe<LogControlRuleDropFieldInput>;
  emitMetrics?: InputMaybe<LogControlRuleEmitMetricsInput>;
  filter: Scalars['String']['input'];
  mode: LogControlRuleMode;
  name: Scalars['String']['input'];
  replaceField?: InputMaybe<LogControlRuleReplaceFieldInput>;
  sample?: InputMaybe<LogControlRuleSampleInput>;
  type: LogControlRuleType;
};

export enum LogControlRuleMode {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export type LogControlRuleReplaceFieldInput = {
  field: Scalars['String']['input'];
  mappedValue?: InputMaybe<ReplaceFieldMappedValueInput>;
  replaceAll: Scalars['Boolean']['input'];
  replaceMode: ReplaceFieldMode;
  replaceRegex: Scalars['String']['input'];
  staticValue?: InputMaybe<ReplaceFieldStaticValueInput>;
};

export type LogControlRuleSampleInput = {
  rate: Scalars['Float']['input'];
};

export enum LogControlRuleType {
  DROP = 'DROP',
  DROP_FIELD = 'DROP_FIELD',
  EMIT_METRICS = 'EMIT_METRICS',
  REPLACE_FIELD = 'REPLACE_FIELD',
  SAMPLE = 'SAMPLE',
}

export type LogDatasetConfigurationInput = {
  filter: LogSearchFilterInput;
};

export type LogEventsInput = {
  events: Array<AnalyticsEventInput>;
};

export type LogFieldParserInput = {
  destination?: InputMaybe<Scalars['String']['input']>;
  mode: ParserMode;
  parser: LogParserInput;
  source: Scalars['String']['input'];
};

export type LogIngestConfigInput = {
  fieldNormalization?: InputMaybe<FieldNormalizationInput>;
  fieldParsers: Array<LogFieldParserInput>;
  plaintextParsers: Array<PlaintextParserInput>;
};

export enum LogLookupTableErrorDetails {
  INTERNAL_ERROR = 'INTERNAL_ERROR',
  INVALID_FILE = 'INVALID_FILE',
}

export type LogLookupTableInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  filePath: Scalars['String']['input'];
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export enum LogLookupTableStatus {
  ERROR = 'ERROR',
  PENDING = 'PENDING',
  PENDING_DELETION = 'PENDING_DELETION',
  READY = 'READY',
}

export type LogParserInput = {
  keyValueParser?: InputMaybe<KeyValueParserInput>;
  parserType: LogParserType;
  regexParser?: InputMaybe<RegexParserInput>;
};

export enum LogParserType {
  JSON = 'JSON',
  KEY_VALUE = 'KEY_VALUE',
  REGEX = 'REGEX',
}

export type LogSearchFilterInput = {
  query: Scalars['String']['input'];
};

export enum LoggingContractState {
  ACTIVE = 'ACTIVE',
  TERMINATED = 'TERMINATED',
}

export enum ManagedBySource {
  CHRONOCTL = 'CHRONOCTL',
  CHRONOSPHERE = 'CHRONOSPHERE',
  KUBERNETES = 'KUBERNETES',
  SYNC_PROMETHEUS = 'SYNC_PROMETHEUS',
  TERRAFORM = 'TERRAFORM',
  UI = 'UI',
  UNKNOWN = 'UNKNOWN',
}

export type MappingLabelInput = {
  /** The name mappings for the mapping label. */
  nameMappings?: InputMaybe<Array<NameMappingInput>>;
  /**
   * These value mappings apply to the whole mapping label.
   * If there's no name_mappings, these value mappings apply to the label that exists on the metric.
   */
  valueMappings?: InputMaybe<Array<DerivedLabelValueMappingInput>>;
};

export enum MappingRuleMode {
  ENABLED = 'ENABLED',
  PREVIEW = 'PREVIEW',
}

export enum Match {
  INVALID = 'INVALID',
  RULE = 'RULE',
}

export type MetricDDXRequest = {
  addFilters?: InputMaybe<Array<InputMaybe<NewLabelMatcher>>>;
  endTime: Scalars['String']['input'];
  query: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type MetricDiscoveryMetadataInput = {
  knownMetrics?: InputMaybe<Array<KnownMetricInput>>;
  rpcMetadata?: InputMaybe<RPCInput>;
};

export type MetricDiscoveryOverrideInput = {
  expr?: InputMaybe<Scalars['String']['input']>;
  markerComponent?: InputMaybe<Scalars['Boolean']['input']>;
  objectLabel: Scalars['String']['input'];
  objectMappingLabel: Scalars['String']['input'];
  objectMappingLabelTransform?: InputMaybe<TransformInput>;
  target?: InputMaybe<MetricDiscoveryTargetInput>;
  uniqueLabel: Scalars['String']['input'];
};

export type MetricDiscoveryTargetInput = {
  filters: Array<DerivedLabelFilterInput>;
};

export enum MetricKind {
  FAILURE_METRIC = 'FAILURE_METRIC',
  LATENCY_HISTOGRAM_BUCKET = 'LATENCY_HISTOGRAM_BUCKET',
  LATENCY_HISTOGRAM_COUNT = 'LATENCY_HISTOGRAM_COUNT',
  SUCCESS_METRIC = 'SUCCESS_METRIC',
  TOTAL_METRIC = 'TOTAL_METRIC',
  UNKNOWN = 'UNKNOWN',
}

export type MetricLabelInput = {
  /** A constructed label creates a label where there previously exists none. */
  constructedLabel?: InputMaybe<ConstructedLabelInput>;
  /** A mapping label is a kind of derived label that is generated by pulling values from some other label on the timeseries. */
  mappingLabel?: InputMaybe<MappingLabelInput>;
};

export type MetricMetadataGeneratedInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  generatedBy?: InputMaybe<Scalars['String']['input']>;
  metricName: Scalars['String']['input'];
};

export type MetricMetadataUserInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  metricName: Scalars['String']['input'];
};

export enum MetricType {
  COUNTER = 'COUNTER',
  CUMULATIVE_COUNTER = 'CUMULATIVE_COUNTER',
  CUMULATIVE_EXPONENTIAL_HISTOGRAM = 'CUMULATIVE_EXPONENTIAL_HISTOGRAM',
  DELTA = 'DELTA',
  DELTA_COUNTER = 'DELTA_COUNTER',
  DELTA_EXPONENTIAL_HISTOGRAM = 'DELTA_EXPONENTIAL_HISTOGRAM',
  DISTRIBUTION = 'DISTRIBUTION',
  GAUGE = 'GAUGE',
  MEASUREMENT = 'MEASUREMENT',
  METRIC_TYPE_INVALID = 'METRIC_TYPE_INVALID',
}

export type MetricsDiscoveryInput = {
  /** A Prom expression (usually a metric name) which generates results that directly or indirectly can enumerate services. */
  expr: Scalars['String']['input'];
  /** Indicates that this component is used only for discovery and does not modify lens_service. */
  markerComponent?: InputMaybe<Scalars['Boolean']['input']>;
  metricMetadata?: InputMaybe<MetricDiscoveryMetadataInput>;
  /** The name of a label in the results from the expression that directly enumerates service names. */
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of a label in the results from the expression whose values can be used to map to a service name
   * that was discovered by the "global configuration".
   */
  objectMappingLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * An optional transformation that is applied to values of `objectMappingLabel` before the values are used to search
   * the global configuration for proper service names.
   */
  objectMappingLabelTransform?: InputMaybe<TransformInput>;
  /** Configures which subset of the expression results the discovery should apply to. */
  target: MetricDiscoveryTargetInput;
  /** The name of a label in the results from the expression whose values uniquely correspond to services. */
  uniqueLabel?: InputMaybe<Scalars['String']['input']>;
};

export type MigrateGrafanaDashboardInput = {
  nativeDashboardConfig: Scalars['JSONObject']['input'];
  /** The grafana dashboard slug. The native dashboard created will have the same slug. */
  slug: Scalars['String']['input'];
};

export type MonitorInformation = {
  /** The specified severity. Valid options include: ['', 'FIRING', 'CRITICAL']. */
  severity: Scalars['String']['input'];
  /** The selected monitor signal if one is selected. */
  signal: Array<NewAlertRuleLabel>;
  /** The monitor slug. */
  slug: Scalars['String']['input'];
};

export type MonitorsV2Filters = {
  /** Filter duplicate results. if true response times may be faster but some monitors may be returned multiple times. */
  allowDuplicates?: InputMaybe<Scalars['Boolean']['input']>;
  collectionRefs?: InputMaybe<Array<CollectionRef>>;
  collectionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set to true, filters to only monitors marked as favorite by the calling user. */
  favoritesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If true, search for dashboards that are owned by the filtered collections as well as
   * those linked to the filtered collections.
   */
  includeLinkedCollections?: InputMaybe<Scalars['Boolean']['input']>;
  /** Specify which AlertStates to include in the response. If none are specified, all states are included. */
  includeStates?: InputMaybe<Array<AlertState>>;
  /** If set, only monitors whose name contains the specified string will be returned. */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** If set, only monitors that use the provided notification policies will be returned. */
  notificationPolicySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If set, only monitors that are in the customer namespace will be returned. */
  onlyCustomerManaged?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set, only monitors with the specified slugs will be returned. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum MutingRuleColumn {
  ENDS_AT = 'ENDS_AT',
  STARTS_AT = 'STARTS_AT',
}

export type MutingRuleOrdering = {
  column: MutingRuleColumn;
  order: Ordering;
};

export type MutingRulePageFilters = {
  /**
   * Specifies which states (pending, active, expired) muting rules to include in the response.
   * If none are specfied, all states are included in the response.
   */
  includeStates: Array<MutingRuleState>;
  /** If set, only muting rules whose name contains the specified string will be returned. */
  nameContains?: InputMaybe<Scalars['String']['input']>;
  /** Specifies the order in which muting rules should be sorted in. Only one ordering column is supported. */
  order: Array<MutingRuleOrdering>;
  /** If set, only muting rules whose payload contains the specified string will be returned. */
  payloadContains?: InputMaybe<Scalars['String']['input']>;
};

export enum MutingRuleState {
  ACTIVE = 'ACTIVE',
  EXPIRED = 'EXPIRED',
  PENDING = 'PENDING',
}

export type NameMappingInput = {
  /** The filters that define the source label. */
  filters?: InputMaybe<Array<DerivedLabelFilterInput>>;
  /** The actual label ingested on the time series. */
  sourceLabel: Scalars['String']['input'];
  /** The value mappings for the name mapping. */
  valueMappings?: InputMaybe<Array<DerivedLabelValueMappingInput>>;
};

export type NamedStringNormalizationInput = {
  normalization: StringNormalizationInput;
  target: Scalars['String']['input'];
};

export type NewAlertNotificationPolicy = {
  name?: InputMaybe<Scalars['String']['input']>;
  routes?: InputMaybe<NewNotificationRoutes>;
  rules?: InputMaybe<Array<NewNotificationRule>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  teamSlug?: InputMaybe<Scalars['String']['input']>;
};

export type NewAlertReceiver = {
  email?: InputMaybe<Array<NewAlertReceiverEmailConfig>>;
  name: Scalars['String']['input'];
  opsgenie?: InputMaybe<Array<NewAlertReceiverOpsGenieConfig>>;
  pagerduty?: InputMaybe<Array<NewAlertReceiverPagerdutyConfig>>;
  slack?: InputMaybe<Array<NewAlertReceiverSlackConfig>>;
  victorOps?: InputMaybe<Array<NewAlertReceiverVictorOpsConfig>>;
  webhook?: InputMaybe<Array<NewAlertReceiverWebhookConfig>>;
};

export type NewAlertReceiverEmailConfig = {
  baseConfig?: InputMaybe<NewAlertReceiverNotifierBaseConfig>;
  html?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export type NewAlertReceiverHTTPConfig = {
  basicAuth?: InputMaybe<NewAlertReceiverHTTPConfigBasicAuth>;
  bearerToken?: InputMaybe<Scalars['String']['input']>;
  proxyURL?: InputMaybe<Scalars['String']['input']>;
  tlsConfig?: InputMaybe<NewAlertReceiverHTTPConfigTLSConfig>;
};

export type NewAlertReceiverHTTPConfigBasicAuth = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type NewAlertReceiverHTTPConfigTLSConfig = {
  insecureSkipVerify: Scalars['Boolean']['input'];
};

export type NewAlertReceiverNotifierBaseConfig = {
  sendResolved: Scalars['Boolean']['input'];
};

export type NewAlertReceiverOpsGenieConfig = {
  apiKey: Scalars['String']['input'];
  apiURL: Scalars['String']['input'];
  baseConfig?: InputMaybe<NewAlertReceiverNotifierBaseConfig>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  httpConfig?: InputMaybe<NewAlertReceiverHTTPConfig>;
  message?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  responders?: InputMaybe<Array<NewAlertReceiverOpsGenieConfigResponder>>;
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
};

export type NewAlertReceiverOpsGenieConfigResponder = {
  responderType: ResponderType;
  responderValue: Scalars['String']['input'];
  responseType: ResponseType;
};

export type NewAlertReceiverPagerdutyConfig = {
  baseConfig?: InputMaybe<NewAlertReceiverNotifierBaseConfig>;
  class?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  clientURL?: InputMaybe<Scalars['String']['input']>;
  component?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  httpConfig?: InputMaybe<NewAlertReceiverHTTPConfig>;
  images?: InputMaybe<Array<NewAlertReceiverPagerdutyConfigImage>>;
  links?: InputMaybe<Array<NewAlertReceiverPagerdutyConfigLink>>;
  serviceKey?: InputMaybe<Scalars['String']['input']>;
  severity?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type NewAlertReceiverPagerdutyConfigImage = {
  alt: Scalars['String']['input'];
  href: Scalars['String']['input'];
  src: Scalars['String']['input'];
};

export type NewAlertReceiverPagerdutyConfigLink = {
  href: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type NewAlertReceiverSlackConfig = {
  actions?: InputMaybe<Array<NewAlertReceiverSlackConfigAction>>;
  apiURL?: InputMaybe<Scalars['String']['input']>;
  baseConfig?: InputMaybe<NewAlertReceiverNotifierBaseConfig>;
  callbackID?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  fallback?: InputMaybe<Scalars['String']['input']>;
  fields?: InputMaybe<Array<NewAlertReceiverSlackConfigField>>;
  footer?: InputMaybe<Scalars['String']['input']>;
  httpConfig?: InputMaybe<NewAlertReceiverHTTPConfig>;
  iconEmoji?: InputMaybe<Scalars['String']['input']>;
  iconURL?: InputMaybe<Scalars['String']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  linkNames?: InputMaybe<Scalars['Boolean']['input']>;
  mrkdwnIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pretext?: InputMaybe<Scalars['String']['input']>;
  shortFields?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  thumbURL?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleLink?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type NewAlertReceiverSlackConfigAction = {
  confirm?: InputMaybe<NewAlertReceiverSlackConfigConfirmField>;
  name: Scalars['String']['input'];
  style?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type NewAlertReceiverSlackConfigConfirmField = {
  dismissText: Scalars['String']['input'];
  okText: Scalars['String']['input'];
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type NewAlertReceiverSlackConfigField = {
  short: Scalars['Boolean']['input'];
  title: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type NewAlertReceiverVictorOpsConfig = {
  apiKey: Scalars['String']['input'];
  apiURL: Scalars['String']['input'];
  baseConfig?: InputMaybe<NewAlertReceiverNotifierBaseConfig>;
  customFields?: InputMaybe<Scalars['String']['input']>;
  entityDisplayName?: InputMaybe<Scalars['String']['input']>;
  httpConfig?: InputMaybe<NewAlertReceiverHTTPConfig>;
  messageType?: InputMaybe<Scalars['String']['input']>;
  monitoringTool?: InputMaybe<Scalars['String']['input']>;
  routingKey?: InputMaybe<Scalars['String']['input']>;
  stateMessage?: InputMaybe<Scalars['String']['input']>;
};

export type NewAlertReceiverWebhookConfig = {
  baseConfig?: InputMaybe<NewAlertReceiverNotifierBaseConfig>;
  httpConfig?: InputMaybe<NewAlertReceiverHTTPConfig>;
  url: Scalars['String']['input'];
};

export type NewAlertRouteMatcher = {
  name: Scalars['String']['input'];
  type: AlertRouteMatcherType;
  value: Scalars['String']['input'];
};

export type NewAlertRuleAnnotation = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type NewAlertRuleLabel = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type NewConditionOverride = {
  conditions: Array<NewSeverityCondition>;
  matchers?: InputMaybe<Array<NewAlertRouteMatcher>>;
};

export type NewDefaultResourcePool = {
  /** @deprecated DefaultPool allocation is deprecated and no longer must be specified. When unspecified, allocation is derived as the remaining amount from the sum across pools. */
  allocation?: InputMaybe<NewResourcePoolAllocation>;
  priorities?: InputMaybe<NewResourcePoolHighLowPriorities>;
  priorityThresholds?: InputMaybe<Array<NewResourcePoolAllocationThresholds>>;
};

export type NewDropRule = {
  dropNanValue?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Array<LabelFilter>;
  mode: DropRuleMode;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  valueBasedDrop?: InputMaybe<InputDropRuleValueBasedDrop>;
};

export type NewLabelMatcher = {
  name: Scalars['String']['input'];
  type: LabelMatcherType;
  value: Scalars['String']['input'];
};

export type NewMappingRule = {
  aggregationPolicy?: InputMaybe<InputMappingRuleAggregationPolicy>;
  drop: Scalars['Boolean']['input'];
  filters: Array<LabelFilter>;
  mode: MappingRuleMode;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type NewMonitor = {
  annotations: Array<NewAlertRuleAnnotation>;
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
  collectionType?: InputMaybe<CollectionType>;
  labels: Array<NewAlertRuleLabel>;
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  spec: NewMonitorSpec;
};

export type NewMonitorCondition = {
  op: ThresholdOp;
  resolveSustain?: InputMaybe<Scalars['String']['input']>;
  sustain: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type NewMonitorQuery = {
  queryDatasource: DatasourceType;
  queryExpression: Scalars['String']['input'];
};

export type NewMonitorSpec = {
  interval?: InputMaybe<Scalars['String']['input']>;
  notificationPolicySlug?: InputMaybe<Scalars['String']['input']>;
  query: NewMonitorQuery;
  schedule?: InputMaybe<NewSchedule>;
  seriesConditions: NewSeriesConditions;
  signalGrouping: NewSignalGrouping;
};

export type NewMutingRule = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /**
   * EndsAt is either a RFC3339 formatted string or `now`. In the latter case the current time is used
   * and the muting rule is immediately expired.
   */
  endsAt: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  matchers: Array<NewLabelMatcher>;
  name?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  /** StarsAt is a RFC3339 formatted string. */
  startsAt: Scalars['String']['input'];
};

export type NewNotificationRoutes = {
  defaults: Array<NewNotifiersBySeverity>;
  overrides: Array<NewNotificationRoutesOverride>;
};

export type NewNotificationRoutesOverride = {
  matchers: Array<NewAlertRouteMatcher>;
  notifiers: Array<NewNotifiersBySeverity>;
};

export type NewNotificationRule = {
  name: Scalars['String']['input'];
  /** A list of receiver names. */
  receivers: Array<Scalars['String']['input']>;
};

export type NewNotifier = {
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type NewNotifiersBySeverity = {
  groupBy?: InputMaybe<Array<Scalars['String']['input']>>;
  notifierList: Array<NewNotifier>;
  repeatInterval?: InputMaybe<Scalars['String']['input']>;
  severity: Scalars['String']['input'];
};

export type NewRecordingRule = {
  executionGroup?: InputMaybe<Scalars['String']['input']>;
  expr: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  labels: Array<NewRecordingRuleLabel>;
  name: Scalars['String']['input'];
};

export type NewRecordingRuleLabel = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type NewResourcePool = {
  allocation: NewResourcePoolAllocation;
  matchRules?: InputMaybe<Array<LabelFilter>>;
  matchType: Match;
  name: Scalars['String']['input'];
  priorities?: InputMaybe<NewResourcePoolHighLowPriorities>;
};

export type NewResourcePoolAllocation = {
  fixedValues?: InputMaybe<Array<NewResourcePoolAllocationFixedValue>>;
  percentOfLicense?: InputMaybe<Scalars['Float']['input']>;
  priorityThresholds?: InputMaybe<Array<NewResourcePoolAllocationThresholds>>;
};

export type NewResourcePoolAllocationFixedValue = {
  license: ResourcePoolLicense;
  value: Scalars['Int']['input'];
};

export type NewResourcePoolAllocationThreshold = {
  fixedValue?: InputMaybe<Scalars['Int']['input']>;
  percentOfPoolAllocation?: InputMaybe<Scalars['Float']['input']>;
};

export type NewResourcePoolAllocationThresholds = {
  allPriorities?: InputMaybe<NewResourcePoolAllocationThreshold>;
  defaultAndLowPriority?: InputMaybe<NewResourcePoolAllocationThreshold>;
  license: ResourcePoolLicense;
  lowPriority?: InputMaybe<NewResourcePoolAllocationThreshold>;
};

export type NewResourcePoolHighLowPriorities = {
  highPriorityMatchRules?: InputMaybe<Array<LabelFilter>>;
  lowPriorityMatchRules?: InputMaybe<Array<LabelFilter>>;
};

export type NewResourcePools = {
  defaultPool?: InputMaybe<NewDefaultResourcePool>;
  pools?: InputMaybe<Array<NewResourcePool>>;
};

export type NewRollupRule = {
  addMetricTypeLabel: Scalars['Boolean']['input'];
  aggregationType: AggregationType;
  dropRaw: Scalars['Boolean']['input'];
  expansiveMatch: Scalars['Boolean']['input'];
  filters: Array<LabelFilter>;
  graphiteLabelPolicy?: InputMaybe<InputGraphiteLabelPolicy>;
  interval?: InputMaybe<Scalars['String']['input']>;
  labelPolicy?: InputMaybe<InputLabelPolicy>;
  labelReplace?: InputMaybe<Array<InputRollupRuleLabelReplace>>;
  metricName: Scalars['String']['input'];
  metricType: MetricType;
  mode: RollupRuleMode;
  name: Scalars['String']['input'];
  skipOnConflict?: InputMaybe<Scalars['Boolean']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  storagePolicy?: InputMaybe<InputStoragePolicy>;
};

export type NewSchedule = {
  timezone: Scalars['String']['input'];
  /**
   * Keyed by time.Weekday index in array (sunday -> saturday).
   * Entire field can be null to indicate no available ranges.
   * Individual days of the week can be null to indicate no ranges on that day.
   */
  weeklySchedule?: InputMaybe<Array<InputMaybe<NewScheduleDay>>>;
};

export type NewScheduleDay = {
  ranges: Array<NewTimeRange>;
};

export type NewSearchHistory = {
  name?: InputMaybe<Scalars['String']['input']>;
  saved?: InputMaybe<Scalars['Boolean']['input']>;
  search: SearchHistoryQueryInput;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  type: SearchType;
};

export type NewSeriesConditions = {
  defaults: Array<NewSeverityCondition>;
  overrides: Array<NewConditionOverride>;
};

export type NewSeverityCondition = {
  conditionLevel: ConditionLevel;
  conditions: Array<NewMonitorCondition>;
};

export type NewSignalGrouping = {
  labelNames: Array<Scalars['String']['input']>;
  signalPerSeries: Scalars['Boolean']['input'];
};

export type NewTeam = {
  addRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated. Use `roles` instead. Only one of `roles` and `isSysAdmin` may be set. */
  isSysAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type NewThreadInput = {
  target: TargetInput;
  text: Scalars['String']['input'];
};

export type NewTimeRange = {
  end: Scalars['String']['input'];
  start: Scalars['String']['input'];
};

/**
 * Queries for notification policies that are in-use by a set of monitors. The filters specify the set of monitors, and the
 * unique ordered notification policies used by those monitors are returned.
 * Repeated fields are ORed together and multiple fields are ANDed.
 */
export type NotificationPoliciesInUseFilters = {
  /** Get policies of monitors within any of the given collections. */
  collectionSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /**  Get policies of monitors by specific monitor slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Get policies used by a monitor within any collection of the given teams. */
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NotificationPoliciesPageFilters = {
  nameContains?: InputMaybe<Scalars['String']['input']>;
  onlyCustomerManaged?: InputMaybe<Scalars['Boolean']['input']>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum NumericFilterComparisonType {
  EQUAL = 'EQUAL',
  GREATER_THAN = 'GREATER_THAN',
  GREATER_THAN_OR_EQUAL = 'GREATER_THAN_OR_EQUAL',
  LESS_THAN = 'LESS_THAN',
  LESS_THAN_OR_EQUAL = 'LESS_THAN_OR_EQUAL',
  NOT_EQUAL = 'NOT_EQUAL',
  UNKNOWN = 'UNKNOWN',
}

export type NumericFilterInput = {
  comparison: NumericFilterComparisonType;
  value: Scalars['Float']['input'];
};

export enum ObjectMergeRuleAction {
  DROP = 'DROP',
  KEEP = 'KEEP',
  REPLACE_KEY = 'REPLACE_KEY',
  SUPPRESS = 'SUPPRESS',
  UNKNOWN = 'UNKNOWN',
}

export type ObjectMergeRuleInput = {
  action: ObjectMergeRuleAction;
  description: Scalars['String']['input'];
  regex?: InputMaybe<Scalars['String']['input']>;
  replacement?: InputMaybe<Scalars['String']['input']>;
  separator?: InputMaybe<Scalars['String']['input']>;
  sourceLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<ObjectMergeRuleStatus>;
  suppressionRule?: InputMaybe<SuppressionMergeRuleInput>;
};

export enum ObjectMergeRuleStatus {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export enum Ordering {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum OriginalMetricSource {
  DERIVED_METRIC = 'DERIVED_METRIC',
  RECORDING_RULE = 'RECORDING_RULE',
  UNKNOWN_SOURCE = 'UNKNOWN_SOURCE',
}

export type PageDataInput = {
  pageName: Scalars['String']['input'];
  pageReferrer?: InputMaybe<Scalars['String']['input']>;
  pageTitle: Scalars['String']['input'];
  pageUrl: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
};

export enum ParserMode {
  DISABLED = 'DISABLED',
  ENABLED = 'ENABLED',
}

export enum PermissionAction {
  READ = 'READ',
  READWRITE = 'READWRITE',
  UNKNOWN = 'UNKNOWN',
  WRITE = 'WRITE',
}

export type PlaintextParserInput = {
  keepOriginal?: InputMaybe<Scalars['Boolean']['input']>;
  mode: ParserMode;
  name: Scalars['String']['input'];
  parser: LogParserInput;
};

export type PresentationConfigsInput = {
  overrides: Array<ComponentPresentationOverrideInput>;
};

export type PresentationDashboardInput = {
  /**
   *  Input Dashboard JSON along with the additional fields used to generate the component.
   * Can be used to edit the component
   */
  inputJSON?: InputMaybe<Scalars['JSONObject']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  serviceTemplateVar?: InputMaybe<Scalars['String']['input']>;
};

export type PresentationEligibilityInput = {
  allowedServiceSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  ignoredServiceSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  requiredDiscoverySlugs: Array<Scalars['String']['input']>;
  withoutDiscoverySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PresentationEventsInput = {
  /**
   * Event JSONs to render on panels and more details views.
   *
   * This field is only available if the ComponentPresentationType is "EVENTS"
   */
  eventJSONs?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
};

export type PutDocArtifactInput = {
  blob: Scalars['JSONObject']['input'];
  /**
   * Key for the artifact.
   *
   * Must be unique or will overwrite existing artifact with the same key.
   * You can prefix the key with the special prefix "@user/" to make it private to the current user.
   * Private artifacts can only be written and read by the current user.
   */
  key: Scalars['String']['input'];
  labels?: InputMaybe<Array<LabelInput>>;
};

export type QueryDowntimesRequest = {
  activeOnly: Scalars['Boolean']['input'];
};

export type RPCInput = {
  endpointLabel: Scalars['String']['input'];
  errorCodes?: InputMaybe<Array<ErrorCodeDefInput>>;
  errorTypeLabel: Scalars['String']['input'];
};

export type ReadPresentationConfigInput = {
  slug: Scalars['String']['input'];
};

export type RecordingRulesFilters = {
  /**
   * If set, only rules with an executionGroup that contains this value will be returned. For legacy support, we will
   * search the attached collection slug (if there is one) instead. For rules with only execution group set, that is the only
   * field that is searched.
   */
  executionGroupContains?: InputMaybe<Scalars['String']['input']>;
  /** If set, only rules whose name field contains the string provided will be returned. The match is case insensitive */
  nameContains?: InputMaybe<Scalars['String']['input']>;
};

export type RegexParserInput = {
  regex: Scalars['String']['input'];
};

export type RelativeTimeFilterInput = {
  endRelativeOffsetSeconds?: InputMaybe<Scalars['Int']['input']>;
  startRelativeOffsetSeconds: Scalars['Int']['input'];
};

export type RemoveUserFromTeam = {
  teamID: Scalars['ID']['input'];
  userID: Scalars['ID']['input'];
};

export type ReplaceFieldMappedValueInput = {
  defaultValue: Scalars['String']['input'];
  pairs: Array<ReplaceFieldMappedValuePairInput>;
  useDefault: Scalars['Boolean']['input'];
};

export type ReplaceFieldMappedValuePairInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum ReplaceFieldMode {
  HASH = 'HASH',
  MAPPED_VALUE = 'MAPPED_VALUE',
  STATIC_VALUE = 'STATIC_VALUE',
}

export type ReplaceFieldStaticValueInput = {
  value: Scalars['String']['input'];
};

export type ResendSignupInviteInput = {
  token: Scalars['String']['input'];
};

export enum ResourcePoolLicense {
  LICENSE_INVALID = 'LICENSE_INVALID',
  MATCHED_WRITES_HISTOGRAM = 'MATCHED_WRITES_HISTOGRAM',
  MATCHED_WRITES_STANDARD = 'MATCHED_WRITES_STANDARD',
  PERSISTED_CARDINALITY_HISTOGRAM = 'PERSISTED_CARDINALITY_HISTOGRAM',
  PERSISTED_CARDINALITY_STANDARD = 'PERSISTED_CARDINALITY_STANDARD',
  PERSISTED_WRITES_HISTOGRAM = 'PERSISTED_WRITES_HISTOGRAM',
  PERSISTED_WRITES_STANDARD = 'PERSISTED_WRITES_STANDARD',
}

export enum ResponderType {
  ID = 'ID',
  NAME = 'NAME',
  UNKNOWN = 'UNKNOWN',
  USERNAME = 'USERNAME',
}

export enum ResponseType {
  ESCALATION = 'ESCALATION',
  SCHEDULE = 'SCHEDULE',
  TEAM = 'TEAM',
  UNKNOWN = 'UNKNOWN',
  USER = 'USER',
}

export type RestoreEntityVersion = {
  id: Scalars['String']['input'];
};

export enum RollupRuleMode {
  ENABLED = 'ENABLED',
  PREVIEW = 'PREVIEW',
}

export enum RuleEvaluationErrorCode {
  CONFLICTING_MONITOR_LABELS = 'CONFLICTING_MONITOR_LABELS',
  CONFLICTING_RECORDING_LABELS = 'CONFLICTING_RECORDING_LABELS',
  DUPLICATE_SERIES = 'DUPLICATE_SERIES',
  INTERNAL = 'INTERNAL',
  INVALID = 'INVALID',
  LICENSE_EXCEEDED = 'LICENSE_EXCEEDED',
  RESOURCE_EXHAUSTED = 'RESOURCE_EXHAUSTED',
  TEMPLATE = 'TEMPLATE',
  TIMEOUT = 'TIMEOUT',
}

export enum RuleEvaluationRuleType {
  ALERTING = 'ALERTING',
  INVALID = 'INVALID',
  RECORDING = 'RECORDING',
}

export enum RuleEvaluationWindow {
  INVALID = 'INVALID',
  WINDOW_5M = 'WINDOW_5M',
  WINDOW_30M = 'WINDOW_30M',
}

export type SLIEndpointAvailabilityInput = {
  /** @deprecated replaced this with the identical field on the SLI */
  additionalPromFilters?: InputMaybe<Array<NewLabelMatcher>>;
  endpointsMonitored?: InputMaybe<Array<Scalars['String']['input']>>;
  errorCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  successCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SLIEndpointLatencyInput = {
  /** @deprecated replaced this with the identical field on the SLI */
  additionalPromFilters?: InputMaybe<Array<NewLabelMatcher>>;
  endpointsMonitored?: InputMaybe<Array<Scalars['String']['input']>>;
  latencyBucket: Scalars['String']['input'];
};

export type SLIInput = {
  additionalPromFilters?: InputMaybe<Array<NewLabelMatcher>>;
  customDimensionLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  rawQueries?: InputMaybe<SLIQueriesInput>;
  templateData?: InputMaybe<SLITemplateDataInput>;
  timeSliceQueries?: InputMaybe<SLITimesliceQueriesInput>;
};

export type SLIQueriesInput = {
  badQuery?: InputMaybe<Scalars['String']['input']>;
  goodQuery?: InputMaybe<Scalars['String']['input']>;
  totalQuery: Scalars['String']['input'];
};

export type SLITemplateDataInput = {
  componentDiscoverySlug?: InputMaybe<Scalars['String']['input']>;
  endpointAvailability?: InputMaybe<SLIEndpointAvailabilityInput>;
  endpointLabel: Scalars['String']['input'];
  endpointLatency?: InputMaybe<SLIEndpointLatencyInput>;
  sourceService: CollectionRef;
  trackLensService?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SLITimesliceConditionInput = {
  op: ThresholdOp;
  value: Scalars['Float']['input'];
};

export type SLITimesliceQueriesInput = {
  condition?: InputMaybe<SLITimesliceConditionInput>;
  query?: InputMaybe<Scalars['String']['input']>;
  sliceSize?: InputMaybe<TimesliceSize>;
};

export type SLOBurnRateDefinitionInput = {
  budget: Scalars['Float']['input'];
  labels?: InputMaybe<Array<LabelInput>>;
  severity?: InputMaybe<ConditionLevel>;
  window: Scalars['String']['input'];
};

export type SLODefinitionInput = {
  burnRateAlertingConfig?: InputMaybe<Array<SLOBurnRateDefinitionInput>>;
  enableBurnRateAlerting?: InputMaybe<Scalars['Boolean']['input']>;
  objective: Scalars['Float']['input'];
  timeWindow?: InputMaybe<SLOReportingWindowInput>;
};

export type SLOListFilterInput = {
  collectionRefs?: InputMaybe<Array<CollectionRef>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  notificationPolicySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SLOQueriesInput = {
  slo: UpdateSLOInput;
};

export type SLOReportingWindowInput = {
  duration: Scalars['String']['input'];
};

export enum SLOType {
  ENDPOINT_AVAILABILITY = 'ENDPOINT_AVAILABILITY',
  LATENCY = 'LATENCY',
}

/** Input used to save a collection homepage. */
export type SaveCollectionHomepageInput = {
  collectionSlug: Scalars['String']['input'];
  links?: InputMaybe<Array<InputMaybe<LinkInput>>>;
};

export type SaveDashboardInput = {
  /** Collection containing this dashboard */
  collectionSlug: Scalars['String']['input'];
  /**
   * Type of the collection containing the dashboard. Optional for backwards compatibility. Defaults to SIMPLE if not
   * specified.
   */
  collectionType?: InputMaybe<CollectionType>;
  dashboardJSON: Scalars['JSONObject']['input'];
  labels?: InputMaybe<Array<LabelInput>>;
  /** Dashboard name. Must be unique within a collection. */
  name: Scalars['String']['input'];
  /** Slug of dashboard to create or update. A new dashboard will be created if this is unset or empty. */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** Input used to save a team homepage. */
export type SaveTeamHomepageInput = {
  links?: InputMaybe<Array<InputMaybe<LinkInput>>>;
  teamSlug: Scalars['String']['input'];
};

export enum SavedTraceSearchColumn {
  CREATED_AT = 'CREATED_AT',
  NAME = 'NAME',
}

export type SavedTraceSearchOrdering = {
  column: SavedTraceSearchColumn;
  order: Ordering;
};

export type SavedTraceSearchQueryInput = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  createdByContains?: InputMaybe<Scalars['String']['input']>;
  createdByStartsWith?: InputMaybe<Scalars['String']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<SavedTraceSearchOrdering>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum ScalingDirection {
  DOWN = 'DOWN',
  UP = 'UP',
}

export type ScopeFilterInput = {
  spanScopes?: InputMaybe<Array<SpanFilterInput>>;
};

export type SearchHistoryQueryInput = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  query: Scalars['String']['input'];
  summaryFields?: InputMaybe<Array<Scalars['String']['input']>>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchQuery = {
  /** Weight given to embedding results vs text search results (0.0 to 1.0). Higher values give more weight to embeddings. Defaults to 0.3. */
  embeddingWeight?: InputMaybe<Scalars['Float']['input']>;
  /** A list of entity kinds to search for. If not set, all kinds are matched. */
  kindFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Maximum embedding distance to include in results (0.0 to 1.0). Lower values are better matches. Defaults to 0.8. */
  maxDistance?: InputMaybe<Scalars['Float']['input']>;
  /** Maximum number of results to return. Defaults to 25 if not set. */
  maxResults?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum confidence score to include in results (0.0 to 1.0). Higher values mean more confident matches. Defaults to 0.0. */
  minConfidence?: InputMaybe<Scalars['Float']['input']>;
  /** The string to search for */
  query?: InputMaybe<Scalars['String']['input']>;
  /** If true, also search within additional fields like dashboard queries. Defaults to false. */
  searchEntityBodies?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, include embedding-based semantic search in results. Defaults to false. */
  useEmbeddings?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SearchType {
  DATAQUERY = 'DATAQUERY',
  INVALID = 'INVALID',
  LOGGING = 'LOGGING',
  TIMELINE = 'TIMELINE',
}

export type ServiceToTracingServiceAttributeInput = {
  serviceDerivedNames: Array<Scalars['String']['input']>;
};

export type ServicesFilter = {
  discoverySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ServicesInput = {
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ShortenMessageRequest = {
  message: Scalars['String']['input'];
};

export type SpanFilterInput = {
  duration?: InputMaybe<DurationFilterInput>;
  error?: InputMaybe<BoolFilterInput>;
  inCriticalPath?: InputMaybe<BoolFilterInput>;
  isRootSpan?: InputMaybe<BoolFilterInput>;
  leafError?: InputMaybe<BoolFilterInput>;
  matchType?: InputMaybe<SpanFilterMatchType>;
  operation?: InputMaybe<StringFilterInput>;
  parentOperation?: InputMaybe<StringFilterInput>;
  parentService?: InputMaybe<StringFilterInput>;
  service?: InputMaybe<StringFilterInput>;
  spanCount?: InputMaybe<CountFilterInput>;
  tags?: InputMaybe<Array<TagFilterInput>>;
};

export enum SpanFilterMatchType {
  EXCLUDE = 'EXCLUDE',
  INCLUDE = 'INCLUDE',
  UNKNOWN = 'UNKNOWN',
}

export type StringFilterInput = {
  inValues?: InputMaybe<Array<Scalars['String']['input']>>;
  match: StringFilterMatchType;
  value: Scalars['String']['input'];
};

export enum StringFilterMatchType {
  EXACT = 'EXACT',
  EXACT_NEGATION = 'EXACT_NEGATION',
  IN = 'IN',
  NOT_IN = 'NOT_IN',
  REGEX = 'REGEX',
  REGEX_NEGATION = 'REGEX_NEGATION',
  UNKNOWN = 'UNKNOWN',
}

export type StringNormalizationInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  sanitizePatterns?: InputMaybe<Array<Scalars['String']['input']>>;
  source: Array<Scalars['String']['input']>;
  valueMap?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitChangeRequestInput = {
  message?: InputMaybe<Scalars['String']['input']>;
  requestType: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type SuppressionMergeRuleInput = {
  /** @deprecated Prefer DiscoveryConfigsInput.SuppressionExemptServices instead */
  exceptionServiceNames?: InputMaybe<Array<Scalars['String']['input']>>;
  suppressedDiscoveryComponentSlug: Scalars['String']['input'];
};

export type TagFilterInput = {
  key: Scalars['String']['input'];
  numericValue?: InputMaybe<NumericFilterInput>;
  value?: InputMaybe<StringFilterInput>;
};

export type TargetInput = {
  reference: Scalars['String']['input'];
  type: TargetType;
};

export enum TargetType {
  AGGREGATION_RULE = 'AGGREGATION_RULE',
  ALERT = 'ALERT',
  CHANGE_EVENT = 'CHANGE_EVENT',
  DROP_RULE = 'DROP_RULE',
  METRIC_LABEL = 'METRIC_LABEL',
  METRIC_NAME = 'METRIC_NAME',
  MONITOR = 'MONITOR',
  RECORDING_RULE = 'RECORDING_RULE',
  TESTING = 'TESTING',
  UNKNOWN = 'UNKNOWN',
}

export type TargetsListInput = {
  targets: Array<TargetInput>;
};

export type TemplateInput = {
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  value: TemplateValueInput;
};

export type TemplateValueInput = {
  labelValues: LabelValuesInput;
};

export type ThreadsListInput = {
  target: TargetInput;
};

export enum ThresholdOp {
  EQ = 'EQ',
  EXISTS = 'EXISTS',
  GEQ = 'GEQ',
  GT = 'GT',
  INVALID = 'INVALID',
  LEQ = 'LEQ',
  LT = 'LT',
  NEQ = 'NEQ',
  NOT_EXISTS = 'NOT_EXISTS',
}

export type TimeFilterInput = {
  between?: InputMaybe<BetweenTimeFilterInput>;
  close?: InputMaybe<CloseToTimeFilterInput>;
  relative?: InputMaybe<RelativeTimeFilterInput>;
};

export enum TimesliceSize {
  FiveMinutes = 'FiveMinutes',
  OneMinute = 'OneMinute',
}

export type TimestampNormalizationInput = {
  source: Array<Scalars['String']['input']>;
};

export type TraceAggregationFocusInput = {
  criticalPathOnly?: InputMaybe<Scalars['Boolean']['input']>;
  terminalErrorsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TraceAggregationGroupByKeyInput = {
  type: TraceAggregationGroupByType;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum TraceAggregationGroupByType {
  OP = 'OP',
  SVC = 'SVC',
  TAG = 'TAG',
  UNKNOWN = 'UNKNOWN',
}

export type TraceAggregationOptionsInput = {
  focus?: InputMaybe<TraceAggregationFocusInput>;
  shape?: InputMaybe<TraceAggregationShapeInput>;
};

export type TraceAggregationShapeInput = {
  groupBy: Array<TraceAggregationGroupByKeyInput>;
};

export enum TraceBehaviorAssignmentType {
  MAIN = 'MAIN',
  OVERRIDE = 'OVERRIDE',
  REMOVED = 'REMOVED',
  UNKNOWN = 'UNKNOWN',
}

export type TraceBehaviorBaselineOptionsInput = {
  baseHeadSampleRate: Scalars['Float']['input'];
  baseTailSampleRate: Scalars['Float']['input'];
  errorSampleOptions?: InputMaybe<TraceBehaviorErrorSampleOptionsInput>;
  fastSampleOptions?: InputMaybe<TraceBehaviorFastSampleOptionsInput>;
  largeTraceSampleOptions?: InputMaybe<TraceBehaviorLargeTraceSampleOptionsInput>;
  slowSampleOptions?: InputMaybe<TraceBehaviorSlowSampleOptionsInput>;
  smallTraceSampleOptions?: InputMaybe<TraceBehaviorSmallTraceSampleOptionsInput>;
};

export type TraceBehaviorErrorSampleOptionsInput = {
  enabled: Scalars['Boolean']['input'];
  sampleRate: Scalars['Float']['input'];
  samplingType: TraceBehaviorSamplingType;
};

export type TraceBehaviorFastSampleOptionsInput = {
  enabled: Scalars['Boolean']['input'];
  maxDurationSeconds: Scalars['Float']['input'];
  sampleRate: Scalars['Float']['input'];
  samplingType: TraceBehaviorSamplingType;
};

export type TraceBehaviorLargeTraceSampleOptionsInput = {
  enabled: Scalars['Boolean']['input'];
  sampleRate: Scalars['Float']['input'];
  samplingType: TraceBehaviorSamplingType;
  spanCountThreshold: Scalars['Int']['input'];
};

export type TraceBehaviorMainAssignmentInput = {
  behavior: Scalars['String']['input'];
  createdBy: Scalars['String']['input'];
  dataset: Scalars['String']['input'];
  description: Scalars['String']['input'];
};

export type TraceBehaviorOverrideAssignmentInput = {
  behavior: Scalars['String']['input'];
  createdBy: Scalars['String']['input'];
  dataset: Scalars['String']['input'];
  description: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export enum TraceBehaviorSamplingType {
  HIGH_VALUE = 'HIGH_VALUE',
  LOW_VALUE = 'LOW_VALUE',
  UNKNOWN = 'UNKNOWN',
}

export type TraceBehaviorSlowSampleOptionsInput = {
  enabled: Scalars['Boolean']['input'];
  minDurationSeconds: Scalars['Float']['input'];
  sampleRate: Scalars['Float']['input'];
  samplingType: TraceBehaviorSamplingType;
};

export type TraceBehaviorSmallTraceSampleOptionsInput = {
  enabled: Scalars['Boolean']['input'];
  sampleRate: Scalars['Float']['input'];
  samplingType: TraceBehaviorSamplingType;
  spanCountThreshold: Scalars['Int']['input'];
};

export type TraceDatasetConfigurationInput = {
  filter: TraceSearchFilterInput;
};

export type TraceDatasetEnhancementsInput = {
  metricsTimeRange?: InputMaybe<TimeFilterInput>;
};

export type TraceFilterInput = {
  duration?: InputMaybe<DurationFilterInput>;
  error?: InputMaybe<BoolFilterInput>;
};

export type TraceJaegerRemoteSamplingStrategiesListFilterInput = {
  nameOrServiceContains?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  serviceNames?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TraceMetricsGroupByInput = {
  key: TraceMetricsGroupByKeyInput;
  label: Scalars['String']['input'];
};

export type TraceMetricsGroupByKeyInput = {
  namedKey?: InputMaybe<Scalars['String']['input']>;
  type: TraceMetricsGroupByKeyType;
};

export enum TraceMetricsGroupByKeyType {
  OPERATION = 'OPERATION',
  PARENT_OPERATION = 'PARENT_OPERATION',
  PARENT_SERVICE = 'PARENT_SERVICE',
  ROOT_OPERATION = 'ROOT_OPERATION',
  ROOT_SERVICE = 'ROOT_SERVICE',
  SERVICE = 'SERVICE',
  TAG = 'TAG',
  UNKNOWN = 'UNKNOWN',
}

export type TraceMetricsRulesListFilterInput = {
  metricNames?: InputMaybe<Array<Scalars['String']['input']>>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type TraceSearchFilterInput = {
  scope?: InputMaybe<ScopeFilterInput>;
  span?: InputMaybe<Array<SpanFilterInput>>;
  trace?: InputMaybe<TraceFilterInput>;
};

export type TraceSearchInput = {
  aggregationOptions?: InputMaybe<TraceAggregationOptionsInput>;
  criteria: TraceSearchFilterInput;
  criticalPathMode?: InputMaybe<Scalars['Boolean']['input']>;
  statisticsGroupBy?: InputMaybe<Scalars['String']['input']>;
  time: TimeFilterInput;
};

export type TraceTopTagInput = {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type TracingServiceAttributeToServiceInput = {
  tracingServiceAttribute: Array<Scalars['String']['input']>;
};

export type TransformInput = {
  regex: Scalars['String']['input'];
  replacement: Scalars['String']['input'];
};

export enum UITheme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
  SYSTEM = 'SYSTEM',
  UNKNOWN = 'UNKNOWN',
}

export type UIThemeInput = {
  uiTheme: UITheme;
};

export type UpdateAlertReceiver = {
  email?: InputMaybe<Array<NewAlertReceiverEmailConfig>>;
  /** Deprecated, use slug when possible */
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  opsgenie?: InputMaybe<Array<NewAlertReceiverOpsGenieConfig>>;
  pagerduty?: InputMaybe<Array<NewAlertReceiverPagerdutyConfig>>;
  slack?: InputMaybe<Array<NewAlertReceiverSlackConfig>>;
  slug?: InputMaybe<Scalars['ID']['input']>;
  victorOps?: InputMaybe<Array<NewAlertReceiverVictorOpsConfig>>;
  webhook?: InputMaybe<Array<NewAlertReceiverWebhookConfig>>;
};

export type UpdateCollection = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Optional slug of notification policy used by this collection */
  policySlug?: InputMaybe<Scalars['String']['input']>;
  /** Required slug for the collection to update. */
  slug: Scalars['String']['input'];
  team_slug?: InputMaybe<Scalars['String']['input']>;
  /** Optional type of collection to update. If unspecified, updates a SIMPLE collection. */
  type?: InputMaybe<CollectionType>;
};

export type UpdateCommentInput = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  taggedUserEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomComponentInput = {
  dashboard: Scalars['JSONObject']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  serviceTemplateVar?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};

export type UpdateDashboardAIDescriptionStatusInput = {
  /** The slug of the dashboard */
  slug: Scalars['String']['input'];
  /** The new status for the AI description */
  status: AIDescriptionStatus;
};

export type UpdateDatasetInput = {
  description: Scalars['String']['input'];
  logConfiguration?: InputMaybe<LogDatasetConfigurationInput>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  traceConfiguration?: InputMaybe<TraceDatasetConfigurationInput>;
};

export type UpdateDerivedLabelInput = {
  /** DerivedLabelSpanTag is used to map span tags to derived labels. */
  derivedLabelSpanTag?: InputMaybe<DerivedLabelSpanTagInput>;
  /** An optional description of the derived label. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** This field specifies the action taken when there's a metric label with the same name as this derived label. */
  existingLabelPolicy?: InputMaybe<DerivedLabelPolicy>;
  /** The name of the derived label. */
  labelName: Scalars['String']['input'];
  metricLabel?: InputMaybe<MetricLabelInput>;
  /** The name of the derived label. */
  name: Scalars['String']['input'];
  /** The unique slug of the derived label. */
  slug: Scalars['String']['input'];
};

export type UpdateDiscoveryInput = {
  /** Discovery config for events. */
  events?: InputMaybe<EventDiscoveryInput>;
  /** Discovery config for metrics. */
  metrics?: InputMaybe<MetricsDiscoveryInput>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type UpdateDropRule = {
  dropNanValue?: InputMaybe<Scalars['Boolean']['input']>;
  filters: Array<LabelFilter>;
  mode: DropRuleMode;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  valueBasedDrop?: InputMaybe<InputDropRuleValueBasedDrop>;
};

export type UpdateFavoriteInput = {
  entityType: FavoriteEntityType;
  isFavorite: Scalars['Boolean']['input'];
  slug: Scalars['String']['input'];
};

export type UpdateGlobalFiltersInput = {
  filters: Array<TemplateInput>;
};

export type UpdateLinkTemplateInput = {
  name: Scalars['String']['input'];
  slug: Scalars['ID']['input'];
  urlTemplate: Scalars['String']['input'];
};

export type UpdateLogAllocationConfigInput = {
  createIfMissing: Scalars['Boolean']['input'];
  dryRun: Scalars['Boolean']['input'];
  logAllocationConfig: LogAllocationConfigInput;
};

export type UpdateLogControlConfigInput = {
  createIfMissing: Scalars['Boolean']['input'];
  dryRun: Scalars['Boolean']['input'];
  logControlConfig: LogControlConfigInput;
};

export type UpdateLogIngestConfigInput = {
  createIfMissing: Scalars['Boolean']['input'];
  dryRun: Scalars['Boolean']['input'];
  logIngestConfig: LogIngestConfigInput;
};

export type UpdateLogLookupTableInput = {
  createIfMissing: Scalars['Boolean']['input'];
  dryRun: Scalars['Boolean']['input'];
  logLookupTable: LogLookupTableInput;
};

export type UpdateMappingRule = {
  aggregationPolicy?: InputMaybe<InputMappingRuleAggregationPolicy>;
  drop: Scalars['Boolean']['input'];
  filters: Array<LabelFilter>;
  mode: MappingRuleMode;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
};

export type UpdatePresentationInput = {
  dashboard?: InputMaybe<PresentationDashboardInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  eligibility?: InputMaybe<PresentationEligibilityInput>;
  events?: InputMaybe<PresentationEventsInput>;
  name: Scalars['String']['input'];
  numPanelsToDisplay?: InputMaybe<Scalars['Int']['input']>;
  slug: Scalars['String']['input'];
};

export type UpdateRecordingRule = {
  executionGroup?: InputMaybe<Scalars['String']['input']>;
  expr: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  interval: Scalars['String']['input'];
  labels: Array<NewRecordingRuleLabel>;
  name: Scalars['String']['input'];
};

export type UpdateRollupRule = {
  addMetricTypeLabel: Scalars['Boolean']['input'];
  aggregationType: AggregationType;
  dropRaw: Scalars['Boolean']['input'];
  expansiveMatch: Scalars['Boolean']['input'];
  filters: Array<LabelFilter>;
  graphiteLabelPolicy?: InputMaybe<InputGraphiteLabelPolicy>;
  interval?: InputMaybe<Scalars['String']['input']>;
  labelPolicy?: InputMaybe<InputLabelPolicy>;
  labelReplace?: InputMaybe<Array<InputRollupRuleLabelReplace>>;
  metricName: Scalars['String']['input'];
  metricType: MetricType;
  mode: RollupRuleMode;
  name: Scalars['String']['input'];
  skipOnConflict?: InputMaybe<Scalars['Boolean']['input']>;
  slug: Scalars['String']['input'];
  storagePolicy?: InputMaybe<InputStoragePolicy>;
};

export type UpdateSLOAIDescriptionStatusInput = {
  /** The slug of the SLO */
  slug: Scalars['String']['input'];
  /** The new status for the AI description */
  status: AIDescriptionStatus;
};

export type UpdateSLOInput = {
  annotations?: InputMaybe<Array<AnnotationInput>>;
  collectionSlug: Scalars['String']['input'];
  collectionType: CollectionType;
  definition: SLODefinitionInput;
  description?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<LabelInput>>;
  name: Scalars['String']['input'];
  notificationPolicySlug?: InputMaybe<Scalars['String']['input']>;
  signalGrouping?: InputMaybe<NewSignalGrouping>;
  sli: SLIInput;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSavedTraceSearchInput = {
  name: Scalars['String']['input'];
  slug: Scalars['ID']['input'];
};

export type UpdateSearchHistoryInput = {
  search: NewSearchHistory;
};

export type UpdateServiceAttribute = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notificationPolicyId?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  team?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeam = {
  addedRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** Deprecated. Use `addedRoles` and `removedRoles` instead. Only one of `isSysAdmin` and `addedRoles` or `removedRoles` may be set. */
  isSysAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  removedRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateThreadInput = {
  id: Scalars['ID']['input'];
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTraceBehaviorConfigInput = {
  baselineBehaviorSlug?: InputMaybe<Scalars['String']['input']>;
  datasetPriorities?: InputMaybe<Array<Scalars['String']['input']>>;
  mainBehaviorAssignments?: InputMaybe<Array<TraceBehaviorMainAssignmentInput>>;
  overrideBehaviorAssignments?: InputMaybe<Array<TraceBehaviorOverrideAssignmentInput>>;
  previewBehaviorAssignments?: InputMaybe<Array<TraceBehaviorOverrideAssignmentInput>>;
  version: Scalars['Int']['input'];
};

export type UpdateTraceBehaviorInput = {
  baseHeadSampleRate?: InputMaybe<Scalars['Float']['input']>;
  baseTailSampleRate?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  errorSampleOptions?: InputMaybe<TraceBehaviorErrorSampleOptionsInput>;
  fastSampleOptions?: InputMaybe<TraceBehaviorFastSampleOptionsInput>;
  largeTraceSampleOptions?: InputMaybe<TraceBehaviorLargeTraceSampleOptionsInput>;
  name: Scalars['String']['input'];
  slowSampleOptions?: InputMaybe<TraceBehaviorSlowSampleOptionsInput>;
  slug: Scalars['ID']['input'];
  smallTraceSampleOptions?: InputMaybe<TraceBehaviorSmallTraceSampleOptionsInput>;
};

export type UpdateTraceMetricsRuleInput = {
  groupBys?: InputMaybe<Array<TraceMetricsGroupByInput>>;
  histogramBucketsSeconds: Array<Scalars['Float']['input']>;
  metricLabels: Array<LabelInput>;
  metricName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  scopeFilter?: InputMaybe<ScopeFilterInput>;
  slug: Scalars['ID']['input'];
  traceFilter: TraceSearchFilterInput;
};

export type UpdateTraceTopTagsInput = {
  data: Array<TraceTopTagInput>;
  version: Scalars['Int']['input'];
};

export type UpdatedMonitor = {
  annotations: Array<NewAlertRuleAnnotation>;
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
  collectionType?: InputMaybe<CollectionType>;
  labels: Array<NewAlertRuleLabel>;
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  spec: NewMonitorSpec;
};

/** UpsertCollectionLinksInput is an input type that specifies a list of collection links to create or update. */
export type UpsertCollectionLinksInput = {
  collectionLinks: Array<CollectionLinkInput>;
};

export type UserSettingsInput = {
  darkMode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSettingsValueInput = {
  name: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Any']['input']>;
};

export enum UserState {
  ACTIVE = 'ACTIVE',
  DEACTIVATED = 'DEACTIVATED',
  INVITED = 'INVITED',
  PENDING = 'PENDING',
  SYNCED = 'SYNCED',
  UNKNOWN = 'UNKNOWN',
}

export enum UserType {
  ACCOUNT = 'ACCOUNT',
  SERVICE_ACCOUNT = 'SERVICE_ACCOUNT',
  UNKNOWN = 'UNKNOWN',
}

export enum ValidationStatus {
  INVALID = 'INVALID',
  UNKNOWN = 'UNKNOWN',
  VALID = 'VALID',
}

export type ValueDefinitionInput = {
  /** The filters that define the constructed label. */
  filters?: InputMaybe<Array<DerivedLabelFilterInput>>;
  /** The value of the constructed label. */
  value: Scalars['String']['input'];
};

export enum XRayNodeType {
  METRIC_NAME = 'METRIC_NAME',
  QUERY = 'QUERY',
}

export type metricMetadataFilterListinput = {
  metricNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetDashboardJSONVariables = Exact<{
  slugs: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type GetDashboardJSON = {
  allDashboards: {
    dashboards: Array<
      { slug: string; config: any; type: 'Dashboard' } | { slug: string; config: any; type: 'GrafanaDashboard' }
    >;
  };
};

export type CreateShortUrlMutationVariables = Exact<{
  input: ShortenMessageRequest;
}>;

export type CreateShortUrlMutation = { createShortenedMessage: { hash: string; message: string } };

export type GetActivityDetailVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetActivityDetail = { eventLog: { resourceName: string; dataJson: string } };

export type CommentFields = {
  id: string;
  text: string;
  authorEmail: string;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
};

export type ThreadFields = {
  id: string;
  isPinned: boolean;
  isResolved: boolean;
  comments: {
    comments: Array<{
      id: string;
      text: string;
      authorEmail: string;
      createdAt: string;
      updatedAt: string;
      isDeleted: boolean;
    }>;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
  };
};

export type CreateCommentVariables = Exact<{
  input: CreateCommentInput;
}>;

export type CreateComment = {
  createComment: {
    id: string;
    text: string;
    authorEmail: string;
    createdAt: string;
    updatedAt: string;
    isDeleted: boolean;
  };
};

export type UpdateThreadVariables = Exact<{
  input: UpdateThreadInput;
}>;

export type UpdateThread = {
  updateThread: {
    id: string;
    isPinned: boolean;
    isResolved: boolean;
    comments: {
      comments: Array<{
        id: string;
        text: string;
        authorEmail: string;
        createdAt: string;
        updatedAt: string;
        isDeleted: boolean;
      }>;
      pageInfo: { hasNextPage: boolean; cursor: string | null };
    };
  };
};

export type UpdateCommentVariables = Exact<{
  input: UpdateCommentInput;
}>;

export type UpdateComment = {
  updateComment: {
    id: string;
    text: string;
    authorEmail: string;
    createdAt: string;
    updatedAt: string;
    isDeleted: boolean;
  };
};

export type SoftDeleteCommentVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type SoftDeleteComment = {
  softDeleteComment: {
    id: string;
    text: string;
    authorEmail: string;
    createdAt: string;
    updatedAt: string;
    isDeleted: boolean;
  };
};

export type CreateThreadVariables = Exact<{
  input: CreateThreadInput;
}>;

export type CreateThread = {
  createThread: {
    id: string;
    isPinned: boolean;
    isResolved: boolean;
    comments: {
      comments: Array<{
        id: string;
        text: string;
        authorEmail: string;
        createdAt: string;
        updatedAt: string;
        isDeleted: boolean;
      }>;
      pageInfo: { hasNextPage: boolean; cursor: string | null };
    };
  };
};

export type GetCommentsVariables = Exact<{
  filter: InputMaybe<CommentsListInput>;
  after: InputMaybe<Scalars['String']['input']>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetComments = {
  comments: {
    comments: Array<{
      id: string;
      text: string;
      authorEmail: string;
      createdAt: string;
      updatedAt: string;
      isDeleted: boolean;
    }>;
    pageInfo: { cursor: string | null };
  };
};

export type GetThreadsVariables = Exact<{
  filter: InputMaybe<ThreadsListInput>;
  after: InputMaybe<Scalars['String']['input']>;
  threadsPageSize: InputMaybe<Scalars['Int']['input']>;
  commentsPageSize: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetThreads = {
  threads: {
    threads: Array<{
      id: string;
      isPinned: boolean;
      isResolved: boolean;
      comments: {
        comments: Array<{
          id: string;
          text: string;
          authorEmail: string;
          createdAt: string;
          updatedAt: string;
          isDeleted: boolean;
        }>;
        pageInfo: { hasNextPage: boolean; cursor: string | null };
      };
    }>;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
  };
};

export type GetTargetSummariesVariables = Exact<{
  filter: InputMaybe<TargetsListInput>;
}>;

export type GetTargetSummaries = {
  targetSummary: Array<{
    type: TargetType;
    reference: string;
    totalComments: number;
    topComment: {
      id: string;
      text: string;
      authorEmail: string;
      createdAt: string;
      updatedAt: string;
      isDeleted: boolean;
    } | null;
  }>;
};

export type LoadAuthorEmailsVariables = Exact<{ [key: string]: never }>;

export type LoadAuthorEmails = { users: Array<{ id: string; email: string }> };

export type CommentSearchVariables = Exact<{
  filter: CommentSearchFilter;
  after: InputMaybe<Scalars['String']['input']>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
}>;

export type CommentSearch = {
  commentSearch: {
    results: Array<{
      target: {
        type: TargetType;
        reference: string;
        totalComments: number;
        topComment: {
          id: string;
          text: string;
          authorEmail: string;
          createdAt: string;
          updatedAt: string;
          isDeleted: boolean;
        } | null;
      };
      comment: {
        id: string;
        text: string;
        authorEmail: string;
        createdAt: string;
        updatedAt: string;
        isDeleted: boolean;
      };
    }>;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
  };
};

export type GetPersonalCollectionVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetPersonalCollection = { collection: { slug: string; name: string } | null };

export type LoadDashboardTagsVariables = Exact<{ [key: string]: never }>;

export type LoadDashboardTags = {
  allDashboards: {
    dashboards: Array<
      | { __typename: 'Dashboard'; labels: Array<{ name: string; value: string }> | null }
      | { __typename: 'GrafanaDashboard'; labels: Array<{ name: string; value: string }> | null }
    >;
  };
};

export type GetDashboardGeneratedDescriptionVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetDashboardGeneratedDescription = {
  dashboard: {
    generatedDescription: {
      description: string;
      status: AIDescriptionStatus;
      promptHash: string;
      generatedAt: string;
    } | null;
  };
};

export type UpdateDashboardAIDescriptionStatusVariables = Exact<{
  input: UpdateDashboardAIDescriptionStatusInput;
}>;

export type UpdateDashboardAIDescriptionStatus = {
  updateDashboardAIDescriptionStatus: {
    description: string;
    status: AIDescriptionStatus;
    promptHash: string;
    generatedAt: string;
  };
};

export type RestoreEntityVersionMutationVariables = Exact<{
  input: RestoreEntityVersion;
}>;

export type RestoreEntityVersionMutation = { restoreEntityVersion: boolean };

export type versionsFragment = {
  nodes: Array<{
    id: string;
    createdAt: string;
    sourceClient: EntityVersionSource;
    config: { terraform: string; chronoctl: string; api: string };
    user: { type: UserType; email: string; name: string } | null;
  }>;
};

export type GetMonitorVersionsVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetMonitorVersions = {
  entity: {
    versions: {
      nodes: Array<{
        id: string;
        createdAt: string;
        sourceClient: EntityVersionSource;
        config: { terraform: string; chronoctl: string; api: string };
        user: { type: UserType; email: string; name: string } | null;
      }>;
    };
  };
};

export type GetDashboardVersionsVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetDashboardVersions = {
  entity: {
    versions: {
      nodes: Array<{
        id: string;
        createdAt: string;
        sourceClient: EntityVersionSource;
        config: { terraform: string; chronoctl: string; api: string };
        user: { type: UserType; email: string; name: string } | null;
      }>;
    };
  };
};

export type GetSLOVersionsVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetSLOVersions = {
  entity: {
    versions: {
      nodes: Array<{
        id: string;
        createdAt: string;
        sourceClient: EntityVersionSource;
        config: { terraform: string; chronoctl: string; api: string };
        user: { type: UserType; email: string; name: string } | null;
      }>;
    };
  };
};

export type ExportSloConfigVariables = Exact<{
  config: UpdateSLOInput;
}>;

export type ExportSloConfig = {
  exportConfig: { config: { dryRunError: string | null; terraform: string; chronoctl: string; api: string } };
};

export type ExportMonitorConfigVariables = Exact<{
  config: NewMonitor;
}>;

export type ExportMonitorConfig = {
  exportConfig: { config: { dryRunError: string | null; terraform: string; chronoctl: string; api: string } };
};

export type ExportDropRuleConfigVariables = Exact<{
  config: NewDropRule;
}>;

export type ExportDropRuleConfig = {
  exportConfig: { config: { dryRunError: string | null; terraform: string; chronoctl: string; api: string } };
};

export type ExportRollupRuleConfigVariables = Exact<{
  config: NewRollupRule;
}>;

export type ExportRollupRuleConfig = {
  exportConfig: { config: { dryRunError: string | null; terraform: string; chronoctl: string; api: string } };
};

export type ExportCollectionConfigVariables = Exact<{
  config: CreateCollection;
}>;

export type ExportCollectionConfig = {
  exportConfig: { config: { dryRunError: string | null; terraform: string; chronoctl: string; api: string } };
};

export type ExportMappingRuleConfigBySlugVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type ExportMappingRuleConfigBySlug = {
  exportConfig: { config: { terraform: string; api: string; chronoctl: string } };
};

export type ExportRollupRuleConfigBySlugVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type ExportRollupRuleConfigBySlug = {
  exportConfig: { config: { terraform: string; api: string; chronoctl: string } };
};

export type GetUpdatedPoolConfigurationVariables = Exact<{
  config: NewResourcePools;
}>;

export type GetUpdatedPoolConfiguration = {
  exportConfig: { config: { dryRunError: string | null; terraform: string } };
};

export type ExportDashboardConfigVariables = Exact<{
  config: SaveDashboardInput;
}>;

export type ExportDashboardConfig = {
  exportConfig: { config: { dryRunError: string | null; terraform: string; chronoctl: string; api: string } };
};

export type ExportDatasetConfigBySlugVariables = Exact<{
  config: CreateDatasetInput;
}>;

export type ExportDatasetConfigBySlug = {
  exportConfig: { config: { dryRunError: string | null; terraform: string; api: string; chronoctl: string } };
};

export type ExportDerivedLabelConfigVariables = Exact<{
  config: CreateDerivedLabelInput;
}>;

export type ExportDerivedLabelConfig = {
  exportConfig: { config: { dryRunError: string | null; terraform: string; chronoctl: string; api: string } };
};

export type ExportConfigVariables = Exact<{
  config: LogIngestConfigInput;
}>;

export type ExportConfig = {
  exportConfig: { config: { dryRunError: string | null; terraform: string; chronoctl: string; api: string } };
};

export type ExportLogsControlConfigVariables = Exact<{
  config: LogControlConfigInput;
}>;

export type ExportLogsControlConfig = {
  exportConfig: { config: { dryRunError: string | null; terraform: string; chronoctl: string; api: string } };
};

export type TestGetAlertsListVariables = Exact<{
  after: InputMaybe<Scalars['String']['input']>;
}>;

export type TestGetAlertsList = {
  alerts: {
    totalCount: number;
    pageInfo: { cursor: string | null; hasNextPage: boolean };
    alerts: Array<{ id: string }>;
  };
};

export type GetMetricDescriptionVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetMetricDescription = {
  metricMetadata: {
    description: string | null;
    descriptionData: { user: string | null; generated: string | null; generatedBy: string | null } | null;
  };
};

export type SetMetricDescriptionUserVariables = Exact<{
  metadata: MetricMetadataUserInput;
}>;

export type SetMetricDescriptionUser = { setMetricMetadataUser: boolean };

export type LoadUserSettingsMenuVariables = Exact<{ [key: string]: never }>;

export type LoadUserSettingsMenu = {
  tenant: { id: string; name: string };
  settings: { buildVersion: string; revision: string };
};

export type GetAffectedSlosVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filter: SLOListFilterInput;
}>;

export type GetAffectedSlos = {
  slos: {
    totalCount: number;
    pageInfo: { cursor: string | null; hasNextPage: boolean };
    slos: Array<{
      name: string;
      slug: string;
      collection: { name: string; slug: string } | { name: string; slug: string };
    }>;
  };
};

export type LoadNotifiersAutocompleteVariables = Exact<{ [key: string]: never }>;

export type LoadNotifiersAutocomplete = {
  alertReceivers: {
    receivers: Array<{
      id: string;
      slug: string;
      name: string;
      webhook: Array<{ url: string }> | null;
      email: Array<{ to: string }> | null;
      slack: Array<{ channel: string }> | null;
      pagerduty: Array<{ description: string }> | null;
      opsgenie: Array<{ description: string }> | null;
      victorOps: Array<{ routingKey: string }> | null;
    }>;
  };
};

export type AnalyzeAlertsListVariables = Exact<{
  input: AnalyzeAlertsListInput;
}>;

export type AnalyzeAlertsList = {
  analyzeAlertsList: {
    alerts: Array<{
      alertId: string;
      monitorSlug: string;
      monitorName: string | null;
      isMuted: boolean;
      startTime: string | null;
      endTime: string | null;
      notificationPolicySlug: string | null;
      notificationPolicyName: string | null;
      signal: Array<{ name: string; value: string }>;
      monitorLabels: Array<{ name: string; value: string }>;
      ownershipContext: {
        entityGroupId: string;
        entityGroupSlug: string;
        collectionId: string;
        collectionSlug: string;
      } | null;
      severityHistory: Array<{ severity: string; timestamp: string }>;
      muteHistory: Array<{ action: string; timestamp: string }>;
      sloMetadata: { slug: string; category: string; name: string; type: string } | null;
      notifierHistory: Array<{
        severity: string;
        notifierSlug: string;
        notifierName: string;
        sendSuccess: boolean;
        timestamp: string;
      }>;
    }>;
  };
};

export type LoadAnalyticsVariables = Exact<{ [key: string]: never }>;

export type LoadAnalytics = {
  me: { id: string; email: string; isAdmin: boolean; roles: Array<{ name: string }> };
  tenant: { id: string; name: string };
  settings: { buildVersion: string };
  userSettings: { darkMode: boolean };
};

export type LogEventsVariables = Exact<{
  input: LogEventsInput;
}>;

export type LogEvents = { logEvents: boolean };

export type DarkModeSettingQueryVariables = Exact<{ [key: string]: never }>;

export type DarkModeSettingQuery = { userSettings: { uiTheme: UITheme } };

export type SaveThemePreferenceMutationVariables = Exact<{
  input: UIThemeInput;
}>;

export type SaveThemePreferenceMutation = { setUITheme: boolean };

export type LoadDashboardOptionsVariables = Exact<{
  filter: InputMaybe<AllDashboardsFilter>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
}>;

export type LoadDashboardOptions = {
  allDashboards: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    dashboards: Array<
      | { __typename: 'Dashboard'; name: string; slug: string }
      | { __typename: 'GrafanaDashboard'; name: string; slug: string }
    >;
  };
};

export type LoadMonitorOptionsVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filters: MonitorsV2Filters;
}>;

export type LoadMonitorOptions = {
  monitorsV2: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    monitors: Array<{ slug: string; name: string }>;
  };
};

export type LoadCollectionOptionsVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<CollectionsFilters>;
}>;

export type LoadCollectionOptions = {
  collections: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    collections: Array<{ name: string; slug: string }>;
  };
};

export type DeleteNativeDashboardMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type DeleteNativeDashboardMutation = { deleteDashboard: boolean };

export type GetResourcePoolsVariables = Exact<{ [key: string]: never }>;

export type GetResourcePools = {
  resourcePools: {
    defaultPool: {
      allocation: { percentOfLicense: number | null } | null;
      priorities: {
        highPriorityMatchRules: Array<{ name: string; value: string }> | null;
        lowPriorityMatchRules: Array<{ name: string; value: string }> | null;
      } | null;
      priorityThresholds: Array<{
        license: ResourcePoolLicense;
        allPriorities: { percentOfPoolAllocation: number | null; fixedValue: number | null } | null;
        defaultAndLowPriority: { percentOfPoolAllocation: number | null; fixedValue: number | null } | null;
        lowPriority: { percentOfPoolAllocation: number | null; fixedValue: number | null } | null;
      }> | null;
    } | null;
    pools: Array<{
      name: string;
      matchType: Match;
      allocation: {
        percentOfLicense: number | null;
        fixedValues: Array<{ license: ResourcePoolLicense; value: number }> | null;
        priorityThresholds: Array<{
          license: ResourcePoolLicense;
          allPriorities: { percentOfPoolAllocation: number | null; fixedValue: number | null } | null;
          defaultAndLowPriority: { percentOfPoolAllocation: number | null; fixedValue: number | null } | null;
          lowPriority: { percentOfPoolAllocation: number | null; fixedValue: number | null } | null;
        }> | null;
      };
      matchRules: Array<{ name: string; value: string }> | null;
      priorities: {
        highPriorityMatchRules: Array<{ name: string; value: string }> | null;
        lowPriorityMatchRules: Array<{ name: string; value: string }> | null;
      } | null;
    }> | null;
  };
};

export type GetSearchHistoryVariables = Exact<{
  userID: InputMaybe<Scalars['String']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  onlySaved: InputMaybe<Scalars['Boolean']['input']>;
  onlyShared: InputMaybe<Scalars['Boolean']['input']>;
  searchType: InputMaybe<SearchType>;
}>;

export type GetSearchHistory = {
  userSearchHistory: {
    searchHistories: Array<{
      id: string;
      updatedAt: string | null;
      name: string | null;
      shared: boolean;
      saved: boolean;
      search: { query: string; summaryFields: Array<string> | null; columns: Array<string> | null };
    }>;
  };
};

export type CreateSearchHistoryVariables = Exact<{
  input: CreateSearchHistoryInput;
}>;

export type CreateSearchHistory = { createUserSearchHistory: { id: string } };

export type DeleteSearchHistoryVariables = Exact<{
  input: DeleteSearchHistoryInput;
}>;

export type DeleteSearchHistory = { deleteUserSearchHistory: boolean };

export type ListTeamsWithCollectionsVariables = Exact<{
  userId: InputMaybe<Scalars['ID']['input']>;
}>;

export type ListTeamsWithCollections = {
  teams: Array<{
    slug: string;
    name: string;
    description: string;
    isAdmin: boolean;
    roles: Array<{ name: string }>;
    collections: { collections: Array<{ slug: string; name: string; description: string }> };
  }>;
};

export type GetUsageStatsConfigVariables = Exact<{ [key: string]: never }>;

export type GetUsageStatsConfig = { usageStatsConfig: { tags: Array<string> | null } | null };

export type DeaggregateQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;

export type DeaggregateQuery = {
  deaggregate: {
    layers: Array<{
      original: string;
      deaggregated: string;
      replacements: Array<{ original: string; replacement: string; type: OriginalMetricSource }>;
    }> | null;
  };
};

export type CreateTestCollectionVariables = Exact<{
  input: CreateCollection;
}>;

export type CreateTestCollection = { createCollection: { slug: string; name: string } };

export type GetPublicCollectionVariables = Exact<{ [key: string]: never }>;

export type GetPublicCollection = { collection: { slug: string; name: string } | null };

export type DeleteTestCollectionVariables = Exact<{
  input: DeleteCollection;
}>;

export type DeleteTestCollection = { deleteCollection: boolean };

export type CreateTestComponentVariables = Exact<{
  input: CreateCustomComponentInput;
}>;

export type CreateTestComponent = {
  createCustomComponent: { component: { slug: string }; discovery: { slug: string } } | null;
};

export type DeleteTestComponentVariables = Exact<{
  input: DeleteCustomComponentInput;
}>;

export type DeleteTestComponent = { deleteCustomComponent: boolean };

export type CreateTestMonitorVariables = Exact<{
  input: NewMonitor;
}>;

export type CreateTestMonitor = {
  createMonitor: { slug: string; name: string; spec: { query: { queryExpression: string } } };
};

export type DeleteTestMonitorVariables = Exact<{
  input: DeleteMonitor;
}>;

export type DeleteTestMonitor = { deleteMonitor: boolean };

export type CreateTestAlertReceiverVariables = Exact<{
  input: NewAlertReceiver;
}>;

export type CreateTestAlertReceiver = { createAlertReceiver: { slug: string } };

export type DeleteTestAlertReceiverVariables = Exact<{
  input: DeleteAlertReceiver;
}>;

export type DeleteTestAlertReceiver = { deleteAlertReceiver: boolean };

export type CreateTestNotificationPolicyVariables = Exact<{
  input: NewAlertNotificationPolicy;
}>;

export type CreateTestNotificationPolicy = { createAlertNotificationPolicy: { slug: string } };

export type DeleteTestNotificationPolicyVariables = Exact<{
  input: DeleteAlertNotificationPolicy;
}>;

export type DeleteTestNotificationPolicy = { deleteAlertNotificationPolicy: boolean };

export type GetAllTestScopesVariables = Exact<{ [key: string]: never }>;

export type GetAllTestScopes = {
  globalFilters: Array<{ name: string; value: { labelValues: { matcher: string } | null } }>;
};

export type CreateTestScopeVariables = Exact<{
  input: UpdateGlobalFiltersInput;
}>;

export type CreateTestScope = { updateGlobalFilters: Array<{ name: string }> };

export type CreateTestServiceAccountVariables = Exact<{
  input: CreateServiceAccountInput;
}>;

export type CreateTestServiceAccount = { createServiceAccount: { serviceAccount: { id: string; name: string } } };

export type DeleteTestServiceAccountsVariables = Exact<{
  input: DeleteServiceAccountsInput;
}>;

export type DeleteTestServiceAccounts = { deleteServiceAccounts: boolean };

export type CreateTestSLOMutationVariables = Exact<{
  input: UpdateSLOInput;
}>;

export type CreateTestSLOMutation = { createSLO: { slug: string; name: string } };

export type DeleteTestSloVariables = Exact<{
  input: DeleteSLOInput;
}>;

export type DeleteTestSlo = { deleteSLO: boolean };

export type CreateTestTeamVariables = Exact<{
  input: NewTeam;
}>;

export type CreateTestTeam = { createTeam: { id: string; slug: string; name: string } };

export type DeleteTestTeamVariables = Exact<{
  input: DeleteTeam;
}>;

export type DeleteTestTeam = { deleteTeam: boolean };

export type GetAlertsListVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filters: AlertsFilters;
}>;

export type GetAlertsList = {
  alerts: {
    totalCount: number;
    pageInfo: { cursor: string | null; hasNextPage: boolean };
    alerts: Array<{
      createdAt: string;
      currentMutedStatus: boolean;
      currentSeverity: AlertDatastoreSeverity;
      currentStatus: AlertDatastoreStatus;
      id: string;
      name: string;
      resolvedAt: string | null;
      slug: string;
      monitor: { name: string; slug: string } | null;
      mutingRules: Array<{ endsAt: string; state: MutingRuleState }>;
      notificationPolicy: { name: string; slug: string } | null;
      signal: Array<{ name: string; value: string }>;
      slo: { name: string; slug: string } | null;
    }>;
  };
};

export type GetAlertDetailsVariables = Exact<{
  alertId: Scalars['ID']['input'];
}>;

export type GetAlertDetails = {
  alert: {
    createdAt: string;
    currentMutedStatus: boolean;
    currentSeverity: AlertDatastoreSeverity;
    currentStatus: AlertDatastoreStatus;
    firstNotifiedAt: string | null;
    id: string;
    name: string;
    collection:
      | {
          __typename: 'Collection';
          name: string;
          slug: string;
          type: CollectionType;
          team: { name: string; slug: string } | null;
        }
      | {
          __typename: 'Service';
          derivedName: string;
          name: string;
          slug: string;
          type: CollectionType;
          team: { name: string; slug: string } | null;
        }
      | null;
    monitor: {
      name: string;
      slug: string;
      annotations: Array<{ name: string; value: string }> | null;
      spec: {
        query: { queryDatasource: DatasourceType; queryExpression: string };
        seriesConditions: {
          defaults: Array<{
            conditionLevel: ConditionLevel;
            conditions: Array<{ sustain: string; op: ThresholdOp; value: number; resolveSustain: string }> | null;
          }> | null;
          overrides: Array<{
            matchers: Array<{ name: string; value: string; type: AlertRouteMatcherType }> | null;
            conditions: Array<{
              conditionLevel: ConditionLevel;
              conditions: Array<{ sustain: string; op: ThresholdOp; value: number; resolveSustain: string }> | null;
            }> | null;
          }> | null;
        };
        signalGrouping: { labelNames: Array<string> | null; signalPerSeries: boolean };
      };
    } | null;
    mutingRules: Array<{ endsAt: string; name: string; slug: string; state: MutingRuleState }>;
    signal: Array<{ name: string; value: string }>;
    slo: {
      description: string | null;
      id: string;
      name: string;
      slug: string;
      annotations: Array<{ name: string; value: string }>;
      definition: {
        objective: number;
        timeWindow: { duration: string } | null;
        burnRateAlertingConfig: Array<{
          budget: number;
          window: string;
          severity: ConditionLevel | null;
          labels: Array<{ name: string; value: string }> | null;
        }> | null;
      } | null;
      signalGrouping: { labelNames: Array<string> | null; signalPerSeries: boolean } | null;
    } | null;
  };
};

export type ListEntityAlertsVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filters: AlertsFilters;
}>;

export type ListEntityAlerts = {
  alerts: {
    totalCount: number;
    pageInfo: { cursor: string | null; hasNextPage: boolean };
    alerts: Array<{
      createdAt: string;
      currentMutedStatus: boolean;
      currentSeverity: AlertDatastoreSeverity;
      currentStatus: AlertDatastoreStatus;
      id: string;
      name: string;
      monitor: { slug: string } | null;
      signal: Array<{ name: string; value: string }>;
      slo: { slug: string } | null;
    }>;
  };
};

export type GetPaginatedAlertEventsVariables = Exact<{
  monitorSlugs: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sloSlugs: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  latestFirst: InputMaybe<Scalars['Boolean']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
  timeRange: InputMaybe<NewTimeRange>;
  eventTypes: InputMaybe<Array<AlertEventType> | AlertEventType>;
  signals: InputMaybe<
    | Array<InputMaybe<Array<NewAlertRuleLabel> | NewAlertRuleLabel>>
    | InputMaybe<Array<NewAlertRuleLabel> | NewAlertRuleLabel>
  >;
  signalFilters: InputMaybe<Array<NewAlertRouteMatcher> | NewAlertRouteMatcher>;
}>;

export type GetPaginatedAlertEvents = {
  alertEvents: {
    alertEvents: Array<{
      eventType: AlertEventType;
      createdAt: string;
      signal: Array<{ name: string; value: string }>;
      details:
        | {
            __typename: 'MonitorMuted';
            severity: ConditionLevel;
            mutingRulesObj: { mutingRules: Array<{ slug: string }> };
          }
        | { __typename: 'MonitorResolvedAlertEvent'; severity: ConditionLevel }
        | {
            __typename: 'MonitorResolvedNotificationFailedToSend';
            severity: ConditionLevel;
            error: string;
            notifier: { name: string; slug: string };
          }
        | {
            __typename: 'MonitorResolvedNotificationSent';
            severity: ConditionLevel;
            notifier: { name: string; slug: string };
          }
        | { __typename: 'MonitorTriggeredAlertEvent'; severity: ConditionLevel }
        | {
            __typename: 'MonitorTriggeredNotificationFailedToSend';
            severity: ConditionLevel;
            error: string;
            notifier: { name: string; slug: string };
          }
        | {
            __typename: 'MonitorTriggeredNotificationSent';
            severity: ConditionLevel;
            notifier: { name: string; slug: string };
          }
        | {
            __typename: 'MonitorUnmuted';
            severity: ConditionLevel;
            mutingRulesObj: { mutingRules: Array<{ slug: string }> };
          };
    }>;
    pageInfo: { cursor: string | null; hasNextPage: boolean };
  };
};

export type GetAllSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAllSettingsQuery = {
  settings: { metrics: { retentionPolicies: Array<{ retention: string; resolution: string }> } | null };
};

export type UpsertCollectionLinksMutationVariables = Exact<{
  input: UpsertCollectionLinksInput;
}>;

export type UpsertCollectionLinksMutation = {
  upsertCollectionLinks: Array<{
    slug: string;
    updatedAt: string;
    createdAt: string;
    collection: {
      name: string;
      slug: string;
      type: CollectionType;
      nullableTeam: { name: string; slug: string } | null;
    };
  }>;
};

export type DeleteCollectionLinksMutationVariables = Exact<{
  input: DeleteCollectionLinksInput;
}>;

export type DeleteCollectionLinksMutation = { deleteCollectionLinks: boolean };

export type CollectionMonitorLinksQueryVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<CollectionLinkListFilterInput>;
}>;

export type CollectionMonitorLinksQuery = {
  collectionLinks: {
    totalCount: number;
    pageInfo: { cursor: string | null; hasNextPage: boolean };
    collectionLinks: Array<{
      slug: string;
      monitorLink: {
        impactsServiceHealth: boolean;
        monitor: {
          slug: string;
          name: string;
          policy: { explicitReference: boolean; policy: { name: string; slug: string } } | null;
          collection: {
            name: string;
            type: CollectionType;
            slug: string;
            nullableTeam: { id: string; slug: string; name: string } | null;
          };
          state: {
            state: AlertState;
            signals: Array<{
              state: AlertState;
              series: Array<{ status: { status: AlertState; startedAt: string | null } }> | null;
              labels: Array<{ name: string; value: string }> | null;
            }> | null;
          };
        };
      } | null;
    }>;
  };
};

export type CollectionDashboardLinksQueryVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<CollectionLinkListFilterInput>;
}>;

export type CollectionDashboardLinksQuery = {
  collectionLinks: {
    totalCount: number;
    pageInfo: { cursor: string | null; hasNextPage: boolean };
    collectionLinks: Array<{
      slug: string;
      dashboardLink: {
        dashboard:
          | {
              __typename: 'Dashboard';
              name: string;
              slug: string;
              source: EditSource;
              isFavorite: boolean;
              labels: Array<{ name: string; value: string }> | null;
              collection: {
                name: string;
                type: CollectionType;
                slug: string;
                nullableTeam: { id: string; name: string; slug: string } | null;
              } | null;
            }
          | {
              __typename: 'GrafanaDashboard';
              name: string;
              slug: string;
              source: EditSource;
              isFavorite: boolean;
              labels: Array<{ name: string; value: string }> | null;
              collection: {
                name: string;
                type: CollectionType;
                slug: string;
                nullableTeam: { id: string; name: string; slug: string } | null;
              } | null;
            };
      } | null;
    }>;
  };
};

export type ListTeamCollectionsVariables = Exact<{
  teamSlug: InputMaybe<Scalars['String']['input']>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  collectionsFilters: InputMaybe<CollectionsFilters>;
}>;

export type ListTeamCollections = {
  team: {
    collections: {
      totalCount: number;
      pageInfo: { hasNextPage: boolean; cursor: string | null };
      collections: Array<
        | {
            __typename: 'Collection';
            name: string;
            slug: string;
            type: CollectionType;
            nullableTeam: { name: string; slug: string } | null;
          }
        | {
            __typename: 'Service';
            derivedName: string;
            name: string;
            slug: string;
            type: CollectionType;
            nullableTeam: { name: string; slug: string } | null;
          }
      >;
    };
  } | null;
};

export type ListCollectionsVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filters: InputMaybe<CollectionsFilters>;
}>;

export type ListCollections = {
  collections: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    collections: Array<
      | {
          __typename: 'Collection';
          name: string;
          slug: string;
          type: CollectionType;
          description: string;
          managedBy: { editable: boolean; source: ManagedBySource };
          nullableTeam: { name: string; slug: string } | null;
          policy: { slug: string } | null;
        }
      | {
          __typename: 'Service';
          derivedName: string;
          name: string;
          slug: string;
          type: CollectionType;
          description: string;
          managedBy: { editable: boolean; source: ManagedBySource };
          nullableTeam: { name: string; slug: string } | null;
          policy: { slug: string } | null;
        }
    >;
  };
};

export type ListCollectionHomepageVariables = Exact<{
  collectionSlug: Scalars['String']['input'];
}>;

export type ListCollectionHomepage = {
  collection: {
    name: string;
    type: CollectionType;
    slug: string;
    description: string;
    managedBy: { editable: boolean; source: ManagedBySource };
    policy: { name: string; slug: string } | null;
    homepage: { links: Array<{ name: string; url: string }> | null } | null;
    nullableTeam: { name: string; slug: string } | null;
  } | null;
};

export type UpdateCollectionHomepageVariables = Exact<{
  input: SaveCollectionHomepageInput;
}>;

export type UpdateCollectionHomepage = { saveCollectionHomepage: { slug: string } };

export type CreateCollectionMutationVariables = Exact<{
  input: CreateCollection;
}>;

export type CreateCollectionMutation = { createCollection: { slug: string } };

export type UpdateCollectionMutationVariables = Exact<{
  input: UpdateCollection;
}>;

export type UpdateCollectionMutation = { updateCollection: { slug: string } };

export type DeleteCollectionMutationVariables = Exact<{
  input: DeleteCollection;
}>;

export type DeleteCollectionMutation = { deleteCollection: boolean };

export type GetPartitionBySlugPathsVariables = Exact<{
  slugPath: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  resource: ConsumptionResource;
  startAt: Scalars['Time']['input'];
  endAt: Scalars['Time']['input'];
}>;

export type GetPartitionBySlugPaths = {
  consumptionPartition: {
    name: string;
    slug: string;
    namePathParts: Array<string>;
    slugPathParts: Array<string>;
    consumed: number;
    dropped: number;
    parentConsumed: number | null;
    weekOverWeekChangePercent: number | null;
    budgetStatus: ConsumptionBudgetStatus;
    archived: boolean;
  };
};

export type GetConsumptionByPartitionVariables = Exact<{
  slugPath: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  resource: ConsumptionResource;
  startAt: Scalars['Time']['input'];
  endAt: Scalars['Time']['input'];
}>;

export type GetConsumptionByPartition = { consumptionPartition: { consumed: number } };

export type GetDroppedByPartitionVariables = Exact<{
  slugPath: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  resource: ConsumptionResource;
  startAt: Scalars['Time']['input'];
  endAt: Scalars['Time']['input'];
}>;

export type GetDroppedByPartition = { consumptionPartition: { dropped: number } };

export type GetChangeOverTimeByPartitionVariables = Exact<{
  slugPath: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  resource: ConsumptionResource;
  startAt: Scalars['Time']['input'];
  endAt: Scalars['Time']['input'];
}>;

export type GetChangeOverTimeByPartition = {
  consumptionPartition: { trendType: ConsumptionTrendType; trendPercent: number | null };
};

export type GetChildPartitionsByPartitionVariables = Exact<{
  slugPath: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  resource: ConsumptionResource;
  startAt: Scalars['Time']['input'];
  endAt: Scalars['Time']['input'];
}>;

export type GetChildPartitionsByPartition = {
  consumptionPartition: {
    children: Array<{
      name: string;
      slug: string;
      namePathParts: Array<string>;
      slugPathParts: Array<string>;
      consumed: number;
      dropped: number;
      parentConsumed: number | null;
      parentDropped: number | null;
      budgetStatus: ConsumptionBudgetStatus;
      trendType: ConsumptionTrendType;
      trendPercent: number | null;
      archived: boolean;
    }> | null;
  };
};

export type GetConsumptionContractVariables = Exact<{
  resource: ConsumptionResource;
  queryAt: Scalars['Time']['input'];
}>;

export type GetConsumptionContract = {
  consumptionContract: { startAt: string; endAt: string; volume: number; consumed: number } | null;
};

export type GetBudgetByPartitionVariables = Exact<{
  slugPath: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  resource: ConsumptionResource;
  startAt: Scalars['Time']['input'];
  endAt: Scalars['Time']['input'];
}>;

export type GetBudgetByPartition = {
  consumptionPartition: {
    consumptionBudget: {
      defaultPriority: number;
      thresholds: Array<{
        action: ConsumptionBudgetThresholdAction;
        type: ConsumptionBudgetThresholdType;
        consumedValue: number | null;
        thresholdValue: number;
        isSystemLimit: boolean;
      }>;
      priorities: Array<{
        priority: number;
        filters: Array<{ logFilter: { query: string } | null; dataset: { slug: string; name: string } | null }>;
      }>;
    } | null;
  };
};

export type GetConsumptionPartitionTimeSeriesVariables = Exact<{
  slugPath: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  resource: ConsumptionResource;
  startAt: Scalars['Time']['input'];
  endAt: Scalars['Time']['input'];
  view: ConsumptionTimeSeriesView;
  groupBy: ConsumptionTimeSeriesGroupBy;
  stepSeconds: Scalars['Int']['input'];
}>;

export type GetConsumptionPartitionTimeSeries = { consumptionPartition: { timeSeries: any | null; logQuery: string } };

export type ListAllDashboardsVariables = Exact<{
  filter: InputMaybe<AllDashboardsFilter>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  fetchUpdateProps?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListAllDashboards = {
  allDashboards: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    dashboards: Array<
      | {
          __typename: 'Dashboard';
          config?: any;
          name: string;
          slug: string;
          isFavorite: boolean;
          favorites: number | null;
          labels: Array<{ name: string; value: string }> | null;
          managedBy: { editable: boolean; source: ManagedBySource };
          collection: {
            name: string;
            type: CollectionType;
            slug: string;
            nullableTeam: { id: string; name: string; slug: string } | null;
          } | null;
        }
      | {
          __typename: 'GrafanaDashboard';
          name: string;
          slug: string;
          isFavorite: boolean;
          favorites: number | null;
          labels: Array<{ name: string; value: string }> | null;
          managedBy: { editable: boolean; source: ManagedBySource };
          collection: {
            name: string;
            type: CollectionType;
            slug: string;
            nullableTeam: { id: string; name: string; slug: string } | null;
          } | null;
        }
    >;
  };
};

export type SaveDashboardVariables = Exact<{
  slug: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  collectionSlug: Scalars['String']['input'];
  collectionType: InputMaybe<CollectionType>;
  dashboardJSON: Scalars['JSONObject']['input'];
  labels: InputMaybe<Array<LabelInput> | LabelInput>;
}>;

export type SaveDashboard = { saveDashboard: { slug: string } };

export type DashboardBySlugVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type DashboardBySlug = {
  grafanaDashboard: {
    slug: string;
    name: string;
    isFavorite: boolean;
    dashboardJSON: string;
    managedBy: { editable: boolean; source: ManagedBySource };
    collection: {
      name: string;
      slug: string;
      type: CollectionType;
      nullableTeam: { id: string; name: string; slug: string } | null;
    } | null;
    collectionLinks: Array<{
      slug: string;
      collection: {
        name: string;
        slug: string;
        type: CollectionType;
        nullableTeam: { name: string; slug: string } | null;
      };
    }> | null;
  } | null;
};

export type SaveDashboardSettingsVariables = Exact<{
  input: GrafanaDashboardSettings;
}>;

export type SaveDashboardSettings = { saveGrafanaDashboardSettings: { slug: string } };

export type ListAllDashboardsForSelectVariables = Exact<{
  filter: InputMaybe<AllDashboardsFilter>;
}>;

export type ListAllDashboardsForSelect = {
  allDashboards: { dashboards: Array<{ name: string; slug: string } | { name: string; slug: string }> };
};

export type GetDashboardConfigVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetDashboardConfig = { dashboard: { config: any } };

export type DocArtifactValue = {
  key: string;
  blob: any;
  createdAt: string;
  updatedAt: string;
  labels: Array<{ name: string; value: string }>;
  createdBy: { email: string };
};

export type ListDocArtifactsVariables = Exact<{
  input: ListDocArtifactsInput;
}>;

export type ListDocArtifacts = {
  docArtifacts: {
    items: Array<{
      key: string;
      blob: any;
      createdAt: string;
      updatedAt: string;
      labels: Array<{ name: string; value: string }>;
      createdBy: { email: string };
    }>;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
  };
};

export type GetDocArtifactVariables = Exact<{
  key: Scalars['String']['input'];
}>;

export type GetDocArtifact = {
  docArtifact: {
    key: string;
    blob: any;
    createdAt: string;
    updatedAt: string;
    labels: Array<{ name: string; value: string }>;
    createdBy: { email: string };
  } | null;
};

export type PutDocArtifactVariables = Exact<{
  input: PutDocArtifactInput;
}>;

export type PutDocArtifact = {
  putDocArtifact: {
    key: string;
    blob: any;
    createdAt: string;
    updatedAt: string;
    labels: Array<{ name: string; value: string }>;
  };
};

export type DeleteDocArtifactVariables = Exact<{
  key: Scalars['String']['input'];
}>;

export type DeleteDocArtifact = { deleteDocArtifact: boolean };

export type UpdateFavoritesMutationVariables = Exact<{
  input: UpdateFavoriteInput;
}>;

export type UpdateFavoritesMutation = { updateFavorite: boolean };

export type GetMonitorOwnershipVariables = Exact<{
  monitorSlug: Scalars['String']['input'];
}>;

export type GetMonitorOwnership = {
  monitor: {
    slug: string;
    collection: { name: string; slug: string; nullableTeam: { id: string; name: string; slug: string } | null };
  };
};

export type ListMonitorsQueryVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filters: MonitorsV2Filters;
  fetchConnections?: InputMaybe<Scalars['Boolean']['input']>;
  fetchUpdateProps?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListMonitorsQuery = {
  monitorsV2: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    monitors: Array<{
      slug: string;
      name: string;
      isFavorite: boolean;
      annotations?: Array<{ name: string; value: string }> | null;
      labels?: Array<{ name: string; value: string }> | null;
      managedBy: { editable: boolean; source: ManagedBySource };
      spec: {
        interval?: string;
        schedule?: {
          timezone: string;
          weeklySchedule: Array<{ ranges: Array<{ start: string; end: string }> } | null> | null;
        } | null;
        signalGrouping: { labelNames: Array<string> | null; signalPerSeries: boolean };
        query?: { queryExpression: string; queryDatasource: DatasourceType };
        seriesConditions?: {
          defaults: Array<{
            conditionLevel: ConditionLevel;
            conditions: Array<{ op: ThresholdOp; value: number; sustain: string; resolveSustain: string }> | null;
          }> | null;
          overrides: Array<{
            conditions: Array<{
              conditionLevel: ConditionLevel;
              conditions: Array<{ op: ThresholdOp; value: number; sustain: string; resolveSustain: string }> | null;
            }> | null;
            matchers: Array<{ name: string; type: AlertRouteMatcherType; value: string }> | null;
          }> | null;
        };
      };
      policy: { explicitReference: boolean; policy: { name: string; slug: string } } | null;
      collection: {
        name: string;
        type: CollectionType;
        slug: string;
        nullableTeam: { id: string; slug: string; name: string } | null;
      };
      collectionLinks?: Array<{
        collection: { slug: string; type: CollectionType };
        monitorLink: { impactsServiceHealth: boolean } | null;
      }> | null;
      state: {
        state: AlertState;
        signals: Array<{
          state: AlertState;
          series: Array<{ status: { status: AlertState; startedAt: string | null } }> | null;
          labels: Array<{ name: string; value: string }> | null;
        }> | null;
      };
    }>;
  };
};

export type BasicListMonitorsQueryVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filters: MonitorsV2Filters;
}>;

export type BasicListMonitorsQuery = {
  monitorsV2: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    monitors: Array<{ slug: string; name: string; isFavorite: boolean }>;
  };
};

export type NotifiersAutocompleteValue = {
  id: string;
  slug: string;
  name: string;
  webhook: Array<{ url: string }> | null;
  email: Array<{ to: string }> | null;
  slack: Array<{ channel: string }> | null;
  pagerduty: Array<{ description: string }> | null;
  opsgenie: Array<{ description: string }> | null;
  victorOps: Array<{ routingKey: string }> | null;
};

export type ListNotificationPoliciesQueryVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filters: NotificationPoliciesPageFilters;
}>;

export type ListNotificationPoliciesQuery = {
  notificationPoliciesPage: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    notificationPolicies: Array<{
      slug: string;
      name: string;
      managedBy: { editable: boolean; source: ManagedBySource };
      team: { name: string; slug: string } | null;
      routes: {
        defaults: Array<{
          severity: string;
          repeatInterval: string;
          notifierList: Array<{ slug: string; name: string; notifierConfig: { slug: string; name: string } }>;
        }>;
        overrides: Array<{
          matchers: Array<{ name: string; value: string; type: AlertRouteMatcherType }>;
          notifiers: Array<{
            severity: string;
            repeatInterval: string;
            notifierList: Array<{ slug: string; name: string; notifierConfig: { slug: string; name: string } }>;
          }>;
        }>;
      };
    }>;
  };
};

export type GetNotificationPolicyQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetNotificationPolicyQuery = {
  notificationPolicy: {
    slug: string;
    name: string;
    managedBy: { editable: boolean; source: ManagedBySource };
    team: { name: string; slug: string } | null;
    routes: {
      defaults: Array<{
        severity: string;
        repeatInterval: string;
        groupBy: Array<string> | null;
        notifierList: Array<{
          slug: string;
          name: string;
          notifierConfig: {
            id: string;
            slug: string;
            name: string;
            webhook: Array<{ url: string }> | null;
            email: Array<{ to: string }> | null;
            slack: Array<{ channel: string }> | null;
            pagerduty: Array<{ description: string }> | null;
            opsgenie: Array<{ description: string }> | null;
            victorOps: Array<{ routingKey: string }> | null;
          };
        }>;
      }>;
      overrides: Array<{
        matchers: Array<{ name: string; value: string; type: AlertRouteMatcherType }>;
        notifiers: Array<{
          severity: string;
          repeatInterval: string;
          groupBy: Array<string> | null;
          notifierList: Array<{
            slug: string;
            name: string;
            notifierConfig: {
              id: string;
              slug: string;
              name: string;
              webhook: Array<{ url: string }> | null;
              email: Array<{ to: string }> | null;
              slack: Array<{ channel: string }> | null;
              pagerduty: Array<{ description: string }> | null;
              opsgenie: Array<{ description: string }> | null;
              victorOps: Array<{ routingKey: string }> | null;
            };
          }>;
        }>;
      }>;
    };
  };
};

export type CreateNotificationPolicyMutationVariables = Exact<{
  input: NewAlertNotificationPolicy;
}>;

export type CreateNotificationPolicyMutation = {
  createAlertNotificationPolicy: { slug: string; rules: Array<{ name: string }> };
};

export type UpdateNotificationPolicyMutationVariables = Exact<{
  input: NewAlertNotificationPolicy;
}>;

export type UpdateNotificationPolicyMutation = { updateAlertNotificationPolicy: { rules: Array<{ name: string }> } };

export type DeleteNotificationPolicyMutationVariables = Exact<{
  input: DeleteAlertNotificationPolicy;
}>;

export type DeleteNotificationPolicyMutation = { deleteAlertNotificationPolicy: boolean };

export type GetCollectionNotificationPolicyVariables = Exact<{
  slug: Scalars['String']['input'];
  collectionType: InputMaybe<CollectionType>;
}>;

export type GetCollectionNotificationPolicy = {
  collection: {
    type: CollectionType;
    slug: string;
    policy: {
      name: string;
      slug: string;
      rules: Array<{
        name: string;
        receivers: Array<{
          id: string;
          slug: string;
          name: string;
          webhook: Array<{ url: string }> | null;
          email: Array<{ to: string }> | null;
          slack: Array<{ channel: string }> | null;
          pagerduty: Array<{ description: string }> | null;
          opsgenie: Array<{ description: string }> | null;
          victorOps: Array<{ routingKey: string }> | null;
        }>;
      }>;
      routes: {
        defaults: Array<{
          severity: string;
          notifierList: Array<{ slug: string; name: string; notifierConfig: { name: string; slug: string } }>;
        }>;
        overrides: Array<{
          matchers: Array<{ name: string; value: string; type: AlertRouteMatcherType }>;
          notifiers: Array<{ severity: string; notifierList: Array<{ slug: string; name: string }> }>;
        }>;
      };
    } | null;
  } | null;
};

export type AvailableScopesQueryVariables = Exact<{ [key: string]: never }>;

export type AvailableScopesQuery = {
  globalFilters: Array<{ name: string; defaultValue: string; value: { labelValues: { matcher: string } | null } }>;
};

export type UpdateScopeConfigurationMutationVariables = Exact<{
  input: UpdateGlobalFiltersInput;
}>;

export type UpdateScopeConfigurationMutation = { updateGlobalFilters: Array<{ name: string }> };

export type SearchVariables = Exact<{
  input: SearchQuery;
}>;

export type Search = {
  searchV2: {
    totalCount: number | null;
    items: Array<{
      type: string;
      name: string;
      slug: string;
      isFavorite: boolean;
      isMigratedDashboard: boolean;
      team: { name: string; slug: string } | null;
      collection: { name: string; type: CollectionType; slug: string } | null;
    }>;
  } | null;
};

export type ObjectMergeRulesVariables = Exact<{ [key: string]: never }>;

export type ObjectMergeRules = {
  suppressionExemptServices: Array<string> | null;
  objectMergeRules: Array<{
    status: ObjectMergeRuleStatus;
    action: ObjectMergeRuleAction;
    description: string;
    regex: string | null;
    replacement: string | null;
    sourceLabels: Array<string> | null;
    suppressionRule: { suppressedDiscoveryComponentSlug: string; exceptionServiceNames: Array<string> | null } | null;
  }>;
};

export type GetComponentDiscoveryConfigsVariables = Exact<{ [key: string]: never }>;

export type GetComponentDiscoveryConfigs = {
  componentDiscoveryConfigs: Array<{
    slug: string;
    name: string;
    discovery: {
      metric: {
        objectLabel: string;
        objectMappingLabel: string;
        uniqueLabel: string;
        expr: string;
        markerComponent: boolean | null;
        objectMappingLabelTransform: { regex: string; replacement: string } | null;
        target: { filters: Array<{ name: string; valueGlob: string }> } | null;
        metricMetadata: {
          knownMetrics: Array<{ kind: MetricKind; metricName: string }> | null;
          rpcMetadata: { errorTypeLabel: string; endpointLabel: string } | null;
        } | null;
      } | null;
      trace: { selectServiceAttribute: boolean } | null;
      event: { serviceNameLabel: string } | null;
    };
    discoveryOverride: {
      name: string | null;
      status: ComponentDiscoveryOverrideStatus | null;
      metric: {
        expr: string | null;
        markerComponent: boolean | null;
        objectLabel: string;
        objectMappingLabel: string;
        uniqueLabel: string;
        target: { filters: Array<{ name: string; valueGlob: string }> } | null;
        objectMappingLabelTransform: { regex: string; replacement: string } | null;
      } | null;
    } | null;
    managedBy: { editable: boolean; source: ManagedBySource };
  }>;
};

export type ListComponentPresentationConfigsVariables = Exact<{ [key: string]: never }>;

export type ListComponentPresentationConfigs = {
  listComponentPresentationConfigs: Array<{
    name: string;
    slug: string;
    description: string | null;
    presentationType: ComponentPresentationType;
    numPanelsToDisplay: number | null;
    eligibility: { requiredDiscoverySlugs: Array<string> };
    events: { eventJSONs: Array<any> | null } | null;
    dashboard: { panelCount: number } | null;
    managedBy: { editable: boolean; source: ManagedBySource };
    override: { status: ComponentPresentationOverrideStatus; componentPresentationSlug: string } | null;
  }>;
};

export type ComponentPresentationDetailVariables = Exact<{
  input: ReadPresentationConfigInput;
}>;

export type ComponentPresentationDetail = {
  componentPresentationConfig: {
    slug: string;
    name: string;
    description: string | null;
    numPanelsToDisplay: number | null;
    presentationType: ComponentPresentationType;
    eligibility: {
      requiredDiscoverySlugs: Array<string>;
      withoutDiscoverySlugs: Array<string> | null;
      allowedServiceSlugs: Array<string> | null;
      ignoredServiceSlugs: Array<string> | null;
    };
    override: { componentPresentationSlug: string; status: ComponentPresentationOverrideStatus } | null;
    dashboard: {
      panelJSONs: Array<any> | null;
      panelCount: number;
      serviceTemplateVar: string | null;
      inputJSON: any | null;
      variableJSONs: Array<any> | null;
    } | null;
    managedBy: { editable: boolean; source: ManagedBySource };
  } | null;
};

export type ObjectDiscoveryRulesVariables = Exact<{ [key: string]: never }>;

export type ObjectDiscoveryRules = {
  objectDiscoveryRules: Array<{
    slug: string;
    name: string;
    metric: { effectiveExpr: string; objectLabels: Array<string>; objectMappingLabel: string } | null;
  }>;
};

export type CreateCustomDiscoveryJobVariables = Exact<{
  input: CreateCustomComponentInput;
}>;

export type CreateCustomDiscoveryJob = {
  createCustomComponent: { component: { slug: string }; discovery: { slug: string } } | null;
};

export type DeleteCustomComponentVariables = Exact<{
  input: DeleteCustomComponentInput;
}>;

export type DeleteCustomComponent = { deleteCustomComponent: boolean };

export type CreateCustomDiscoveryVariables = Exact<{
  input: CreateDiscoveryInput;
}>;

export type CreateCustomDiscovery = { createDiscovery: { slug: string } };

export type UpdateCustomDiscoveryVariables = Exact<{
  input: UpdateDiscoveryInput;
}>;

export type UpdateCustomDiscovery = { updateDiscovery: { slug: string } };

export type GetServiceComponentPresentationVariables = Exact<{
  serviceComponentSlug: Scalars['String']['input'];
}>;

export type GetServiceComponentPresentation = {
  customComponent: {
    name: string;
    slug: string;
    serviceTemplateVar: string | null;
    interval: string | null;
    inputJSON: any | null;
  };
};

export type UpdateCustomServiceComponentVariables = Exact<{
  input: UpdateCustomComponentInput;
}>;

export type UpdateCustomServiceComponent = {
  updateCustomComponent: { component: { slug: string }; discovery: { slug: string } } | null;
};

export type GetDiscoveryPipelineMessagesVariables = Exact<{ [key: string]: never }>;

export type GetDiscoveryPipelineMessages = {
  discoveryPipelineStatusMessages: Array<{
    id: number;
    executionID: string;
    componentSlug: string | null;
    objectMergeRuleIdentifier: string | null;
    code: DiscoveryPipelineStatusMessageCode;
    severity: DiscoveryPipelineStatusMessageSeverity;
    message: string;
    labels: Array<{ name: string; value: string }> | null;
  }>;
};

export type ServiceViewAttributes = {
  eventsConfig: Array<any> | null;
  inactive: boolean | null;
  hasChangeEvents: boolean | null;
  service: {
    name: string;
    derivedName: string;
    state: AlertState;
    slug: string;
    description: string;
    policy: { name: string; slug: string } | null;
    team: { name: string; slug: string } | null;
  };
  labelsConfig: Array<{
    name: string;
    traces: { nameMapping: string | null; valueMapping: Array<{ name: string; values: Array<string> }> | null } | null;
    events: { nameMapping: string | null; valueMapping: Array<{ name: string; values: Array<string> }> | null } | null;
  }> | null;
  oemLoggingConfig: { repo: string; fieldName: string } | null;
  components: Array<{
    name: string;
    slug: string;
    moreDetailsJSON: any | null;
    panelJSONs: Array<any> | null;
    variableJSONs: Array<any> | null;
  }> | null;
  chronosphereLoggingConfig: { hasLogs: boolean; loggingServiceValues: Array<string> | null } | null;
};

export type ListPaginatedServicesVariables = Exact<{
  getFullView?: InputMaybe<Scalars['Boolean']['input']>;
  getDiscoveries?: InputMaybe<Scalars['Boolean']['input']>;
  filters: InputMaybe<ServicesFilter>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
}>;

export type ListPaginatedServices = {
  servicesPage: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    services: Array<{
      name: string;
      slug: string;
      state: AlertState;
      derivedName: string;
      createdAt: string;
      monitorStates: Array<{ state: AlertState; monitorCount: number; sloCount: number }> | null;
      team: { name: string; slug: string } | null;
      view?: {
        inactive: boolean | null;
        hasChangeEvents: boolean | null;
        hasTraces: boolean;
        eventsConfig: Array<any> | null;
        components: Array<{ name: string; slug: string }> | null;
      };
      discoveries?: Array<{
        slug: string;
        name: string;
        metric: { sloMetadata: Array<{ sloType: SLOType } | { sloType: SLOType }> | null } | null;
      }> | null;
    }>;
  };
};

export type ListPaginatedServicesAlertVariables = Exact<{
  filters: InputMaybe<ServicesFilter>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
}>;

export type ListPaginatedServicesAlert = {
  servicesPage: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    services: Array<{
      name: string;
      slug: string;
      derivedName: string;
      createdAt: string;
      view: { inactive: boolean | null };
    }>;
  };
};

export type GetServiceOverviewVariables = Exact<{
  serviceSlug: Scalars['String']['input'];
}>;

export type GetServiceOverview = {
  serviceView: {
    eventsConfig: Array<any> | null;
    inactive: boolean | null;
    hasChangeEvents: boolean | null;
    service: {
      name: string;
      derivedName: string;
      state: AlertState;
      slug: string;
      description: string;
      policy: { name: string; slug: string } | null;
      team: { name: string; slug: string } | null;
    };
    labelsConfig: Array<{
      name: string;
      traces: {
        nameMapping: string | null;
        valueMapping: Array<{ name: string; values: Array<string> }> | null;
      } | null;
      events: {
        nameMapping: string | null;
        valueMapping: Array<{ name: string; values: Array<string> }> | null;
      } | null;
    }> | null;
    oemLoggingConfig: { repo: string; fieldName: string } | null;
    components: Array<{
      name: string;
      slug: string;
      moreDetailsJSON: any | null;
      panelJSONs: Array<any> | null;
      variableJSONs: Array<any> | null;
    }> | null;
    chronosphereLoggingConfig: { hasLogs: boolean; loggingServiceValues: Array<string> | null } | null;
  } | null;
};

export type ServiceComponentDetailsViewVariables = Exact<{
  serviceComponentSlug: Scalars['String']['input'];
}>;

export type ServiceComponentDetailsView = {
  serviceComponentViewDetails: {
    eventsConfig: Array<any> | null;
    hasChangeEvents: boolean | null;
    component: { name: string; type: ComponentType; moreDetailsJSON: any | null };
  };
};

export type ListPaginatedMinimalServicesVariables = Exact<{
  filters: InputMaybe<ServicesFilter>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
}>;

export type ListPaginatedMinimalServices = {
  servicesPage: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    services: Array<{ name: string; slug: string }>;
  };
};

export type UpdateServiceAttributeMutationVariables = Exact<{
  input: UpdateServiceAttribute;
}>;

export type UpdateServiceAttributeMutation = { updateServiceAttribute: { slug: string } };

export type GetSloListVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filter: SLOListFilterInput;
  matchers: InputMaybe<Array<NewLabelMatcher> | NewLabelMatcher>;
}>;

export type GetSloList = {
  slos: {
    totalCount: number;
    pageInfo: { cursor: string | null; hasNextPage: boolean };
    slos: Array<{
      name: string;
      slug: string;
      state: AlertState;
      collection:
        | { name: string; slug: string; type: CollectionType; team: { name: string; slug: string } | null }
        | { name: string; slug: string; type: CollectionType; team: { name: string; slug: string } | null };
      definition: { enableBurnRateAlerting: boolean | null; objective: number } | null;
      managedBy: { editable: boolean; source: ManagedBySource };
      signalGrouping: { labelNames: Array<string> | null; signalPerSeries: boolean } | null;
    }>;
  };
};

export type GetSloDetailsVariables = Exact<{
  slug: Scalars['String']['input'];
  matchers: InputMaybe<Array<NewLabelMatcher> | NewLabelMatcher>;
}>;

export type GetSloDetails = {
  slo: {
    createdAt: string;
    description: string | null;
    id: string;
    name: string;
    slug: string;
    state: AlertState;
    annotations: Array<{ name: string; value: string }>;
    collection:
      | {
          __typename: 'Collection';
          name: string;
          slug: string;
          type: CollectionType;
          policy: { name: string; slug: string } | null;
          team: { name: string; slug: string } | null;
        }
      | {
          __typename: 'Service';
          derivedName: string;
          name: string;
          slug: string;
          type: CollectionType;
          policy: { name: string; slug: string } | null;
          team: { name: string; slug: string } | null;
          view: {
            eventsConfig: Array<any> | null;
            labelsConfig: Array<{
              tracing: { valueMapping: Array<{ name: string; values: Array<string> }> | null } | null;
            }> | null;
            oemLoggingConfig: { fieldName: string; repo: string } | null;
          };
        };
    definition: {
      objective: number;
      enableBurnRateAlerting: boolean | null;
      timeWindow: { errorRatioMetric: string; duration: string } | null;
      burnRateAlertingConfig: Array<{
        window: string;
        budget: number;
        severity: ConditionLevel | null;
        labels: Array<{ name: string; value: string }> | null;
      }> | null;
    } | null;
    labels: Array<{ name: string; value: string }> | null;
    managedBy: { editable: boolean; source: ManagedBySource };
    notificationPolicy: { name: string; slug: string } | null;
    signalGrouping: { labelNames: Array<string> | null; signalPerSeries: boolean } | null;
    sli: {
      customDimensionLabels: Array<string> | null;
      additionalPromFilters: Array<{ name: string; type: LabelMatcherType; value: string }> | null;
      rawQueries: { badQuery: string | null; goodQuery: string | null; totalQuery: string } | null;
      templateData: {
        componentDiscoverySlug: string | null;
        endpointLabel: string;
        trackLensService: boolean | null;
        components: Array<{
          moreDetailsJSON: any | null;
          name: string;
          panelJSONs: Array<any> | null;
          slug: string;
          variableJSONs: Array<any> | null;
        }> | null;
        endpointAvailability: { endpointsMonitored: Array<string> | null; errorCodes: Array<string> | null } | null;
        endpointLatency: { endpointsMonitored: Array<string> | null; latencyBucket: string } | null;
        sourceService: { derivedName: string; name: string; slug: string; view: { eventsConfig: Array<any> | null } };
      } | null;
      timeSliceQueries: {
        query: string | null;
        sliceSize: TimesliceSize | null;
        condition: { op: ThresholdOp; value: number } | null;
      } | null;
    };
  };
};

export type GetSloMutingRulesVariables = Exact<{
  slug: Scalars['String']['input'];
  signal: Array<NewAlertRuleLabel> | NewAlertRuleLabel;
  timeRange: NewTimeRange;
}>;

export type GetSloMutingRules = {
  slo: {
    mutingRules: { activeMutingRules: Array<{ endsAt: string; name: string; slug: string; state: MutingRuleState }> };
  };
};

export type GetSloSummariesVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSloSummaries = {
  slos: {
    totalCount: number;
    pageInfo: { cursor: string | null; hasNextPage: boolean };
    slos: Array<{ name: string; slug: string }>;
  };
};

export type CreateSLOMutationVariables = Exact<{
  input: UpdateSLOInput;
}>;

export type CreateSLOMutation = { createSLO: { slug: string } };

export type UpdateSLOMutationVariables = Exact<{
  input: UpdateSLOInput;
}>;

export type UpdateSLOMutation = { updateSLO: { slug: string } };

export type DeleteSloMutationVariables = Exact<{
  input: DeleteSLOInput;
}>;

export type DeleteSloMutation = { deleteSLO: boolean };

export type ServiceDiscoveryMetaVariables = Exact<{
  serviceSlug: Scalars['String']['input'];
}>;

export type ServiceDiscoveryMeta = {
  serviceView: {
    service: {
      discoveries: Array<{
        slug: string;
        name: string;
        metric: {
          sloMetadata: Array<
            | {
                __typename: 'SLOMetadataEndpointAvailability';
                endpointLabel: string;
                errorTypeLabel: string;
                sloType: SLOType;
                allErrorCodes: Array<{ displayName: string | null; isSuccess: boolean | null; value: string }> | null;
              }
            | {
                __typename: 'SLOMetadataLatency';
                classicHistogramMetricName: string | null;
                endpointLabel: string;
                errorTypeLabel: string;
                sloType: SLOType;
                allErrorCodes: Array<{ displayName: string | null; isSuccess: boolean | null; value: string }> | null;
              }
          > | null;
        } | null;
      }> | null;
    };
  } | null;
};

export type ListTeamsVariables = Exact<{ [key: string]: never }>;

export type ListTeams = {
  teams: Array<{
    id: string;
    slug: string;
    name: string;
    description: string;
    isAdmin: boolean;
    managedBy: { editable: boolean; source: ManagedBySource };
    roles: Array<{ name: string }>;
  }>;
};

export type ListTeamHomepageVariables = Exact<{
  teamSlug: Scalars['String']['input'];
}>;

export type ListTeamHomepage = {
  team: {
    id: string;
    name: string;
    slug: string;
    description: string;
    isAdmin: boolean;
    managedBy: { editable: boolean; source: ManagedBySource };
    roles: Array<{ name: string }>;
    users: Array<{
      id: string;
      email: string;
      name: string;
      type: UserType;
      state: UserState;
      roles: Array<{ name: string }>;
    }>;
    homepage: { links: Array<{ name: string; url: string }> | null } | null;
    policies: Array<{ name: string; slug: string; team: { name: string; slug: string } | null }>;
  } | null;
};

export type CreateTeamMutationVariables = Exact<{
  input: NewTeam;
}>;

export type CreateTeamMutation = { createTeam: { id: string; slug: string } };

export type UpdateTeamMutationVariables = Exact<{
  input: UpdateTeam;
}>;

export type UpdateTeamMutation = { updateTeam: { id: string } };

export type DeleteTeamMutationVariables = Exact<{
  input: DeleteTeam;
}>;

export type DeleteTeamMutation = { deleteTeam: boolean };

export type UpdateTeamHomepageVariables = Exact<{
  input: SaveTeamHomepageInput;
}>;

export type UpdateTeamHomepage = { saveTeamHomepage: { slug: string } };

export type BulkUpdateTeamMutationVariables = Exact<{
  input: BulkUpdateTeam;
}>;

export type BulkUpdateTeamMutation = { bulkUpdateTeam: { addedIDs: Array<string>; removedIDs: Array<string> } };

export type UserSettingsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type UserSettingsQuery = { userSettingsValue: any | null };

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UserSettingsValueInput;
}>;

export type UpdateUserSettingsMutation = { setUserSettingsValue: boolean };

export type LoadUsersVariables = Exact<{ [key: string]: never }>;

export type LoadUsers = {
  users: Array<{ __typename: 'User'; id: string; email: string; state: UserState; roles: Array<{ name: string }> }>;
  serviceAccounts: Array<{
    __typename: 'ServiceAccount';
    id: string;
    name: string;
    email: string;
    roles: Array<{ name: string }>;
  }>;
};

export type LoadUsersSidebarVariables = Exact<{
  excludeServiceAccounts: Scalars['Boolean']['input'];
}>;

export type LoadUsersSidebar = {
  users: Array<{ __typename: 'User'; id: string; email: string; isAdmin: boolean; state: UserState }>;
  serviceAccounts?: Array<{ __typename: 'ServiceAccount'; id: string; name: string; email: string; isAdmin: boolean }>;
};

export type LoadUserDetailsVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;

export type LoadUserDetails = {
  user: {
    id: string;
    email: string;
    state: UserState;
    inviteURL: string | null;
    token: string | null;
    name: string;
    type: UserType;
    roles: Array<{ name: string }>;
    teams: Array<{ id: string; name: string; slug: string; roles: Array<{ name: string }> }>;
    auditLog: { items: Array<{ id: string; eventCode: string; eventTime: string; eventDescription: string }> | null };
  } | null;
};

export type CreatePersonalAccessTokenMutationVariables = Exact<{
  input: CreatePersonalAccessTokenInput;
}>;

export type CreatePersonalAccessTokenMutation = {
  createPersonalAccessToken: {
    token: string;
    metadata: { name: string; expiresAt: string; slug: string; status: string; createdAt: string };
  };
};

export type DeletePersonalAccessTokensMutationVariables = Exact<{
  input: DeletePersonalAccessTokensInput;
}>;

export type DeletePersonalAccessTokensMutation = { deletePersonalAccessTokens: boolean };

export type RevokeAllPersonalAccessTokensMutationVariables = Exact<{ [key: string]: never }>;

export type RevokeAllPersonalAccessTokensMutation = { revokeAllPersonalAccessTokens: boolean };

export type LoadMyAccountVariables = Exact<{ [key: string]: never }>;

export type LoadMyAccount = { me: { id: string; email: string }; tenant: { id: string; name: string } };

export type PersonalAccessTokensListVariables = Exact<{ [key: string]: never }>;

export type PersonalAccessTokensList = {
  personalAccessTokens: Array<{ name: string; slug: string; status: string; createdAt: string; expiresAt: string }>;
};

export type WebhookSigningKeyVariables = Exact<{ [key: string]: never }>;

export type WebhookSigningKey = { webhookSigningKey: string };

export type GetRollupRulesVariables = Exact<{ [key: string]: never }>;

export type GetRollupRules = {
  rollupRules: Array<{
    addMetricTypeLabel: boolean;
    aggregationType: AggregationType;
    createdAt: string;
    dropRaw: boolean;
    expansiveMatch: boolean;
    interval: string | null;
    metricName: string;
    metricType: MetricType;
    mode: RollupRuleMode;
    name: string;
    slug: string;
    source: EditSource;
    updatedAt: string;
    filters: Array<{ name: string; value: string }>;
    graphiteLabelPolicy: { replace: Array<{ name: string; newValue: string } | null> | null } | null;
    labelPolicy: { discard: Array<string> | null; keep: Array<string> | null } | null;
    labelReplace: Array<{
      dstLabelName: string | null;
      keepLabel: boolean | null;
      labelValueRegex: string | null;
      newLabelValue: string;
      srcLabelName: string;
    }> | null;
    storagePolicy: { resolution: string; retention: string } | null;
  }>;
};

export type RollupRuleValue = {
  addMetricTypeLabel: boolean;
  aggregationType: AggregationType;
  createdAt: string;
  dropRaw: boolean;
  expansiveMatch: boolean;
  interval: string | null;
  metricName: string;
  metricType: MetricType;
  mode: RollupRuleMode;
  name: string;
  slug: string;
  source: EditSource;
  updatedAt: string;
  filters: Array<{ name: string; value: string }>;
  graphiteLabelPolicy: { replace: Array<{ name: string; newValue: string } | null> | null } | null;
  labelPolicy: { discard: Array<string> | null; keep: Array<string> | null } | null;
  labelReplace: Array<{
    dstLabelName: string | null;
    keepLabel: boolean | null;
    labelValueRegex: string | null;
    newLabelValue: string;
    srcLabelName: string;
  }> | null;
  storagePolicy: { resolution: string; retention: string } | null;
};

export type GetMappingRulesVariables = Exact<{ [key: string]: never }>;

export type GetMappingRules = {
  mappingRules: Array<{
    createdAt: string;
    drop: boolean;
    mode: MappingRuleMode;
    name: string;
    slug: string;
    source: EditSource;
    updatedAt: string;
    aggregationPolicy: {
      aggregation: AggregationType;
      dropTimestamp: boolean;
      interval: string | null;
      storagePolicy: { resolution: string; retention: string } | null;
    } | null;
    filters: Array<{ name: string; value: string }>;
  }>;
};

export type MappingRuleValue = {
  createdAt: string;
  drop: boolean;
  mode: MappingRuleMode;
  name: string;
  slug: string;
  source: EditSource;
  updatedAt: string;
  aggregationPolicy: {
    aggregation: AggregationType;
    dropTimestamp: boolean;
    interval: string | null;
    storagePolicy: { resolution: string; retention: string } | null;
  } | null;
  filters: Array<{ name: string; value: string }>;
};

export type GetDashboardsBySlugsVariables = Exact<{
  slugs: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type GetDashboardsBySlugs = {
  allDashboards: {
    dashboards: Array<
      | { slug: string; name: string; collection: { name: string; nullableTeam: { name: string } | null } | null }
      | { slug: string; name: string; collection: { name: string; nullableTeam: { name: string } | null } | null }
    >;
  };
};

export type GetEventLogByIdVariables = Exact<{
  id: Scalars['String']['input'];
}>;

export type GetEventLogById = {
  eventLog: {
    id: string;
    userEmail: string;
    userId: string;
    eventCode: string;
    eventDescription: string;
    eventTime: string;
    applicationName: string;
    methodName: string;
    resourceName: string;
    dataJson: string;
  };
};

export type GetEventLogsVariables = Exact<{
  pageToken: InputMaybe<Scalars['Int']['input']>;
  excludeServiceAccounts: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetEventLogs = {
  eventLogs: {
    nextPageToken: number;
    items: Array<{
      id: string;
      userEmail: string;
      eventCode: string;
      eventDescription: string;
      eventTime: string;
    }> | null;
  };
};

export type ImportDashboardMutationVariables = Exact<{
  input: ImportGrafanaDashboard;
}>;

export type ImportDashboardMutation = { importGrafanaDashboard: { slug: string } };

export type MigrateDashboardVariables = Exact<{
  slug: Scalars['String']['input'];
  nativeConfig: Scalars['JSONObject']['input'];
}>;

export type MigrateDashboard = { migrateGrafanaDashboard: { slug: string } };

export type CreateTestDashboardVariables = Exact<{
  input: SaveDashboardInput;
}>;

export type CreateTestDashboard = { saveDashboard: { slug: string; name: string } };

export type DeleteTestDashboardVariables = Exact<{
  input: DeleteDashboard;
}>;

export type DeleteTestDashboard = { deleteDashboard: boolean };

export type CreateTestGrafanaDashboardVariables = Exact<{
  input: GrafanaDashboardSettings;
}>;

export type CreateTestGrafanaDashboard = { saveGrafanaDashboardSettings: { slug: string; name: string } };

export type CreateTestGrafanaDashboardWithImportVariables = Exact<{
  input: ImportGrafanaDashboard;
}>;

export type CreateTestGrafanaDashboardWithImport = { importGrafanaDashboard: { slug: string; name: string } };

export type DeleteTestGrafanaDashboardVariables = Exact<{
  input: DeleteGrafanaDashboard;
}>;

export type DeleteTestGrafanaDashboard = { deleteGrafanaDashboard: boolean };

export type LoadDashboardSettingsVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type LoadDashboardSettings = {
  grafanaDashboard: {
    slug: string;
    source: EditSource;
    name: string;
    collection: {
      slug: string;
      name: string;
      description: string;
      source: EditSource;
      type: CollectionType;
      nullableTeam: { slug: string; name: string } | null;
      policy: { slug: string } | null;
    } | null;
    labels: Array<{ name: string; value: string }> | null;
  } | null;
};

export type DeleteGrafanaDashboardMutationVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type DeleteGrafanaDashboardMutation = { deleteGrafanaDashboard: boolean };

export type LoadDuplicateDashboardSettingsVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type LoadDuplicateDashboardSettings = {
  grafanaDashboard: {
    slug: string;
    source: EditSource;
    name: string;
    dashboardJSON: string;
    collection: {
      slug: string;
      name: string;
      description: string;
      source: EditSource;
      type: CollectionType;
      nullableTeam: { slug: string; name: string } | null;
      policy: { slug: string } | null;
    } | null;
    labels: Array<{ name: string; value: string }> | null;
  } | null;
};

export type DuplicateDashboardVariables = Exact<{
  input: ImportGrafanaDashboard;
}>;

export type DuplicateDashboard = { importGrafanaDashboard: { slug: string } };

export type GetDashboardForMigrationVariables = Exact<{
  slugs: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type GetDashboardForMigration = {
  allDashboards: {
    dashboards: Array<
      | { slug: string; config: any; source: EditSource; type: 'Dashboard' }
      | { slug: string; config: any; source: EditSource; type: 'GrafanaDashboard' }
    >;
  };
};

export type GetDashboardVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetDashboard = {
  dashboard: {
    slug: string;
    name: string;
    config: any;
    isFavorite: boolean;
    managedBy: { editable: boolean; source: ManagedBySource };
    labels: Array<{ name: string; value: string }> | null;
    collection: {
      slug: string;
      name: string;
      type: CollectionType;
      nullableTeam: { slug: string; name: string } | null;
    } | null;
    collectionLinks: Array<{
      slug: string;
      collection: {
        name: string;
        slug: string;
        type: CollectionType;
        nullableTeam: { name: string; slug: string } | null;
      };
    }> | null;
  };
};

export type GetDashboardTimestampsVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetDashboardTimestamps = {
  dashboard: { slug: string; name: string; createdAt: string; updatedAt: string };
};

export type ListRecentDashboardsVariables = Exact<{
  slugs: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  excludeMigratedGrafana: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListRecentDashboards = {
  allDashboards: {
    dashboards: Array<
      | {
          __typename: 'Dashboard';
          slug: string;
          name: string;
          isFavorite: boolean;
          collection: { name: string; slug: string; nullableTeam: { name: string; slug: string } | null } | null;
        }
      | {
          __typename: 'GrafanaDashboard';
          slug: string;
          name: string;
          isFavorite: boolean;
          collection: { name: string; slug: string; nullableTeam: { name: string; slug: string } | null } | null;
        }
    >;
  };
};

export type DerivedLabelModel = {
  slug: string;
  name: string;
  labelName: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
  existingLabelPolicy: DerivedLabelPolicy | null;
  source: EditSource;
  metricLabel: {
    mappingLabel: {
      nameMappings: Array<{
        sourceLabel: string;
        filters: Array<{ name: string; valueGlob: string }> | null;
        valueMappings: Array<{ sourceValueGlobs: Array<string> | null; targetValue: string }> | null;
      }> | null;
      valueMappings: Array<{ sourceValueGlobs: Array<string> | null; targetValue: string }> | null;
    } | null;
    constructedLabel: {
      valueDefinitions: Array<{ value: string; filters: Array<{ name: string; valueGlob: string }> | null }> | null;
    } | null;
  } | null;
  derivedLabelSpanTag: { nameMappings: Array<{ sourceTag: string }> | null } | null;
};

export type FetchDerivedLabelsVariables = Exact<{
  slugs: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;

export type FetchDerivedLabels = {
  derivedLabels: {
    derivedLabels: Array<{
      slug: string;
      name: string;
      labelName: string;
      description: string | null;
      createdAt: string;
      updatedAt: string;
      existingLabelPolicy: DerivedLabelPolicy | null;
      source: EditSource;
      metricLabel: {
        mappingLabel: {
          nameMappings: Array<{
            sourceLabel: string;
            filters: Array<{ name: string; valueGlob: string }> | null;
            valueMappings: Array<{ sourceValueGlobs: Array<string> | null; targetValue: string }> | null;
          }> | null;
          valueMappings: Array<{ sourceValueGlobs: Array<string> | null; targetValue: string }> | null;
        } | null;
        constructedLabel: {
          valueDefinitions: Array<{ value: string; filters: Array<{ name: string; valueGlob: string }> | null }> | null;
        } | null;
      } | null;
      derivedLabelSpanTag: { nameMappings: Array<{ sourceTag: string }> | null } | null;
    }> | null;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
  };
};

export type FetchDerivedLabelVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type FetchDerivedLabel = {
  derivedLabel: {
    slug: string;
    name: string;
    labelName: string;
    description: string | null;
    createdAt: string;
    updatedAt: string;
    existingLabelPolicy: DerivedLabelPolicy | null;
    source: EditSource;
    metricLabel: {
      mappingLabel: {
        nameMappings: Array<{
          sourceLabel: string;
          filters: Array<{ name: string; valueGlob: string }> | null;
          valueMappings: Array<{ sourceValueGlobs: Array<string> | null; targetValue: string }> | null;
        }> | null;
        valueMappings: Array<{ sourceValueGlobs: Array<string> | null; targetValue: string }> | null;
      } | null;
      constructedLabel: {
        valueDefinitions: Array<{ value: string; filters: Array<{ name: string; valueGlob: string }> | null }> | null;
      } | null;
    } | null;
    derivedLabelSpanTag: { nameMappings: Array<{ sourceTag: string }> | null } | null;
  } | null;
};

export type PreviewDerivedLabelVariables = Exact<{
  input: DerivedLabelPreviewInput;
}>;

export type PreviewDerivedLabel = {
  previewDerivedLabel: {
    allValues: Array<string>;
    nameMappings: Array<{ sourceLabel: string; values: Array<string> }>;
  };
};

export type CreateDerivedLabelVariables = Exact<{
  input: CreateDerivedLabelInput;
}>;

export type CreateDerivedLabel = {
  createDerivedLabel: {
    slug: string;
    name: string;
    labelName: string;
    description: string | null;
    createdAt: string;
    updatedAt: string;
    existingLabelPolicy: DerivedLabelPolicy | null;
    source: EditSource;
    metricLabel: {
      mappingLabel: {
        nameMappings: Array<{
          sourceLabel: string;
          filters: Array<{ name: string; valueGlob: string }> | null;
          valueMappings: Array<{ sourceValueGlobs: Array<string> | null; targetValue: string }> | null;
        }> | null;
        valueMappings: Array<{ sourceValueGlobs: Array<string> | null; targetValue: string }> | null;
      } | null;
      constructedLabel: {
        valueDefinitions: Array<{ value: string; filters: Array<{ name: string; valueGlob: string }> | null }> | null;
      } | null;
    } | null;
    derivedLabelSpanTag: { nameMappings: Array<{ sourceTag: string }> | null } | null;
  };
};

export type UpdateDerivedLabelVariables = Exact<{
  input: UpdateDerivedLabelInput;
}>;

export type UpdateDerivedLabel = {
  updateDerivedLabel: {
    slug: string;
    name: string;
    labelName: string;
    description: string | null;
    createdAt: string;
    updatedAt: string;
    existingLabelPolicy: DerivedLabelPolicy | null;
    source: EditSource;
    metricLabel: {
      mappingLabel: {
        nameMappings: Array<{
          sourceLabel: string;
          filters: Array<{ name: string; valueGlob: string }> | null;
          valueMappings: Array<{ sourceValueGlobs: Array<string> | null; targetValue: string }> | null;
        }> | null;
        valueMappings: Array<{ sourceValueGlobs: Array<string> | null; targetValue: string }> | null;
      } | null;
      constructedLabel: {
        valueDefinitions: Array<{ value: string; filters: Array<{ name: string; valueGlob: string }> | null }> | null;
      } | null;
    } | null;
    derivedLabelSpanTag: { nameMappings: Array<{ sourceTag: string }> | null } | null;
  };
};

export type DeleteDerivedLabelVariables = Exact<{
  input: DeleteDerivedLabelInput;
}>;

export type DeleteDerivedLabel = { deleteDerivedLabel: boolean };

export type ListRecentlyTriggeredAlertsVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
}>;

export type ListRecentlyTriggeredAlerts = {
  alerts: {
    totalCount: number;
    pageInfo: { cursor: string | null; hasNextPage: boolean };
    alerts: Array<{
      currentMutedStatus: boolean;
      currentSeverity: AlertDatastoreSeverity;
      currentStatus: AlertDatastoreStatus;
      id: string;
      name: string;
      signal: Array<{ name: string; value: string }>;
    }>;
  };
};

export type CreateTestDropRuleVariables = Exact<{
  input: NewDropRule;
}>;

export type CreateTestDropRule = { createDropRule: { slug: string } };

export type DeleteTestDropRuleMutationVariables = Exact<{
  input: DeleteDropRule;
}>;

export type DeleteTestDropRuleMutation = { deleteDropRule: boolean };

export type GetDropRulesVariables = Exact<{ [key: string]: never }>;

export type GetDropRules = {
  dropRules: Array<{
    slug: string;
    mode: DropRuleMode;
    name: string;
    source: EditSource;
    createdAt: string;
    updatedAt: string;
    dropNanValue: boolean | null;
    filters: Array<{ name: string; value: string }>;
    valueBasedDrop: { enabled: boolean; targetDropValue: number } | null;
  }>;
};

export type DropRuleValue = {
  slug: string;
  mode: DropRuleMode;
  name: string;
  source: EditSource;
  createdAt: string;
  updatedAt: string;
  dropNanValue: boolean | null;
  filters: Array<{ name: string; value: string }>;
  valueBasedDrop: { enabled: boolean; targetDropValue: number } | null;
};

export type DeleteDropRuleMutationVariables = Exact<{
  input: DeleteDropRule;
}>;

export type DeleteDropRuleMutation = { deleteDropRule: boolean };

export type CreateDropRuleMutationVariables = Exact<{
  input: NewDropRule;
}>;

export type CreateDropRuleMutation = { createDropRule: { slug: string } };

export type UpdateDropRuleMutationVariables = Exact<{
  input: UpdateDropRule;
}>;

export type UpdateDropRuleMutation = { updateDropRule: { slug: string } };

export type LoadLoggingConsumptionSnapshotVariables = Exact<{ [key: string]: never }>;

export type LoadLoggingConsumptionSnapshot = {
  loggingContracts: Array<{ startDate: string; endDate: string; state: LoggingContractState }>;
};

export type GetLoggedInTestUserIdVariables = Exact<{ [key: string]: never }>;

export type GetLoggedInTestUserId = { me: { id: string } };

export type DeleteTestSignupUserVariables = Exact<{
  input: DeleteUserInput;
}>;

export type DeleteTestSignupUser = { deleteUser: boolean };

export type GetLogIngestConfigVariables = Exact<{ [key: string]: never }>;

export type GetLogIngestConfig = {
  logIngestConfig: {
    createdAt: string;
    updatedAt: string;
    plaintextParsers: Array<{
      __typename: 'PlaintextParser';
      mode: ParserMode;
      name: string;
      keepOriginal: boolean | null;
      parser: { __typename: 'LogParser'; parserType: LogParserType; regexParser: { regex: string } | null };
    }>;
    fieldParsers: Array<{
      __typename: 'LogFieldParser';
      mode: ParserMode;
      source: { selector: string };
      destination: { selector: string } | null;
      parser: {
        __typename: 'LogParser';
        parserType: LogParserType;
        regexParser: { regex: string } | null;
        keyValueParser: { pairSeparator: string; delimiter: string; trimSet: string | null } | null;
      };
    }>;
    fieldNormalization: {
      primaryKey: {
        target: string;
        normalization: {
          defaultValue: string | null;
          valueMap: string | null;
          sanitizePatterns: Array<string>;
          source: Array<{ selector: string }>;
        };
      } | null;
      timestamp: { source: Array<{ selector: string }> } | null;
      severity: {
        defaultValue: string | null;
        valueMap: string | null;
        sanitizePatterns: Array<string>;
        source: Array<{ selector: string }>;
      } | null;
      message: {
        defaultValue: string | null;
        valueMap: string | null;
        sanitizePatterns: Array<string>;
        source: Array<{ selector: string }>;
      } | null;
      customFieldNormalization: Array<{
        target: string;
        normalization: {
          defaultValue: string | null;
          valueMap: string | null;
          sanitizePatterns: Array<string>;
          source: Array<{ selector: string }>;
        };
      }>;
    } | null;
  };
};

export type GetLogIngestConfigDefaultsVariables = Exact<{ [key: string]: never }>;

export type GetLogIngestConfigDefaults = {
  logIngestConfigDefaults: {
    severity: { valueMap: string | null } | null;
    message: { valueMap: string | null } | null;
    customFieldNormalization: Array<{ target: string; normalization: { valueMap: string | null } }>;
  };
};

export type ValidateFilterQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;

export type ValidateFilterQuery = { validateFilterQuery: { valid: boolean; error: string | null } };

export type LoadLogsControlRulesVariables = Exact<{ [key: string]: never }>;

export type LoadLogsControlRules = {
  logControlConfig: {
    rules: Array<{
      name: string;
      mode: LogControlRuleMode;
      filter: string;
      type: LogControlRuleType;
      sample: { rate: number } | null;
      dropField: { fieldRegex: string; parentPath: { selector: string } | null } | null;
      emitMetrics: {
        mode: EmitMetricsMode;
        name: string;
        dropLog: boolean;
        labels: Array<{ key: string; value: { selector: string } }>;
        counter: { value: { selector: string } | null } | null;
        gauge: { aggregationType: EmitMetricsGaugeAggregationType; value: { selector: string } } | null;
        histogram: { value: { selector: string } } | null;
      } | null;
      replaceField: {
        replaceRegex: string;
        replaceAll: boolean;
        replaceMode: ReplaceFieldMode;
        field: { selector: string };
        staticValue: { value: string } | null;
        mappedValue: { useDefault: boolean; defaultValue: string; pairs: Array<{ key: string; value: string }> } | null;
      } | null;
    }>;
  };
};

export type LoadLogLookupTableVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type LoadLogLookupTable = {
  logLookupTable: {
    id: string;
    slug: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    description: string | null;
    updatedBy: string;
    status: LogLookupTableStatus;
    errorDetails: LogLookupTableErrorDetails | null;
    downloadURL: string | null;
  } | null;
};

export type LoadLogLookupTablesVariables = Exact<{
  name: InputMaybe<Scalars['String']['input']>;
}>;

export type LoadLogLookupTables = {
  logLookupTables: Array<{
    id: string;
    slug: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    description: string | null;
    updatedBy: string;
    status: LogLookupTableStatus;
    errorDetails: LogLookupTableErrorDetails | null;
    fileSizeBytes: number;
    downloadURL: string | null;
  }>;
};

export type GenerateLogLookupTableUploadUrlVariables = Exact<{ [key: string]: never }>;

export type GenerateLogLookupTableUploadUrl = { generateLogLookupTableUploadURL: { url: string; filePath: string } };

export type CreateLogLookupTableVariables = Exact<{
  input: CreateLogLookupTableInput;
}>;

export type CreateLogLookupTable = {
  createLogLookupTable: {
    id: string;
    slug: string;
    name: string;
    createdAt: string;
    updatedAt: string;
    description: string | null;
    updatedBy: string;
    status: LogLookupTableStatus;
    errorDetails: LogLookupTableErrorDetails | null;
    fileSizeBytes: number;
    downloadURL: string | null;
  };
};

export type MetricDDXVariables = Exact<{
  req: MetricDDXRequest;
}>;

export type MetricDDX = { metricDDX: { allLabelNames: Array<string> | null; queryByLabelName: string } };

export type MonitorSignalQueryVariables = Exact<{
  expression: Scalars['String']['input'];
  signals: InputMaybe<
    | Array<InputMaybe<Array<NewAlertRuleLabel> | NewAlertRuleLabel>>
    | InputMaybe<Array<NewAlertRuleLabel> | NewAlertRuleLabel>
  >;
  queryType: InputMaybe<DatasourceType>;
}>;

export type MonitorSignalQuery = { monitorSignalQuery: string };

export type GetPaginatedAlertEventsListVariables = Exact<{
  monitorSlugs: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  latestFirst: InputMaybe<Scalars['Boolean']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
  timeRange: InputMaybe<NewTimeRange>;
  eventTypes: InputMaybe<Array<AlertEventType> | AlertEventType>;
  signals: InputMaybe<
    | Array<InputMaybe<Array<NewAlertRuleLabel> | NewAlertRuleLabel>>
    | InputMaybe<Array<NewAlertRuleLabel> | NewAlertRuleLabel>
  >;
  signalFilters: InputMaybe<Array<NewAlertRouteMatcher> | NewAlertRouteMatcher>;
}>;

export type GetPaginatedAlertEventsList = {
  alertEvents: {
    alertEvents: Array<{
      monitorSlug: string;
      eventType: AlertEventType;
      createdAt: string;
      signal: Array<{ name: string; value: string }>;
      details:
        | {
            __typename: 'MonitorMuted';
            severity: ConditionLevel;
            mutingRulesObj: { mutingRules: Array<{ slug: string }> };
          }
        | { __typename: 'MonitorResolvedAlertEvent'; severity: ConditionLevel }
        | {
            __typename: 'MonitorResolvedNotificationFailedToSend';
            severity: ConditionLevel;
            error: string;
            notifier: { name: string; slug: string };
          }
        | {
            __typename: 'MonitorResolvedNotificationSent';
            severity: ConditionLevel;
            notifier: { name: string; slug: string };
          }
        | { __typename: 'MonitorTriggeredAlertEvent'; severity: ConditionLevel }
        | {
            __typename: 'MonitorTriggeredNotificationFailedToSend';
            severity: ConditionLevel;
            error: string;
            notifier: { name: string; slug: string };
          }
        | {
            __typename: 'MonitorTriggeredNotificationSent';
            severity: ConditionLevel;
            notifier: { name: string; slug: string };
          }
        | {
            __typename: 'MonitorUnmuted';
            severity: ConditionLevel;
            mutingRulesObj: { mutingRules: Array<{ slug: string }> };
          };
    }>;
    pageInfo: { cursor: string | null; hasNextPage: boolean };
  };
};

export type GetTenantDataSourceSettingsVariables = Exact<{ [key: string]: never }>;

export type GetTenantDataSourceSettings = {
  tenant: {
    id: string;
    graphiteEnabled: boolean;
    loggingDataSourceEnabled: boolean;
    settings: { alertsIntervalsSeconds: Array<number> | null; loggingAlertsIntervalSeconds: Array<number> | null };
  };
};

export type CreateMonitorMutationVariables = Exact<{
  input: NewMonitor;
}>;

export type CreateMonitorMutation = { createMonitor: { slug: string; name: string } };

export type DeleteMonitorMutationVariables = Exact<{
  input: DeleteMonitor;
}>;

export type DeleteMonitorMutation = { deleteMonitor: boolean };

export type LoadMonitorEditorVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type LoadMonitorEditor = {
  monitor: {
    slug: string;
    name: string;
    collection: { slug: string; name: string; type: CollectionType };
    collectionLinks: Array<{ collection: { name: string } }> | null;
    managedBy: { editable: boolean; source: ManagedBySource };
    labels: Array<{ name: string; value: string }> | null;
    annotations: Array<{ name: string; value: string }> | null;
    policy: {
      policy: {
        name: string;
        slug: string;
        routes: {
          defaults: Array<{
            severity: string;
            notifierList: Array<{ slug: string; name: string; notifierConfig: { name: string; slug: string } }>;
          }>;
          overrides: Array<{
            matchers: Array<{ name: string; value: string; type: AlertRouteMatcherType }>;
            notifiers: Array<{ severity: string; notifierList: Array<{ slug: string; name: string }> }>;
          }>;
        };
      };
    } | null;
    spec: {
      interval: string;
      query: { queryExpression: string; queryDatasource: DatasourceType };
      signalGrouping: { labelNames: Array<string> | null; signalPerSeries: boolean };
      seriesConditions: {
        defaults: Array<{
          conditionLevel: ConditionLevel;
          conditions: Array<{ sustain: string; op: ThresholdOp; value: number; resolveSustain: string }> | null;
        }> | null;
        overrides: Array<{
          matchers: Array<{ name: string; value: string; type: AlertRouteMatcherType }> | null;
          conditions: Array<{
            conditionLevel: ConditionLevel;
            conditions: Array<{ sustain: string; op: ThresholdOp; value: number; resolveSustain: string }> | null;
          }> | null;
        }> | null;
      };
      schedule: {
        timezone: string;
        weeklySchedule: Array<{ ranges: Array<{ start: string; end: string }> } | null> | null;
      } | null;
    };
  };
};

export type UpdateMonitorMutationVariables = Exact<{
  input: UpdatedMonitor;
}>;

export type UpdateMonitorMutation = { updateMonitor: { slug: string; name: string } };

export type GetFullMonitorVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetFullMonitor = {
  monitor: {
    name: string;
    slug: string;
    isFavorite: boolean;
    collection: {
      slug: string;
      name: string;
      type: CollectionType;
      nullableTeam: { id: string; name: string; slug: string } | null;
      policy: { name: string; slug: string } | null;
    };
    collectionLinks: Array<{
      slug: string;
      collection: {
        name: string;
        slug: string;
        type: CollectionType;
        nullableTeam: { name: string; slug: string } | null;
      };
    }> | null;
    matchingRoutesAndConditions: {
      signal: Array<{ name: string; value: string }>;
      conditions: {
        defaults: Array<{
          conditionLevel: ConditionLevel;
          conditions: Array<{ sustain: string; op: ThresholdOp; value: number; resolveSustain: string }> | null;
        }> | null;
        overrides: Array<{
          matchers: Array<{ name: string; value: string; type: AlertRouteMatcherType }> | null;
          conditions: Array<{
            conditionLevel: ConditionLevel;
            conditions: Array<{ sustain: string; op: ThresholdOp; value: number; resolveSustain: string }> | null;
          }> | null;
        }> | null;
      };
      routes: {
        defaults: Array<{
          severity: string;
          repeatInterval: string;
          groupBy: Array<string> | null;
          notifierList: Array<{ name: string; slug: string; notifierConfig: { name: string; slug: string } }>;
        }>;
        overrides: Array<{
          matchers: Array<{ name: string; value: string; type: AlertRouteMatcherType }>;
          notifiers: Array<{
            repeatInterval: string;
            severity: string;
            groupBy: Array<string> | null;
            notifierList: Array<{ name: string; slug: string }>;
          }>;
        }>;
      };
    } | null;
    policy: {
      policy: {
        name: string;
        slug: string;
        routes: {
          defaults: Array<{
            severity: string;
            notifierList: Array<{ slug: string; name: string; notifierConfig: { name: string; slug: string } }>;
          }>;
          overrides: Array<{
            matchers: Array<{ name: string; value: string; type: AlertRouteMatcherType }>;
            notifiers: Array<{ severity: string; notifierList: Array<{ slug: string; name: string }> }>;
          }>;
        };
      };
    } | null;
    annotations: Array<{ name: string; value: string }> | null;
    labels: Array<{ name: string; value: string }> | null;
    state: { state: AlertState };
    spec: {
      interval: string;
      query: { queryDatasource: DatasourceType; queryExpression: string };
      signalGrouping: { labelNames: Array<string> | null; signalPerSeries: boolean };
      seriesConditions: {
        defaults: Array<{
          conditionLevel: ConditionLevel;
          conditions: Array<{ sustain: string; op: ThresholdOp; value: number; resolveSustain: string }> | null;
        }> | null;
        overrides: Array<{
          matchers: Array<{ name: string; value: string; type: AlertRouteMatcherType }> | null;
          conditions: Array<{
            conditionLevel: ConditionLevel;
            conditions: Array<{ sustain: string; op: ThresholdOp; value: number; resolveSustain: string }> | null;
          }> | null;
        }> | null;
      };
    };
  };
};

export type GetMutingRulesForMonitorVariables = Exact<{
  monitorSlug: Scalars['ID']['input'];
  signal: Array<NewAlertRuleLabel> | NewAlertRuleLabel;
  timeRange: NewTimeRange;
}>;

export type GetMutingRulesForMonitor = {
  mutingRulesForMonitor: {
    activeMutingRules: Array<{
      name: string;
      slug: string;
      id: string;
      startsAt: string;
      endsAt: string;
      comment: string;
      createdBy: string;
      state: MutingRuleState;
      matchers: Array<{ name: string; value: string; type: LabelMatcherType }>;
    }>;
    expiredMutingRules: Array<{
      name: string;
      slug: string;
      id: string;
      startsAt: string;
      endsAt: string;
      comment: string;
      createdBy: string;
      state: MutingRuleState;
      matchers: Array<{ name: string; value: string; type: LabelMatcherType }>;
    }>;
  };
};

export type GetMonitorRoutesAndConditionsVariables = Exact<{
  monitorSlug: Scalars['String']['input'];
  signals: Array<Array<NewAlertRuleLabel> | NewAlertRuleLabel> | Array<NewAlertRuleLabel> | NewAlertRuleLabel;
}>;

export type GetMonitorRoutesAndConditions = {
  matchingMonitorRoutesAndConditions: Array<{
    signal: Array<{ name: string; value: string }>;
    conditions: {
      defaults: Array<{
        conditionLevel: ConditionLevel;
        conditions: Array<{ sustain: string; op: ThresholdOp; value: number; resolveSustain: string }> | null;
      }> | null;
      overrides: Array<{
        matchers: Array<{ type: AlertRouteMatcherType; name: string; value: string }> | null;
        conditions: Array<{
          conditionLevel: ConditionLevel;
          conditions: Array<{ op: ThresholdOp; value: number; sustain: string; resolveSustain: string }> | null;
        }> | null;
      }> | null;
    };
    routes: {
      defaults: Array<{
        severity: string;
        notifierList: Array<{ slug: string; name: string; notifierConfig: { name: string; slug: string } }>;
      }>;
      overrides: Array<{
        matchers: Array<{ type: AlertRouteMatcherType; name: string; value: string }>;
        notifiers: Array<{ severity: string; notifierList: Array<{ name: string; slug: string }> }>;
      }>;
    };
  }>;
};

export type GetMonitorEventFiltersVariables = Exact<{
  pageInfo: MonitorInformation;
}>;

export type GetMonitorEventFilters = {
  monitorsPageEventFilters: { filters: Array<{ queries: Array<string>; description: string }> };
};

export type GetMonitorGroupingsVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetMonitorGroupings = {
  monitor: {
    slug: string;
    spec: { signalGrouping: { labelNames: Array<string> | null; signalPerSeries: boolean } };
    state: {
      state: AlertState;
      signals: Array<{
        state: AlertState;
        labels: Array<{ name: string; value: string }> | null;
        series: Array<{
          status: {
            status: AlertState;
            startedAt: string | null;
            updatedAt: string | null;
            labels: Array<{ name: string; value: string }> | null;
          };
        }> | null;
      }> | null;
    };
  };
};

export type GetMonitorSummariesVariables = Exact<{ [key: string]: never }>;

export type GetMonitorSummaries = { monitorSummaries: Array<{ slug: string; name: string }> };

export type UpdateMutingRuleMutationVariables = Exact<{
  input: NewMutingRule;
}>;

export type UpdateMutingRuleMutation = { updateMutingRule: { id: string } };

export type CreateMutingRuleMutationVariables = Exact<{
  input: NewMutingRule;
}>;

export type CreateMutingRuleMutation = { createMutingRule: { slug: string } };

export type GetMutingRuleDetailsVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetMutingRuleDetails = {
  mutingRule: {
    slug: string;
    name: string;
    startsAt: string;
    endsAt: string;
    createdBy: string;
    comment: string;
    state: MutingRuleState;
    matchers: Array<{ type: LabelMatcherType; name: string; value: string }>;
  };
};

export type GetMutingRulesQueryVariables = Exact<{
  filters: MutingRulePageFilters;
  after: InputMaybe<Scalars['String']['input']>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetMutingRulesQuery = {
  mutingRulesPage: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    mutingRules: Array<{
      id: string;
      slug: string;
      state: MutingRuleState;
      startsAt: string;
      endsAt: string;
      name: string;
      comment: string;
      createdBy: string;
      matchers: Array<{ name: string; value: string; type: LabelMatcherType }>;
    }>;
  };
};

export type DeleteAlertReceiverMutationVariables = Exact<{
  input: DeleteAlertReceiver;
}>;

export type DeleteAlertReceiverMutation = { deleteAlertReceiver: boolean };

export type NotifiersValue = {
  id: string;
  source: EditSource;
  name: string;
  isGlobal: boolean;
  webhook: Array<{ url: string; baseConfig: { sendResolved: boolean } | null }> | null;
  slack: Array<{
    apiURL: string;
    channel: string;
    username: string;
    baseConfig: { sendResolved: boolean } | null;
  }> | null;
  email: Array<{ to: string; html: string; baseConfig: { sendResolved: boolean } | null }> | null;
  pagerduty: Array<{
    serviceKey: string;
    severity: string;
    url: string;
    baseConfig: { sendResolved: boolean } | null;
  }> | null;
  opsgenie: Array<{ apiURL: string; apiKey: string; baseConfig: { sendResolved: boolean } | null }> | null;
  victorOps: Array<{
    apiURL: string;
    apiKey: string;
    routingKey: string;
    baseConfig: { sendResolved: boolean } | null;
  }> | null;
};

export type GetNotifiersQueryVariables = Exact<{ [key: string]: never }>;

export type GetNotifiersQuery = {
  alertReceivers: {
    receivers: Array<{
      id: string;
      source: EditSource;
      name: string;
      isGlobal: boolean;
      webhook: Array<{ url: string; baseConfig: { sendResolved: boolean } | null }> | null;
      slack: Array<{
        apiURL: string;
        channel: string;
        username: string;
        baseConfig: { sendResolved: boolean } | null;
      }> | null;
      email: Array<{ to: string; html: string; baseConfig: { sendResolved: boolean } | null }> | null;
      pagerduty: Array<{
        serviceKey: string;
        severity: string;
        url: string;
        baseConfig: { sendResolved: boolean } | null;
      }> | null;
      opsgenie: Array<{ apiURL: string; apiKey: string; baseConfig: { sendResolved: boolean } | null }> | null;
      victorOps: Array<{
        apiURL: string;
        apiKey: string;
        routingKey: string;
        baseConfig: { sendResolved: boolean } | null;
      }> | null;
    }>;
  };
};

export type CreateTestNotifierMutationVariables = Exact<{
  input: NewAlertReceiver;
}>;

export type CreateTestNotifierMutation = { createAlertReceiver: { slug: string; name: string } };

export type DeleteTestNotifierMutationVariables = Exact<{
  input: DeleteAlertReceiver;
}>;

export type DeleteTestNotifierMutation = { deleteAlertReceiver: boolean };

export type CreateAlertReceiverMutationVariables = Exact<{
  input: NewAlertReceiver;
}>;

export type CreateAlertReceiverMutation = { createAlertReceiver: { id: string } };

export type UpdateAlertReceiverMutationVariables = Exact<{
  input: UpdateAlertReceiver;
}>;

export type UpdateAlertReceiverMutation = { patchAlertReceiver: { id: string } };

export type GetRecordingRulesQueryVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filters: RecordingRulesFilters;
}>;

export type GetRecordingRulesQuery = {
  recordingRules: {
    totalCount: number;
    rules: Array<{
      id: string;
      name: string;
      interval: string;
      expr: string;
      executionGroup: string | null;
      metricName: string | null;
      labels: Array<{ value: string; name: string }>;
    }>;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
  };
};

export type GetRuleEvaluationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetRuleEvaluationsQuery = {
  ruleEvaluations: {
    totalMonitors: number;
    totalRecordingRules: number;
    evaluations: Array<{
      ruleID: string;
      ruleSlug: string;
      ruleFrequency: string;
      ruleName: string;
      ruleType: RuleEvaluationRuleType;
      errorCode: RuleEvaluationErrorCode;
      window: RuleEvaluationWindow;
      value: number;
      message: string;
    }>;
  };
};

export type CreateServiceAccountMutationVariables = Exact<{
  input: CreateServiceAccountInput;
}>;

export type CreateServiceAccountMutation = { createServiceAccount: { token: string; serviceAccount: { id: string } } };

export type GetServiceAccountsVariables = Exact<{
  includeLastUsedAt: Scalars['Boolean']['input'];
}>;

export type GetServiceAccounts = {
  serviceAccounts: Array<{
    source: EditSource;
    id: string;
    name: string;
    email: string;
    createdBy: string;
    lastUsedAt?: string | null;
    permission: PermissionAction;
    labels: Array<{ name: string; value: string }>;
  }>;
};

export type DeleteServiceAccountsMutationVariables = Exact<{
  input: DeleteServiceAccountsInput;
}>;

export type DeleteServiceAccountsMutation = { deleteServiceAccounts: boolean };

export type GetDiscoveryConfigExpressionVariables = Exact<{
  input: ComponentDiscoveryOverrideInput;
}>;

export type GetDiscoveryConfigExpression = { discoveryOverrideEffectiveExpr: string };

export type ServiceDiscoveryPreviewVariables = Exact<{
  input: DiscoveryConfigsInput;
  presentationInput: InputMaybe<Array<ComponentPresentationDiffInput> | ComponentPresentationDiffInput>;
}>;

export type ServiceDiscoveryPreview = {
  previewServiceDiscovery: {
    compressedDebugLogs: string | null;
    services: Array<{
      name: string;
      slug: string;
      status: DiscoveryStatus;
      discoveredComponents: Array<{ slug: string; status: DiscoveryStatus }>;
      presentationComponents: Array<{ slug: string; status: DiscoveryStatus }>;
    }>;
  } | null;
};

export type PresentationDiscoveryEligibilityVariables = Exact<{
  input: EligibleServicesInput;
}>;

export type PresentationDiscoveryEligibility = {
  eligibleServices: { services: Array<{ name: string; slug: string }> };
};

export type ServicePresentationCreateVariables = Exact<{
  input: CreatePresentationInput;
}>;

export type ServicePresentationCreate = {
  createPresentation: {
    slug: string;
    name: string;
    description: string | null;
    presentationType: ComponentPresentationType;
    managedBy: { editable: boolean; source: ManagedBySource };
    dashboard: { panelCount: number } | null;
    override: { componentPresentationSlug: string; status: ComponentPresentationOverrideStatus } | null;
  };
};

export type ServicePresentationPanelsVariables = Exact<{
  input: CreatePresentationInput;
}>;

export type ServicePresentationPanels = { createPresentation: { dashboard: { panelJSONs: Array<any> | null } | null } };

export type ServicePresentationUpdateVariables = Exact<{
  input: UpdatePresentationInput;
}>;

export type ServicePresentationUpdate = {
  updatePresentation: {
    name: string;
    slug: string;
    description: string | null;
    presentationType: ComponentPresentationType;
    dashboard: { panelCount: number } | null;
    managedBy: { editable: boolean; source: ManagedBySource };
    override: { componentPresentationSlug: string; status: ComponentPresentationOverrideStatus } | null;
  };
};

export type ServicePresentationDeleteVariables = Exact<{
  input: DeletePresentationInput;
}>;

export type ServicePresentationDelete = { deletePresentation: boolean };

export type ApplyCurrentServiceConfigurationVariables = Exact<{
  discoveryInput: DiscoveryConfigsInput;
  presentationInput: PresentationConfigsInput;
}>;

export type ApplyCurrentServiceConfiguration = { updateDiscoveryConfigs: boolean; updatePresentationConfigs: boolean };

export type RunServiceDiscoveryVariables = Exact<{
  debugLogFilter: InputMaybe<DebugLogFilter>;
}>;

export type RunServiceDiscovery = {
  runServiceDiscovery: { compressedDebugLogs: string | null; services: Array<{ name: string }> } | null;
};

export type GetRelatedServicesVariables = Exact<{
  filters: ServicesFilter;
}>;

export type GetRelatedServices = {
  servicesPage: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    services: Array<{ name: string; slug: string }>;
  };
};

export type LookupShortUrlVariables = Exact<{
  hash: Scalars['String']['input'];
}>;

export type LookupShortUrl = { shortenedMessage: { hash: string; message: string } };

export type GetSloServiceDashboardsVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  filter: InputMaybe<AllDashboardsFilter>;
}>;

export type GetSloServiceDashboards = {
  allDashboards: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    dashboards: Array<
      | {
          __typename: 'Dashboard';
          name: string;
          slug: string;
          collection: { name: string; slug: string; type: CollectionType } | null;
        }
      | {
          __typename: 'GrafanaDashboard';
          name: string;
          slug: string;
          collection: { name: string; slug: string; type: CollectionType } | null;
        }
    >;
  };
};

export type ListRecentSlosVariables = Exact<{
  slugs: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type ListRecentSlos = { slos: { slos: Array<{ slug: string; name: string }> } };

export type GetPreviewSloQueriesVariables = Exact<{
  input: SLOQueriesInput;
}>;

export type GetPreviewSloQueries = {
  sloQueries: {
    rawAvailability: string | null;
    rawError: string | null;
    rawTotal: string | null;
    dimensionLabelNames: Array<string> | null;
    effectiveHighErrorRateMonitorQuery: string | null;
    effectiveLowErrorRateMonitorQuery: string | null;
  };
};

export type ListTeamServicesVariables = Exact<{
  filters: InputMaybe<ServicesFilter>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
}>;

export type ListTeamServices = {
  servicesPage: {
    totalCount: number;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
    services: Array<{
      name: string;
      slug: string;
      state: AlertState;
      monitorStates: Array<{ state: AlertState; monitorCount: number; sloCount: number }> | null;
    }>;
  };
};

export type ListChangeEventCategoriesVariables = Exact<{
  includeDeleted: Scalars['Boolean']['input'];
}>;

export type ListChangeEventCategories = {
  timelineCategories: Array<{ Name: string; Deleted: boolean; FieldValue: string }>;
};

export type GetTimelineSearchHistoryVariables = Exact<{
  userID: InputMaybe<Scalars['String']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  onlySaved: InputMaybe<Scalars['Boolean']['input']>;
  onlyShared: InputMaybe<Scalars['Boolean']['input']>;
  searchType: InputMaybe<SearchType>;
}>;

export type GetTimelineSearchHistory = {
  userSearchHistory: {
    searchHistories: Array<{
      id: string;
      updatedAt: string | null;
      name: string | null;
      saved: boolean;
      shared: boolean;
      search: { query: string; columns: Array<string> | null };
    }>;
  };
};

export type UpdateSearchHistoryVariables = Exact<{
  id: Scalars['String']['input'];
  input: UpdateSearchHistoryInput;
}>;

export type UpdateSearchHistory = {
  updateUserSearchHistory: {
    id: string;
    updatedAt: string | null;
    name: string | null;
    shared: boolean;
    search: { query: string; columns: Array<string> | null };
  };
};

export type CreateTraceMetricsRuleVariables = Exact<{
  input: CreateTraceMetricsRuleInput;
}>;

export type CreateTraceMetricsRule = { createTraceMetricsRule: { slug: string; metricName: string } };

export type DeleteTraceMetricsRuleVariables = Exact<{
  input: DeleteTraceMetricsRuleInput;
}>;

export type DeleteTraceMetricsRule = { deleteTraceMetricsRule: boolean };

export type TraceBehaviorValue = {
  name: string;
  slug: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
  baseHeadSampleRate: number | null;
  baseTailSampleRate: number | null;
  fastSampleOptions: {
    sampleRate: number;
    maxDurationSeconds: number;
    enabled: boolean;
    samplingType: TraceBehaviorSamplingType;
  } | null;
  slowSampleOptions: {
    sampleRate: number;
    minDurationSeconds: number;
    enabled: boolean;
    samplingType: TraceBehaviorSamplingType;
  } | null;
  errorSampleOptions: { sampleRate: number; enabled: boolean; samplingType: TraceBehaviorSamplingType } | null;
  largeTraceSampleOptions: {
    sampleRate: number;
    spanCountThreshold: number;
    enabled: boolean;
    samplingType: TraceBehaviorSamplingType;
  } | null;
  smallTraceSampleOptions: {
    sampleRate: number;
    spanCountThreshold: number;
    enabled: boolean;
    samplingType: TraceBehaviorSamplingType;
  } | null;
};

export type GetTraceActiveBehaviorsVariables = Exact<{
  datasetSlugs: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  behaviorSlugs: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  timeRange: InputMaybe<BetweenTimeFilterInput>;
  includeFutureBehaviors: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetTraceActiveBehaviors = {
  traceActiveBehaviors: {
    activeBehaviors: Array<{
      dataset: string;
      behavior: string | null;
      startTime: string;
      endTime: string | null;
      assignmentType: TraceBehaviorAssignmentType;
      description: string;
      createdBy: string;
      createdAt: string;
      updatedAt: string;
    }> | null;
    futureActiveBehaviors: Array<{
      dataset: string;
      behavior: string | null;
      startTime: string;
      endTime: string | null;
      assignmentType: TraceBehaviorAssignmentType;
      description: string;
      createdBy: string;
      createdAt: string;
      updatedAt: string;
    }> | null;
  };
};

export type GetTraceBehaviorConfigVariables = Exact<{ [key: string]: never }>;

export type GetTraceBehaviorConfig = {
  traceBehaviorConfig: {
    datasetPriorities: Array<string>;
    version: number;
    baselineBehaviorSlug: string | null;
    mainBehaviorAssignments: Array<{
      dataset: string;
      behavior: string;
      createdBy: string;
      description: string;
      createdAt: string;
      updatedAt: string;
    }>;
    overrideBehaviorAssignments: Array<{
      dataset: string;
      behavior: string;
      startTime: string;
      endTime: string;
      createdBy: string;
      description: string;
      createdAt: string;
      updatedAt: string;
    }> | null;
    previewBehaviorAssignments: Array<{
      dataset: string;
      behavior: string;
      startTime: string;
      endTime: string;
      createdBy: string;
      description: string;
      createdAt: string;
      updatedAt: string;
    }> | null;
  } | null;
};

export type GetTraceBehaviorsVariables = Exact<{ [key: string]: never }>;

export type GetTraceBehaviors = {
  traceBehaviors: {
    behaviors: Array<{
      name: string;
      slug: string;
      description: string | null;
      createdAt: string;
      updatedAt: string;
      baseHeadSampleRate: number | null;
      baseTailSampleRate: number | null;
      fastSampleOptions: {
        sampleRate: number;
        maxDurationSeconds: number;
        enabled: boolean;
        samplingType: TraceBehaviorSamplingType;
      } | null;
      slowSampleOptions: {
        sampleRate: number;
        minDurationSeconds: number;
        enabled: boolean;
        samplingType: TraceBehaviorSamplingType;
      } | null;
      errorSampleOptions: { sampleRate: number; enabled: boolean; samplingType: TraceBehaviorSamplingType } | null;
      largeTraceSampleOptions: {
        sampleRate: number;
        spanCountThreshold: number;
        enabled: boolean;
        samplingType: TraceBehaviorSamplingType;
      } | null;
      smallTraceSampleOptions: {
        sampleRate: number;
        spanCountThreshold: number;
        enabled: boolean;
        samplingType: TraceBehaviorSamplingType;
      } | null;
    }> | null;
  };
};

export type UpdateTraceBehaviorConfigVariables = Exact<{
  input: UpdateTraceBehaviorConfigInput;
}>;

export type UpdateTraceBehaviorConfig = {
  updateTraceBehaviorConfig: {
    datasetPriorities: Array<string>;
    version: number;
    baselineBehaviorSlug: string | null;
    mainBehaviorAssignments: Array<{ dataset: string; behavior: string; createdBy: string; description: string }>;
    overrideBehaviorAssignments: Array<{
      dataset: string;
      behavior: string;
      startTime: string;
      endTime: string;
      createdBy: string;
      description: string;
    }> | null;
  };
};

export type DeleteTraceBehaviorVariables = Exact<{
  input: DeleteTraceBehaviorInput;
}>;

export type DeleteTraceBehavior = { deleteTraceBehavior: boolean };

export type CreateTraceBehaviorVariables = Exact<{
  input: CreateTraceBehaviorInput;
}>;

export type CreateTraceBehavior = {
  createTraceBehavior: {
    name: string;
    slug: string;
    description: string | null;
    createdAt: string;
    updatedAt: string;
    baseHeadSampleRate: number | null;
    baseTailSampleRate: number | null;
    fastSampleOptions: {
      sampleRate: number;
      maxDurationSeconds: number;
      enabled: boolean;
      samplingType: TraceBehaviorSamplingType;
    } | null;
    slowSampleOptions: {
      sampleRate: number;
      minDurationSeconds: number;
      enabled: boolean;
      samplingType: TraceBehaviorSamplingType;
    } | null;
    errorSampleOptions: { sampleRate: number; enabled: boolean; samplingType: TraceBehaviorSamplingType } | null;
    largeTraceSampleOptions: {
      sampleRate: number;
      spanCountThreshold: number;
      enabled: boolean;
      samplingType: TraceBehaviorSamplingType;
    } | null;
    smallTraceSampleOptions: {
      sampleRate: number;
      spanCountThreshold: number;
      enabled: boolean;
      samplingType: TraceBehaviorSamplingType;
    } | null;
  };
};

export type UpdateTraceBehaviorVariables = Exact<{
  input: UpdateTraceBehaviorInput;
}>;

export type UpdateTraceBehavior = {
  updateTraceBehavior: {
    name: string;
    slug: string;
    description: string | null;
    createdAt: string;
    updatedAt: string;
    baseHeadSampleRate: number | null;
    baseTailSampleRate: number | null;
    fastSampleOptions: {
      sampleRate: number;
      maxDurationSeconds: number;
      enabled: boolean;
      samplingType: TraceBehaviorSamplingType;
    } | null;
    slowSampleOptions: {
      sampleRate: number;
      minDurationSeconds: number;
      enabled: boolean;
      samplingType: TraceBehaviorSamplingType;
    } | null;
    errorSampleOptions: { sampleRate: number; enabled: boolean; samplingType: TraceBehaviorSamplingType } | null;
    largeTraceSampleOptions: {
      sampleRate: number;
      spanCountThreshold: number;
      enabled: boolean;
      samplingType: TraceBehaviorSamplingType;
    } | null;
    smallTraceSampleOptions: {
      sampleRate: number;
      spanCountThreshold: number;
      enabled: boolean;
      samplingType: TraceBehaviorSamplingType;
    } | null;
  };
};

export type TraceDatasetEnhancementValue = {
  persistedTotalVolumeBytes: number;
  persistedUniqueVolumeBytes: number;
  processedTotalVolumeBytes: number;
  processedUniqueVolumeBytes: number;
};

export type TraceDatasetConfigurationValue = {
  filter: {
    trace: { duration: { minSeconds: number; maxSeconds: number } | null; error: { value: boolean } | null } | null;
    span: Array<{
      matchType: SpanFilterMatchType;
      service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
      operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
      parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
      parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
      duration: { minSeconds: number; maxSeconds: number } | null;
      error: { value: boolean } | null;
      inCriticalPath: { value: boolean } | null;
      isRootSpan: { value: boolean } | null;
      leafError: { value: boolean } | null;
      tags: Array<{
        key: string;
        value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
        numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
      }>;
      spanCount: { min: number; max: number; isMinExclusive: boolean | null; isMaxExclusive: boolean | null } | null;
    }>;
    scope: {
      spanScopes: Array<{
        matchType: SpanFilterMatchType;
        service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
        operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
        parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
        parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
        duration: { minSeconds: number; maxSeconds: number } | null;
        error: { value: boolean } | null;
        inCriticalPath: { value: boolean } | null;
        isRootSpan: { value: boolean } | null;
        leafError: { value: boolean } | null;
        tags: Array<{
          key: string;
          value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
        }>;
        spanCount: { min: number; max: number; isMinExclusive: boolean | null; isMaxExclusive: boolean | null } | null;
      }> | null;
    } | null;
  };
};

export type DatasetValue = {
  name: string;
  slug: string;
  description: string;
  createdAt: string;
  updatedAt: string;
  type: DatasetType;
  source: EditSource;
  managedBy: { editable: boolean; source: ManagedBySource };
  configuration:
    | { __typename: 'LogDatasetConfiguration' }
    | {
        __typename: 'TraceDatasetConfiguration';
        filter: {
          trace: {
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
          } | null;
          span: Array<{
            matchType: SpanFilterMatchType;
            service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
            inCriticalPath: { value: boolean } | null;
            isRootSpan: { value: boolean } | null;
            leafError: { value: boolean } | null;
            tags: Array<{
              key: string;
              value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
            }>;
            spanCount: {
              min: number;
              max: number;
              isMinExclusive: boolean | null;
              isMaxExclusive: boolean | null;
            } | null;
          }>;
          scope: {
            spanScopes: Array<{
              matchType: SpanFilterMatchType;
              service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
              inCriticalPath: { value: boolean } | null;
              isRootSpan: { value: boolean } | null;
              leafError: { value: boolean } | null;
              tags: Array<{
                key: string;
                value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
              }>;
              spanCount: {
                min: number;
                max: number;
                isMinExclusive: boolean | null;
                isMaxExclusive: boolean | null;
              } | null;
            }> | null;
          } | null;
        };
      };
  enhancements: {
    __typename: 'TraceDatasetEnhancement';
    persistedTotalVolumeBytes: number;
    persistedUniqueVolumeBytes: number;
    processedTotalVolumeBytes: number;
    processedUniqueVolumeBytes: number;
  } | null;
};

export type GetDatasetVariables = Exact<{
  slug: Scalars['String']['input'];
  enhancements: InputMaybe<DatasetEnhancementsInput>;
}>;

export type GetDataset = {
  dataset: {
    name: string;
    slug: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    type: DatasetType;
    source: EditSource;
    managedBy: { editable: boolean; source: ManagedBySource };
    configuration:
      | { __typename: 'LogDatasetConfiguration' }
      | {
          __typename: 'TraceDatasetConfiguration';
          filter: {
            trace: {
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
            } | null;
            span: Array<{
              matchType: SpanFilterMatchType;
              service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
              inCriticalPath: { value: boolean } | null;
              isRootSpan: { value: boolean } | null;
              leafError: { value: boolean } | null;
              tags: Array<{
                key: string;
                value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
              }>;
              spanCount: {
                min: number;
                max: number;
                isMinExclusive: boolean | null;
                isMaxExclusive: boolean | null;
              } | null;
            }>;
            scope: {
              spanScopes: Array<{
                matchType: SpanFilterMatchType;
                service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                duration: { minSeconds: number; maxSeconds: number } | null;
                error: { value: boolean } | null;
                inCriticalPath: { value: boolean } | null;
                isRootSpan: { value: boolean } | null;
                leafError: { value: boolean } | null;
                tags: Array<{
                  key: string;
                  value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                  numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
                }>;
                spanCount: {
                  min: number;
                  max: number;
                  isMinExclusive: boolean | null;
                  isMaxExclusive: boolean | null;
                } | null;
              }> | null;
            } | null;
          };
        };
    enhancements: {
      __typename: 'TraceDatasetEnhancement';
      persistedTotalVolumeBytes: number;
      persistedUniqueVolumeBytes: number;
      processedTotalVolumeBytes: number;
      processedUniqueVolumeBytes: number;
    } | null;
  } | null;
};

export type GetDatasetsVariables = Exact<{
  filter: InputMaybe<DatasetsListFilterInput>;
  enhancements: InputMaybe<DatasetEnhancementsInput>;
}>;

export type GetDatasets = {
  datasets: {
    datasets: Array<{
      name: string;
      slug: string;
      description: string;
      createdAt: string;
      updatedAt: string;
      type: DatasetType;
      source: EditSource;
      managedBy: { editable: boolean; source: ManagedBySource };
      configuration:
        | { __typename: 'LogDatasetConfiguration' }
        | {
            __typename: 'TraceDatasetConfiguration';
            filter: {
              trace: {
                duration: { minSeconds: number; maxSeconds: number } | null;
                error: { value: boolean } | null;
              } | null;
              span: Array<{
                matchType: SpanFilterMatchType;
                service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                duration: { minSeconds: number; maxSeconds: number } | null;
                error: { value: boolean } | null;
                inCriticalPath: { value: boolean } | null;
                isRootSpan: { value: boolean } | null;
                leafError: { value: boolean } | null;
                tags: Array<{
                  key: string;
                  value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                  numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
                }>;
                spanCount: {
                  min: number;
                  max: number;
                  isMinExclusive: boolean | null;
                  isMaxExclusive: boolean | null;
                } | null;
              }>;
              scope: {
                spanScopes: Array<{
                  matchType: SpanFilterMatchType;
                  service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                  operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                  parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                  parentOperation: {
                    match: StringFilterMatchType;
                    value: string;
                    inValues: Array<string> | null;
                  } | null;
                  duration: { minSeconds: number; maxSeconds: number } | null;
                  error: { value: boolean } | null;
                  inCriticalPath: { value: boolean } | null;
                  isRootSpan: { value: boolean } | null;
                  leafError: { value: boolean } | null;
                  tags: Array<{
                    key: string;
                    value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                    numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
                  }>;
                  spanCount: {
                    min: number;
                    max: number;
                    isMinExclusive: boolean | null;
                    isMaxExclusive: boolean | null;
                  } | null;
                }> | null;
              } | null;
            };
          };
      enhancements: {
        __typename: 'TraceDatasetEnhancement';
        persistedTotalVolumeBytes: number;
        persistedUniqueVolumeBytes: number;
        processedTotalVolumeBytes: number;
        processedUniqueVolumeBytes: number;
      } | null;
    }>;
  };
};

export type DeleteDatasetVariables = Exact<{
  input: DeleteDatasetInput;
}>;

export type DeleteDataset = { deleteDataset: boolean };

export type GetUnassignedDatasetVariables = Exact<{
  type: DatasetType;
  enhancements: InputMaybe<DatasetEnhancementsInput>;
}>;

export type GetUnassignedDataset = {
  unassignedDataset: {
    name: string;
    slug: string;
    description: string;
    createdAt: string;
    updatedAt: string;
    type: DatasetType;
    source: EditSource;
    managedBy: { editable: boolean; source: ManagedBySource };
    configuration:
      | { __typename: 'LogDatasetConfiguration' }
      | {
          __typename: 'TraceDatasetConfiguration';
          filter: {
            trace: {
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
            } | null;
            span: Array<{
              matchType: SpanFilterMatchType;
              service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
              inCriticalPath: { value: boolean } | null;
              isRootSpan: { value: boolean } | null;
              leafError: { value: boolean } | null;
              tags: Array<{
                key: string;
                value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
              }>;
              spanCount: {
                min: number;
                max: number;
                isMinExclusive: boolean | null;
                isMaxExclusive: boolean | null;
              } | null;
            }>;
            scope: {
              spanScopes: Array<{
                matchType: SpanFilterMatchType;
                service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                duration: { minSeconds: number; maxSeconds: number } | null;
                error: { value: boolean } | null;
                inCriticalPath: { value: boolean } | null;
                isRootSpan: { value: boolean } | null;
                leafError: { value: boolean } | null;
                tags: Array<{
                  key: string;
                  value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                  numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
                }>;
                spanCount: {
                  min: number;
                  max: number;
                  isMinExclusive: boolean | null;
                  isMaxExclusive: boolean | null;
                } | null;
              }> | null;
            } | null;
          };
        };
    enhancements: {
      __typename: 'TraceDatasetEnhancement';
      persistedTotalVolumeBytes: number;
      persistedUniqueVolumeBytes: number;
      processedTotalVolumeBytes: number;
      processedUniqueVolumeBytes: number;
    } | null;
  } | null;
};

export type CreateDatasetVariables = Exact<{
  input: CreateDatasetInput;
}>;

export type CreateDataset = { createDataset: { slug: string } };

export type UpdateDatasetVariables = Exact<{
  input: UpdateDatasetInput;
}>;

export type UpdateDataset = { updateDataset: { slug: string } };

export type GetTraceHeadSamplingRulesVariables = Exact<{
  serviceNames: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
  nameOrServiceContains: InputMaybe<Scalars['String']['input']>;
}>;

export type GetTraceHeadSamplingRules = {
  traceJaegerRemoteSamplingStrategies: {
    foundStrategies: Array<{
      slug: string;
      name: string;
      createdAt: string;
      updatedAt: string;
      lastAccessedAt: string | null;
      service: string;
      appliedStrategy:
        | {
            __typename: 'JaegerRemotePerOperationSamplingStrategies';
            defaultSamplingRate: number;
            defaultLowerBoundTracesPerSecond: number;
            defaultUpperBoundTracesPerSecond: number;
            perOperationSamplingStrategies: Array<{
              operation: string;
              probabilisticStrategy: { samplingRate: number };
            }> | null;
          }
        | { __typename: 'JaegerRemoteSamplingProbabilisticStrategy'; samplingRate: number }
        | { __typename: 'JaegerRemoteSamplingRateLimitingSamplingStrategy'; maxTracesPerSecond: number };
    }>;
    pageInfo: { hasNextPage: boolean; cursor: string | null };
  };
};

export type GetTraceTailSamplingRulesVariables = Exact<{ [key: string]: never }>;

export type GetTraceTailSamplingRules = {
  traceTailSamplingRules: {
    createdAt: string;
    updatedAt: string;
    rules: Array<{
      createdAt: string;
      updatedAt: string;
      name: string;
      systemName: string;
      sampleRate: number;
      filter: {
        trace: { duration: { minSeconds: number; maxSeconds: number } | null; error: { value: boolean } | null } | null;
        span: Array<{
          matchType: SpanFilterMatchType;
          service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          duration: { minSeconds: number; maxSeconds: number } | null;
          error: { value: boolean } | null;
          inCriticalPath: { value: boolean } | null;
          isRootSpan: { value: boolean } | null;
          leafError: { value: boolean } | null;
          tags: Array<{
            key: string;
            value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
          }>;
          spanCount: {
            min: number;
            max: number;
            isMinExclusive: boolean | null;
            isMaxExclusive: boolean | null;
          } | null;
        }>;
        scope: {
          spanScopes: Array<{
            matchType: SpanFilterMatchType;
            service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
            inCriticalPath: { value: boolean } | null;
            isRootSpan: { value: boolean } | null;
            leafError: { value: boolean } | null;
            tags: Array<{
              key: string;
              value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
            }>;
            spanCount: {
              min: number;
              max: number;
              isMinExclusive: boolean | null;
              isMaxExclusive: boolean | null;
            } | null;
          }> | null;
        } | null;
      };
    }>;
    defaultSampleRate: { enabled: boolean; sampleRate: number };
  };
};

export type GetLinkTemplateVariables = Exact<{
  slug: Scalars['String']['input'];
}>;

export type GetLinkTemplate = {
  linkTemplate: { name: string; urlTemplate: string; slug: string; createdAt: string; updatedAt: string } | null;
};

export type GetLinkTemplatesVariables = Exact<{ [key: string]: never }>;

export type GetLinkTemplates = {
  linkTemplates: Array<{ name: string; urlTemplate: string; slug: string; createdAt: string; updatedAt: string }>;
};

export type CreateLinkTemplateVariables = Exact<{
  input: CreateLinkTemplateInput;
}>;

export type CreateLinkTemplate = { createLinkTemplate: { slug: string } };

export type UpdateLinkTemplateVariables = Exact<{
  input: UpdateLinkTemplateInput;
}>;

export type UpdateLinkTemplate = { updateLinkTemplate: { slug: string } };

export type DeleteLinkTemplateVariables = Exact<{
  input: DeleteLinkTemplateInput;
}>;

export type DeleteLinkTemplate = { deleteLinkTemplate: boolean };

export type TracingRecentSearchesVariables = Exact<{ [key: string]: never }>;

export type TracingRecentSearches = {
  traceSearchHistory: {
    traceSearchHistories: Array<{
      id: string;
      createdAt: string;
      search: {
        criteria: {
          scope: {
            spanScopes: Array<{
              matchType: SpanFilterMatchType;
              service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
              inCriticalPath: { value: boolean } | null;
              isRootSpan: { value: boolean } | null;
              leafError: { value: boolean } | null;
              tags: Array<{
                key: string;
                value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
              }>;
              spanCount: {
                min: number;
                max: number;
                isMinExclusive: boolean | null;
                isMaxExclusive: boolean | null;
              } | null;
            }> | null;
          } | null;
          trace: {
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
          } | null;
          span: Array<{
            matchType: SpanFilterMatchType;
            service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
            inCriticalPath: { value: boolean } | null;
            isRootSpan: { value: boolean } | null;
            leafError: { value: boolean } | null;
            tags: Array<{
              key: string;
              value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
            }>;
            spanCount: {
              min: number;
              max: number;
              isMinExclusive: boolean | null;
              isMaxExclusive: boolean | null;
            } | null;
          }>;
        };
        time:
          | { minTimestamp: string; maxTimestamp: string }
          | { timestamp: string }
          | { startRelativeOffsetSeconds: number; endRelativeOffsetSeconds: number | null };
        aggregationOptions: {
          focus: { criticalPathOnly: boolean | null; terminalErrorsOnly: boolean | null } | null;
          shape: {
            groupBy: Array<{ key: string | null; type: TraceAggregationGroupByType; value: string | null }>;
          } | null;
        } | null;
      };
      comparison: {
        criteria: {
          scope: {
            spanScopes: Array<{
              matchType: SpanFilterMatchType;
              service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
              inCriticalPath: { value: boolean } | null;
              isRootSpan: { value: boolean } | null;
              leafError: { value: boolean } | null;
              tags: Array<{
                key: string;
                value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
              }>;
              spanCount: {
                min: number;
                max: number;
                isMinExclusive: boolean | null;
                isMaxExclusive: boolean | null;
              } | null;
            }> | null;
          } | null;
          trace: {
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
          } | null;
          span: Array<{
            matchType: SpanFilterMatchType;
            service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
            inCriticalPath: { value: boolean } | null;
            isRootSpan: { value: boolean } | null;
            leafError: { value: boolean } | null;
            tags: Array<{
              key: string;
              value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
            }>;
            spanCount: {
              min: number;
              max: number;
              isMinExclusive: boolean | null;
              isMaxExclusive: boolean | null;
            } | null;
          }>;
        };
        time:
          | { minTimestamp: string; maxTimestamp: string }
          | { timestamp: string }
          | { startRelativeOffsetSeconds: number; endRelativeOffsetSeconds: number | null };
        aggregationOptions: {
          focus: { criticalPathOnly: boolean | null; terminalErrorsOnly: boolean | null } | null;
          shape: {
            groupBy: Array<{ key: string | null; type: TraceAggregationGroupByType; value: string | null }>;
          } | null;
        } | null;
      } | null;
    }>;
  };
};

export type CreateTracingRecentSearchVariables = Exact<{
  input: CreateTraceSearchHistoryInput;
}>;

export type CreateTracingRecentSearch = { createTraceSearchHistory: { id: string } };

export type CreateSavedTraceSearchVariables = Exact<{
  input: CreateSavedTraceSearchInput;
}>;

export type CreateSavedTraceSearch = { createSavedTraceSearch: { createdAt: string; slug: string } };

export type UpdateSavedTraceSearchVariables = Exact<{
  input: UpdateSavedTraceSearchInput;
}>;

export type UpdateSavedTraceSearch = { updatedSavedTraceSearch: { createdAt: string; slug: string } };

export type DeleteSavedTraceSearchVariables = Exact<{
  input: DeleteSavedTraceSearchInput;
}>;

export type DeleteSavedTraceSearch = { deleteSavedTraceSearch: boolean };

export type SavedTraceSearchConnections = {
  savedSearches: Array<{
    slug: string;
    createdAt: string;
    createdBy: string;
    updatedAt: string;
    name: string;
    search: {
      criteria: {
        scope: {
          spanScopes: Array<{
            matchType: SpanFilterMatchType;
            service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
            inCriticalPath: { value: boolean } | null;
            isRootSpan: { value: boolean } | null;
            leafError: { value: boolean } | null;
            tags: Array<{
              key: string;
              value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
            }>;
            spanCount: {
              min: number;
              max: number;
              isMinExclusive: boolean | null;
              isMaxExclusive: boolean | null;
            } | null;
          }> | null;
        } | null;
        trace: { duration: { minSeconds: number; maxSeconds: number } | null; error: { value: boolean } | null } | null;
        span: Array<{
          matchType: SpanFilterMatchType;
          service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          duration: { minSeconds: number; maxSeconds: number } | null;
          error: { value: boolean } | null;
          inCriticalPath: { value: boolean } | null;
          isRootSpan: { value: boolean } | null;
          leafError: { value: boolean } | null;
          tags: Array<{
            key: string;
            value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
          }>;
          spanCount: {
            min: number;
            max: number;
            isMinExclusive: boolean | null;
            isMaxExclusive: boolean | null;
          } | null;
        }>;
      };
      time:
        | { minTimestamp: string; maxTimestamp: string }
        | { timestamp: string }
        | { startRelativeOffsetSeconds: number; endRelativeOffsetSeconds: number | null };
      aggregationOptions: {
        focus: { criticalPathOnly: boolean | null; terminalErrorsOnly: boolean | null } | null;
        shape: {
          groupBy: Array<{ key: string | null; type: TraceAggregationGroupByType; value: string | null }>;
        } | null;
      } | null;
    };
    comparison: {
      criteria: {
        scope: {
          spanScopes: Array<{
            matchType: SpanFilterMatchType;
            service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
            inCriticalPath: { value: boolean } | null;
            isRootSpan: { value: boolean } | null;
            leafError: { value: boolean } | null;
            tags: Array<{
              key: string;
              value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
            }>;
            spanCount: {
              min: number;
              max: number;
              isMinExclusive: boolean | null;
              isMaxExclusive: boolean | null;
            } | null;
          }> | null;
        } | null;
        trace: { duration: { minSeconds: number; maxSeconds: number } | null; error: { value: boolean } | null } | null;
        span: Array<{
          matchType: SpanFilterMatchType;
          service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          duration: { minSeconds: number; maxSeconds: number } | null;
          error: { value: boolean } | null;
          inCriticalPath: { value: boolean } | null;
          isRootSpan: { value: boolean } | null;
          leafError: { value: boolean } | null;
          tags: Array<{
            key: string;
            value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
          }>;
          spanCount: {
            min: number;
            max: number;
            isMinExclusive: boolean | null;
            isMaxExclusive: boolean | null;
          } | null;
        }>;
      };
      time:
        | { minTimestamp: string; maxTimestamp: string }
        | { timestamp: string }
        | { startRelativeOffsetSeconds: number; endRelativeOffsetSeconds: number | null };
      aggregationOptions: {
        focus: { criticalPathOnly: boolean | null; terminalErrorsOnly: boolean | null } | null;
        shape: {
          groupBy: Array<{ key: string | null; type: TraceAggregationGroupByType; value: string | null }>;
        } | null;
      } | null;
    } | null;
  }>;
};

export type SavedTraceSearchesVariables = Exact<{ [key: string]: never }>;

export type SavedTraceSearches = {
  savedTraceSearches: {
    savedSearches: Array<{
      slug: string;
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      name: string;
      search: {
        criteria: {
          scope: {
            spanScopes: Array<{
              matchType: SpanFilterMatchType;
              service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
              inCriticalPath: { value: boolean } | null;
              isRootSpan: { value: boolean } | null;
              leafError: { value: boolean } | null;
              tags: Array<{
                key: string;
                value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
              }>;
              spanCount: {
                min: number;
                max: number;
                isMinExclusive: boolean | null;
                isMaxExclusive: boolean | null;
              } | null;
            }> | null;
          } | null;
          trace: {
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
          } | null;
          span: Array<{
            matchType: SpanFilterMatchType;
            service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
            inCriticalPath: { value: boolean } | null;
            isRootSpan: { value: boolean } | null;
            leafError: { value: boolean } | null;
            tags: Array<{
              key: string;
              value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
            }>;
            spanCount: {
              min: number;
              max: number;
              isMinExclusive: boolean | null;
              isMaxExclusive: boolean | null;
            } | null;
          }>;
        };
        time:
          | { minTimestamp: string; maxTimestamp: string }
          | { timestamp: string }
          | { startRelativeOffsetSeconds: number; endRelativeOffsetSeconds: number | null };
        aggregationOptions: {
          focus: { criticalPathOnly: boolean | null; terminalErrorsOnly: boolean | null } | null;
          shape: {
            groupBy: Array<{ key: string | null; type: TraceAggregationGroupByType; value: string | null }>;
          } | null;
        } | null;
      };
      comparison: {
        criteria: {
          scope: {
            spanScopes: Array<{
              matchType: SpanFilterMatchType;
              service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
              inCriticalPath: { value: boolean } | null;
              isRootSpan: { value: boolean } | null;
              leafError: { value: boolean } | null;
              tags: Array<{
                key: string;
                value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
              }>;
              spanCount: {
                min: number;
                max: number;
                isMinExclusive: boolean | null;
                isMaxExclusive: boolean | null;
              } | null;
            }> | null;
          } | null;
          trace: {
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
          } | null;
          span: Array<{
            matchType: SpanFilterMatchType;
            service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
            inCriticalPath: { value: boolean } | null;
            isRootSpan: { value: boolean } | null;
            leafError: { value: boolean } | null;
            tags: Array<{
              key: string;
              value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
            }>;
            spanCount: {
              min: number;
              max: number;
              isMinExclusive: boolean | null;
              isMaxExclusive: boolean | null;
            } | null;
          }>;
        };
        time:
          | { minTimestamp: string; maxTimestamp: string }
          | { timestamp: string }
          | { startRelativeOffsetSeconds: number; endRelativeOffsetSeconds: number | null };
        aggregationOptions: {
          focus: { criticalPathOnly: boolean | null; terminalErrorsOnly: boolean | null } | null;
          shape: {
            groupBy: Array<{ key: string | null; type: TraceAggregationGroupByType; value: string | null }>;
          } | null;
        } | null;
      } | null;
    }>;
  };
};

export type FilteredSavedTraceSearchesVariables = Exact<{
  input: InputMaybe<Scalars['String']['input']>;
}>;

export type FilteredSavedTraceSearches = {
  savedTraceSearchesByName: {
    savedSearches: Array<{
      slug: string;
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      name: string;
      search: {
        criteria: {
          scope: {
            spanScopes: Array<{
              matchType: SpanFilterMatchType;
              service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
              inCriticalPath: { value: boolean } | null;
              isRootSpan: { value: boolean } | null;
              leafError: { value: boolean } | null;
              tags: Array<{
                key: string;
                value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
              }>;
              spanCount: {
                min: number;
                max: number;
                isMinExclusive: boolean | null;
                isMaxExclusive: boolean | null;
              } | null;
            }> | null;
          } | null;
          trace: {
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
          } | null;
          span: Array<{
            matchType: SpanFilterMatchType;
            service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
            inCriticalPath: { value: boolean } | null;
            isRootSpan: { value: boolean } | null;
            leafError: { value: boolean } | null;
            tags: Array<{
              key: string;
              value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
            }>;
            spanCount: {
              min: number;
              max: number;
              isMinExclusive: boolean | null;
              isMaxExclusive: boolean | null;
            } | null;
          }>;
        };
        time:
          | { minTimestamp: string; maxTimestamp: string }
          | { timestamp: string }
          | { startRelativeOffsetSeconds: number; endRelativeOffsetSeconds: number | null };
        aggregationOptions: {
          focus: { criticalPathOnly: boolean | null; terminalErrorsOnly: boolean | null } | null;
          shape: {
            groupBy: Array<{ key: string | null; type: TraceAggregationGroupByType; value: string | null }>;
          } | null;
        } | null;
      };
      comparison: {
        criteria: {
          scope: {
            spanScopes: Array<{
              matchType: SpanFilterMatchType;
              service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
              inCriticalPath: { value: boolean } | null;
              isRootSpan: { value: boolean } | null;
              leafError: { value: boolean } | null;
              tags: Array<{
                key: string;
                value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
              }>;
              spanCount: {
                min: number;
                max: number;
                isMinExclusive: boolean | null;
                isMaxExclusive: boolean | null;
              } | null;
            }> | null;
          } | null;
          trace: {
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
          } | null;
          span: Array<{
            matchType: SpanFilterMatchType;
            service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
            inCriticalPath: { value: boolean } | null;
            isRootSpan: { value: boolean } | null;
            leafError: { value: boolean } | null;
            tags: Array<{
              key: string;
              value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
            }>;
            spanCount: {
              min: number;
              max: number;
              isMinExclusive: boolean | null;
              isMaxExclusive: boolean | null;
            } | null;
          }>;
        };
        time:
          | { minTimestamp: string; maxTimestamp: string }
          | { timestamp: string }
          | { startRelativeOffsetSeconds: number; endRelativeOffsetSeconds: number | null };
        aggregationOptions: {
          focus: { criticalPathOnly: boolean | null; terminalErrorsOnly: boolean | null } | null;
          shape: {
            groupBy: Array<{ key: string | null; type: TraceAggregationGroupByType; value: string | null }>;
          } | null;
        } | null;
      } | null;
    }>;
  };
  savedTraceSearchesByCreator: {
    savedSearches: Array<{
      slug: string;
      createdAt: string;
      createdBy: string;
      updatedAt: string;
      name: string;
      search: {
        criteria: {
          scope: {
            spanScopes: Array<{
              matchType: SpanFilterMatchType;
              service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
              inCriticalPath: { value: boolean } | null;
              isRootSpan: { value: boolean } | null;
              leafError: { value: boolean } | null;
              tags: Array<{
                key: string;
                value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
              }>;
              spanCount: {
                min: number;
                max: number;
                isMinExclusive: boolean | null;
                isMaxExclusive: boolean | null;
              } | null;
            }> | null;
          } | null;
          trace: {
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
          } | null;
          span: Array<{
            matchType: SpanFilterMatchType;
            service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
            inCriticalPath: { value: boolean } | null;
            isRootSpan: { value: boolean } | null;
            leafError: { value: boolean } | null;
            tags: Array<{
              key: string;
              value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
            }>;
            spanCount: {
              min: number;
              max: number;
              isMinExclusive: boolean | null;
              isMaxExclusive: boolean | null;
            } | null;
          }>;
        };
        time:
          | { minTimestamp: string; maxTimestamp: string }
          | { timestamp: string }
          | { startRelativeOffsetSeconds: number; endRelativeOffsetSeconds: number | null };
        aggregationOptions: {
          focus: { criticalPathOnly: boolean | null; terminalErrorsOnly: boolean | null } | null;
          shape: {
            groupBy: Array<{ key: string | null; type: TraceAggregationGroupByType; value: string | null }>;
          } | null;
        } | null;
      };
      comparison: {
        criteria: {
          scope: {
            spanScopes: Array<{
              matchType: SpanFilterMatchType;
              service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              duration: { minSeconds: number; maxSeconds: number } | null;
              error: { value: boolean } | null;
              inCriticalPath: { value: boolean } | null;
              isRootSpan: { value: boolean } | null;
              leafError: { value: boolean } | null;
              tags: Array<{
                key: string;
                value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
                numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
              }>;
              spanCount: {
                min: number;
                max: number;
                isMinExclusive: boolean | null;
                isMaxExclusive: boolean | null;
              } | null;
            }> | null;
          } | null;
          trace: {
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
          } | null;
          span: Array<{
            matchType: SpanFilterMatchType;
            service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            duration: { minSeconds: number; maxSeconds: number } | null;
            error: { value: boolean } | null;
            inCriticalPath: { value: boolean } | null;
            isRootSpan: { value: boolean } | null;
            leafError: { value: boolean } | null;
            tags: Array<{
              key: string;
              value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
              numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
            }>;
            spanCount: {
              min: number;
              max: number;
              isMinExclusive: boolean | null;
              isMaxExclusive: boolean | null;
            } | null;
          }>;
        };
        time:
          | { minTimestamp: string; maxTimestamp: string }
          | { timestamp: string }
          | { startRelativeOffsetSeconds: number; endRelativeOffsetSeconds: number | null };
        aggregationOptions: {
          focus: { criticalPathOnly: boolean | null; terminalErrorsOnly: boolean | null } | null;
          shape: {
            groupBy: Array<{ key: string | null; type: TraceAggregationGroupByType; value: string | null }>;
          } | null;
        } | null;
      } | null;
    }>;
  };
};

export type TraceSearchFields = {
  criteria: {
    scope: {
      spanScopes: Array<{
        matchType: SpanFilterMatchType;
        service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
        operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
        parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
        parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
        duration: { minSeconds: number; maxSeconds: number } | null;
        error: { value: boolean } | null;
        inCriticalPath: { value: boolean } | null;
        isRootSpan: { value: boolean } | null;
        leafError: { value: boolean } | null;
        tags: Array<{
          key: string;
          value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
        }>;
        spanCount: { min: number; max: number; isMinExclusive: boolean | null; isMaxExclusive: boolean | null } | null;
      }> | null;
    } | null;
    trace: { duration: { minSeconds: number; maxSeconds: number } | null; error: { value: boolean } | null } | null;
    span: Array<{
      matchType: SpanFilterMatchType;
      service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
      operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
      parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
      parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
      duration: { minSeconds: number; maxSeconds: number } | null;
      error: { value: boolean } | null;
      inCriticalPath: { value: boolean } | null;
      isRootSpan: { value: boolean } | null;
      leafError: { value: boolean } | null;
      tags: Array<{
        key: string;
        value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
        numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
      }>;
      spanCount: { min: number; max: number; isMinExclusive: boolean | null; isMaxExclusive: boolean | null } | null;
    }>;
  };
  time:
    | { minTimestamp: string; maxTimestamp: string }
    | { timestamp: string }
    | { startRelativeOffsetSeconds: number; endRelativeOffsetSeconds: number | null };
  aggregationOptions: {
    focus: { criticalPathOnly: boolean | null; terminalErrorsOnly: boolean | null } | null;
    shape: { groupBy: Array<{ key: string | null; type: TraceAggregationGroupByType; value: string | null }> } | null;
  } | null;
};

export type GetTraceTopTagsVariables = Exact<{ [key: string]: never }>;

export type GetTraceTopTags = {
  traceTopTags: { version: number; data: Array<{ name: string; description: string }> } | null;
};

export type UpdateTraceTopTagsVariables = Exact<{
  input: UpdateTraceTopTagsInput;
}>;

export type UpdateTraceTopTags = { updateTraceTopTags: { version: number; data: Array<{ name: string }> } };

export type UpdateTraceMetricsRuleVariables = Exact<{
  input: UpdateTraceMetricsRuleInput;
}>;

export type UpdateTraceMetricsRule = { updateTraceMetricsRule: { slug: string } };

export type TraceMetricsRulesVariables = Exact<{
  pageSize: InputMaybe<Scalars['Int']['input']>;
  after: InputMaybe<Scalars['String']['input']>;
}>;

export type TraceMetricsRules = {
  traceMetricsRules: {
    pageInfo: { cursor: string | null; hasNextPage: boolean };
    traceMetricsRules: Array<{
      name: string;
      slug: string;
      metricName: string;
      createdAt: string;
      createdBy: string;
      source: EditSource;
      metricLabels: Array<{ name: string; value: string }>;
      groupBys: Array<{ label: string; key: { namedKey: string | null; type: TraceMetricsGroupByKeyType } }> | null;
      traceFilter: {
        trace: { duration: { minSeconds: number; maxSeconds: number } | null; error: { value: boolean } | null } | null;
        span: Array<{
          matchType: SpanFilterMatchType;
          service: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          operation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          parentService: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          parentOperation: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
          duration: { minSeconds: number; maxSeconds: number } | null;
          error: { value: boolean } | null;
          tags: Array<{
            key: string;
            value: { match: StringFilterMatchType; value: string; inValues: Array<string> | null } | null;
            numericValue: { comparison: NumericFilterComparisonType; value: number } | null;
          }>;
          spanCount: {
            min: number;
            max: number;
            isMaxExclusive: boolean | null;
            isMinExclusive: boolean | null;
          } | null;
          inCriticalPath: { value: boolean } | null;
          isRootSpan: { value: boolean } | null;
          leafError: { value: boolean } | null;
        }>;
      };
    }>;
  };
};

export type GetTracingServiceAttributeMapVariables = Exact<{
  input: ServiceToTracingServiceAttributeInput;
}>;

export type GetTracingServiceAttributeMap = {
  mapServiceToTracingServiceAttribute: {
    tracingServices: Array<{
      tracingServiceAttribute: Array<string>;
      serviceDerivedName: string | null;
      serviceSlug: string | null;
    }>;
  };
};

export type GetServiceTracingAttributeMapVariables = Exact<{
  input: TracingServiceAttributeToServiceInput;
}>;

export type GetServiceTracingAttributeMap = {
  mapTracingServiceAttributeToService: {
    tracingServiceMappings: Array<{
      tracingServiceAttribute: Array<string>;
      serviceDerivedName: string | null;
      serviceSlug: string | null;
    }>;
  };
};

export type ResendSignupInviteMutationVariables = Exact<{
  input: ResendSignupInviteInput;
}>;

export type ResendSignupInviteMutation = { resendSignupInvite: boolean };

export type CreateUserInviteMutationVariables = Exact<{
  input: CreateSignupInviteInput;
}>;

export type CreateUserInviteMutation = {
  createSignupInvite: { token: string; email: string; expiresAt: string; inviteURL: string; tenant: { name: string } };
};

export type LoadUserMembershipDialogVariables = Exact<{ [key: string]: never }>;

export type LoadUserMembershipDialog = {
  teams: Array<{ id: string; name: string; createdAt: string; source: EditSource; roles: Array<{ name: string }> }>;
};

export type BulkUpdateTeamsForUserMutationVariables = Exact<{
  input: BulkUpdateTeamsForUser;
}>;

export type BulkUpdateTeamsForUserMutation = {
  bulkUpdateTeamsForUser: { addedIDs: Array<string>; removedIDs: Array<string> };
};

export const SchemaTypenames = {
  Alert: 'Alert',
  AlertAnalysisAggregationBucket: 'AlertAnalysisAggregationBucket',
  AlertAnalysisAlert: 'AlertAnalysisAlert',
  AlertAnalysisMuteActionHistoryEntry: 'AlertAnalysisMuteActionHistoryEntry',
  AlertAnalysisNotifierHistoryEntry: 'AlertAnalysisNotifierHistoryEntry',
  AlertAnalysisOwnershipContext: 'AlertAnalysisOwnershipContext',
  AlertAnalysisSeverityChangeHistoryEntry: 'AlertAnalysisSeverityChangeHistoryEntry',
  AlertAnalysisSloMetadata: 'AlertAnalysisSloMetadata',
  AlertEvent: 'AlertEvent',
  AlertEventConnection: 'AlertEventConnection',
  AlertReceiver: 'AlertReceiver',
  AlertReceiverEmailConfig: 'AlertReceiverEmailConfig',
  AlertReceiverHTTPConfig: 'AlertReceiverHTTPConfig',
  AlertReceiverHTTPConfigBasicAuth: 'AlertReceiverHTTPConfigBasicAuth',
  AlertReceiverHTTPConfigTLSConfig: 'AlertReceiverHTTPConfigTLSConfig',
  AlertReceiverNotifierBaseConfig: 'AlertReceiverNotifierBaseConfig',
  AlertReceiverOpsGenieConfig: 'AlertReceiverOpsGenieConfig',
  AlertReceiverOpsGenieConfigResponder: 'AlertReceiverOpsGenieConfigResponder',
  AlertReceiverPagerdutyConfig: 'AlertReceiverPagerdutyConfig',
  AlertReceiverPagerdutyConfigImage: 'AlertReceiverPagerdutyConfigImage',
  AlertReceiverPagerdutyConfigLink: 'AlertReceiverPagerdutyConfigLink',
  AlertReceiverSlackConfig: 'AlertReceiverSlackConfig',
  AlertReceiverSlackConfigAction: 'AlertReceiverSlackConfigAction',
  AlertReceiverSlackConfigConfirmField: 'AlertReceiverSlackConfigConfirmField',
  AlertReceiverSlackConfigField: 'AlertReceiverSlackConfigField',
  AlertReceiverVictorOpsConfig: 'AlertReceiverVictorOpsConfig',
  AlertReceiverWebhookConfig: 'AlertReceiverWebhookConfig',
  AlertReceivers: 'AlertReceivers',
  AlertRouteMatcher: 'AlertRouteMatcher',
  AlertRuleLabel: 'AlertRuleLabel',
  AlertStatus: 'AlertStatus',
  AlertsConnection: 'AlertsConnection',
  AllDashboardsConnection: 'AllDashboardsConnection',
  Allocation: 'Allocation',
  AnalyzeAlertsAggregateResponse: 'AnalyzeAlertsAggregateResponse',
  AnalyzeAlertsListResponse: 'AnalyzeAlertsListResponse',
  Annotation: 'Annotation',
  Attributes: 'Attributes',
  BetweenTimeFilter: 'BetweenTimeFilter',
  BoolFilter: 'BoolFilter',
  BoolValue: 'BoolValue',
  ChronosphereLoggingConfig: 'ChronosphereLoggingConfig',
  CloseToTimeFilter: 'CloseToTimeFilter',
  Collection: 'Collection',
  CollectionDashboardConnection: 'CollectionDashboardConnection',
  CollectionDashboardLink: 'CollectionDashboardLink',
  CollectionHomepage: 'CollectionHomepage',
  CollectionLink: 'CollectionLink',
  CollectionLinksConnection: 'CollectionLinksConnection',
  CollectionMonitorLink: 'CollectionMonitorLink',
  CollectionsConnection: 'CollectionsConnection',
  Comment: 'Comment',
  CommentSearchConnection: 'CommentSearchConnection',
  CommentSearchResult: 'CommentSearchResult',
  CommentsConnection: 'CommentsConnection',
  Component: 'Component',
  ComponentDashboardPresentationConfig: 'ComponentDashboardPresentationConfig',
  ComponentDiscovery: 'ComponentDiscovery',
  ComponentDiscoveryConfig: 'ComponentDiscoveryConfig',
  ComponentDiscoveryOverride: 'ComponentDiscoveryOverride',
  ComponentEventPresentationConfig: 'ComponentEventPresentationConfig',
  ComponentPresentationConfig: 'ComponentPresentationConfig',
  ComponentPresentationOverride: 'ComponentPresentationOverride',
  ConditionOverride: 'ConditionOverride',
  ConfigEntity: 'ConfigEntity',
  ConstructedLabel: 'ConstructedLabel',
  ConsumptionBudget: 'ConsumptionBudget',
  ConsumptionBudgetAlertActionConfig: 'ConsumptionBudgetAlertActionConfig',
  ConsumptionBudgetFilter: 'ConsumptionBudgetFilter',
  ConsumptionBudgetInstantRate: 'ConsumptionBudgetInstantRate',
  ConsumptionBudgetPriority: 'ConsumptionBudgetPriority',
  ConsumptionBudgetThreshold: 'ConsumptionBudgetThreshold',
  ConsumptionBudgetVolume: 'ConsumptionBudgetVolume',
  ConsumptionContract: 'ConsumptionContract',
  ConsumptionPartition: 'ConsumptionPartition',
  ConsumptionPartitionFilter: 'ConsumptionPartitionFilter',
  ConsumptionPartitionFilterCondition: 'ConsumptionPartitionFilterCondition',
  ContainerHealth: 'ContainerHealth',
  ContainerInfo: 'ContainerInfo',
  ContainerLifecycle: 'ContainerLifecycle',
  ContainerResources: 'ContainerResources',
  CountFilter: 'CountFilter',
  CrashEvent: 'CrashEvent',
  CrashEventEvidence: 'CrashEventEvidence',
  CreatePersonalAccessTokenResponse: 'CreatePersonalAccessTokenResponse',
  CreateServiceAccountResponse: 'CreateServiceAccountResponse',
  CustomComponentOutput: 'CustomComponentOutput',
  Dashboard: 'Dashboard',
  DashboardLabel: 'DashboardLabel',
  DashboardsConnection: 'DashboardsConnection',
  Dataset: 'Dataset',
  DatasetAllocation: 'DatasetAllocation',
  DatasetConnection: 'DatasetConnection',
  DeaggregateResult: 'DeaggregateResult',
  DeaggregatedQuery: 'DeaggregatedQuery',
  DebugLog: 'DebugLog',
  DebugLogEntry: 'DebugLogEntry',
  DefaultDataset: 'DefaultDataset',
  DefaultResourcePool: 'DefaultResourcePool',
  DefaultSampleRate: 'DefaultSampleRate',
  DeploymentEvent: 'DeploymentEvent',
  DeploymentEvidence: 'DeploymentEvidence',
  DeploymentInfo: 'DeploymentInfo',
  DerivedLabel: 'DerivedLabel',
  DerivedLabelFilter: 'DerivedLabelFilter',
  DerivedLabelPreview: 'DerivedLabelPreview',
  DerivedLabelSpanTag: 'DerivedLabelSpanTag',
  DerivedLabelSpanTagNameMapping: 'DerivedLabelSpanTagNameMapping',
  DerivedLabelValueMapping: 'DerivedLabelValueMapping',
  DescriptionData: 'DescriptionData',
  DiscoveredComponent: 'DiscoveredComponent',
  DiscoveredService: 'DiscoveredService',
  DiscoveryPipelineStatusMessage: 'DiscoveryPipelineStatusMessage',
  DocArtifact: 'DocArtifact',
  DocArtifactConnection: 'DocArtifactConnection',
  Downtime: 'Downtime',
  DropRule: 'DropRule',
  DropRuleValueBasedDrop: 'DropRuleValueBasedDrop',
  DropValue: 'DropValue',
  DurationFilter: 'DurationFilter',
  EligibleServicesConnection: 'EligibleServicesConnection',
  EmitMetricsCounter: 'EmitMetricsCounter',
  EmitMetricsGauge: 'EmitMetricsGauge',
  EmitMetricsHistogram: 'EmitMetricsHistogram',
  EmitMetricsLabel: 'EmitMetricsLabel',
  EntityVersion: 'EntityVersion',
  EntityVersionsConnection: 'EntityVersionsConnection',
  ErrorCodeDef: 'ErrorCodeDef',
  EventDiscovery: 'EventDiscovery',
  EventLog: 'EventLog',
  EventLogListItem: 'EventLogListItem',
  EventLogs: 'EventLogs',
  ExportConfigQuery: 'ExportConfigQuery',
  ExportedConfig: 'ExportedConfig',
  FeatureFlag: 'FeatureFlag',
  FieldNormalization: 'FieldNormalization',
  FilterQueryValidationResult: 'FilterQueryValidationResult',
  GatewayConfigs: 'GatewayConfigs',
  GeneratedDescription: 'GeneratedDescription',
  GrafanaDashboard: 'GrafanaDashboard',
  GrafanaDashboardsConnection: 'GrafanaDashboardsConnection',
  GraphiteLabelPolicy: 'GraphiteLabelPolicy',
  GraphiteLabelPolicyReplace: 'GraphiteLabelPolicyReplace',
  HighLowPriorities: 'HighLowPriorities',
  ImageChange: 'ImageChange',
  ImageChangeEvent: 'ImageChangeEvent',
  IntValue: 'IntValue',
  JaegerRemotePerOperationSamplingStrategies: 'JaegerRemotePerOperationSamplingStrategies',
  JaegerRemotePerOperationSamplingStrategy: 'JaegerRemotePerOperationSamplingStrategy',
  JaegerRemoteSamplingProbabilisticStrategy: 'JaegerRemoteSamplingProbabilisticStrategy',
  JaegerRemoteSamplingRateLimitingSamplingStrategy: 'JaegerRemoteSamplingRateLimitingSamplingStrategy',
  K8sContextDiscoveryResult: 'K8sContextDiscoveryResult',
  K8sEventInference: 'K8sEventInference',
  K8sSearchCriteria: 'K8sSearchCriteria',
  KeyValueParser: 'KeyValueParser',
  KnownMetric: 'KnownMetric',
  Label: 'Label',
  LabelConfig: 'LabelConfig',
  LabelMapping: 'LabelMapping',
  LabelMatcher: 'LabelMatcher',
  LabelNames: 'LabelNames',
  LabelPair: 'LabelPair',
  LabelPolicy: 'LabelPolicy',
  LabelValues: 'LabelValues',
  Link: 'Link',
  LinkTemplate: 'LinkTemplate',
  ListDerivedLabelsConnection: 'ListDerivedLabelsConnection',
  LogAllocationConfig: 'LogAllocationConfig',
  LogControlConfig: 'LogControlConfig',
  LogControlRule: 'LogControlRule',
  LogControlRuleDropField: 'LogControlRuleDropField',
  LogControlRuleEmitMetrics: 'LogControlRuleEmitMetrics',
  LogControlRuleReplaceField: 'LogControlRuleReplaceField',
  LogControlRuleSample: 'LogControlRuleSample',
  LogDatasetConfiguration: 'LogDatasetConfiguration',
  LogFieldParser: 'LogFieldParser',
  LogFieldPath: 'LogFieldPath',
  LogIngestConfig: 'LogIngestConfig',
  LogLookupTable: 'LogLookupTable',
  LogParser: 'LogParser',
  LogSearchFilter: 'LogSearchFilter',
  LoggingContract: 'LoggingContract',
  LoggingLimit: 'LoggingLimit',
  ManagedBy: 'ManagedBy',
  MappingLabel: 'MappingLabel',
  MappingRule: 'MappingRule',
  MappingRuleAggregationPolicy: 'MappingRuleAggregationPolicy',
  MatchingMonitorRoutesAndConditions: 'MatchingMonitorRoutesAndConditions',
  MetricDDXResult: 'MetricDDXResult',
  MetricDiscovery: 'MetricDiscovery',
  MetricDiscoveryMetadata: 'MetricDiscoveryMetadata',
  MetricDiscoveryOverride: 'MetricDiscoveryOverride',
  MetricDiscoveryTarget: 'MetricDiscoveryTarget',
  MetricLabel: 'MetricLabel',
  MetricMetadata: 'MetricMetadata',
  MetricMetadataConnection: 'MetricMetadataConnection',
  MetricSettings: 'MetricSettings',
  Monitor: 'Monitor',
  MonitorCondition: 'MonitorCondition',
  MonitorMuted: 'MonitorMuted',
  MonitorNotificationPolicy: 'MonitorNotificationPolicy',
  MonitorQuery: 'MonitorQuery',
  MonitorResolvedAlertEvent: 'MonitorResolvedAlertEvent',
  MonitorResolvedNotificationFailedToSend: 'MonitorResolvedNotificationFailedToSend',
  MonitorResolvedNotificationSent: 'MonitorResolvedNotificationSent',
  MonitorSeries: 'MonitorSeries',
  MonitorSignal: 'MonitorSignal',
  MonitorSignalConfig: 'MonitorSignalConfig',
  MonitorSpec: 'MonitorSpec',
  MonitorState: 'MonitorState',
  MonitorStats: 'MonitorStats',
  MonitorSummary: 'MonitorSummary',
  MonitorTriggeredAlertEvent: 'MonitorTriggeredAlertEvent',
  MonitorTriggeredNotificationFailedToSend: 'MonitorTriggeredNotificationFailedToSend',
  MonitorTriggeredNotificationSent: 'MonitorTriggeredNotificationSent',
  MonitorUnmuted: 'MonitorUnmuted',
  MonitorsConnection: 'MonitorsConnection',
  Mutation: 'Mutation',
  MutingRule: 'MutingRule',
  MutingRuleConnection: 'MutingRuleConnection',
  MutingRulesForMonitor: 'MutingRulesForMonitor',
  NameMapping: 'NameMapping',
  NameMappingValues: 'NameMappingValues',
  NamedStringNormalization: 'NamedStringNormalization',
  NodeInfo: 'NodeInfo',
  NotificationPolicy: 'NotificationPolicy',
  NotificationPolicyConnection: 'NotificationPolicyConnection',
  NotificationRoutes: 'NotificationRoutes',
  NotificationRoutesOverride: 'NotificationRoutesOverride',
  NotificationRule: 'NotificationRule',
  Notifier: 'Notifier',
  NotifiersBySeverity: 'NotifiersBySeverity',
  NumericFilter: 'NumericFilter',
  ObjectDiscoveryMetricRule: 'ObjectDiscoveryMetricRule',
  ObjectDiscoveryRule: 'ObjectDiscoveryRule',
  ObjectMergeRule: 'ObjectMergeRule',
  OemLoggingConfig: 'OemLoggingConfig',
  PageInfo: 'PageInfo',
  Panel: 'Panel',
  PanelQuery: 'PanelQuery',
  PersonalAccessToken: 'PersonalAccessToken',
  PlaintextParser: 'PlaintextParser',
  PodInfo: 'PodInfo',
  PresentationComponent: 'PresentationComponent',
  PresentationEligibility: 'PresentationEligibility',
  ProbeStatus: 'ProbeStatus',
  PromQL: 'PromQL',
  Query: 'Query',
  RPC: 'RPC',
  RateLimit: 'RateLimit',
  RecordingRule: 'RecordingRule',
  RecordingRuleLabel: 'RecordingRuleLabel',
  RecordingRules: 'RecordingRules',
  RegexParser: 'RegexParser',
  RelativeTimeFilter: 'RelativeTimeFilter',
  ReplaceFieldMappedValue: 'ReplaceFieldMappedValue',
  ReplaceFieldMappedValuePair: 'ReplaceFieldMappedValuePair',
  ReplaceFieldStaticValue: 'ReplaceFieldStaticValue',
  ReplacementInfo: 'ReplacementInfo',
  ReplicaCountChange: 'ReplicaCountChange',
  ResourcePool: 'ResourcePool',
  ResourcePoolAllocation: 'ResourcePoolAllocation',
  ResourcePoolAllocationFixedValue: 'ResourcePoolAllocationFixedValue',
  ResourcePoolAllocationThreshold: 'ResourcePoolAllocationThreshold',
  ResourcePoolAllocationThresholds: 'ResourcePoolAllocationThresholds',
  ResourcePoolHighLowPriorities: 'ResourcePoolHighLowPriorities',
  ResourcePools: 'ResourcePools',
  RestartEvent: 'RestartEvent',
  Result: 'Result',
  RetentionPolicy: 'RetentionPolicy',
  Role: 'Role',
  RollupRule: 'RollupRule',
  RollupRuleLabelReplace: 'RollupRuleLabelReplace',
  RuleEvaluation: 'RuleEvaluation',
  RuleEvaluations: 'RuleEvaluations',
  SLI: 'SLI',
  SLIEndpointAvailability: 'SLIEndpointAvailability',
  SLIEndpointLatency: 'SLIEndpointLatency',
  SLIMetadata: 'SLIMetadata',
  SLIQueries: 'SLIQueries',
  SLITemplateData: 'SLITemplateData',
  SLITimesliceCondition: 'SLITimesliceCondition',
  SLITimesliceQueries: 'SLITimesliceQueries',
  SLO: 'SLO',
  SLOBurnRateDefinition: 'SLOBurnRateDefinition',
  SLOCalculatedBurnRate: 'SLOCalculatedBurnRate',
  SLOConnection: 'SLOConnection',
  SLODefinition: 'SLODefinition',
  SLOErrorCode: 'SLOErrorCode',
  SLOMetadataEndpointAvailability: 'SLOMetadataEndpointAvailability',
  SLOMetadataLatency: 'SLOMetadataLatency',
  SLORelatedMetricsQueries: 'SLORelatedMetricsQueries',
  SLOReportingWindow: 'SLOReportingWindow',
  SavedTraceSearch: 'SavedTraceSearch',
  SavedTraceSearchConnection: 'SavedTraceSearchConnection',
  ScalingEvent: 'ScalingEvent',
  Schedule: 'Schedule',
  ScheduleDay: 'ScheduleDay',
  ScopeFilter: 'ScopeFilter',
  SearchConnection: 'SearchConnection',
  SearchHistoryConnection: 'SearchHistoryConnection',
  SearchHistoryQuery: 'SearchHistoryQuery',
  SeriesConditions: 'SeriesConditions',
  Service: 'Service',
  ServiceAccount: 'ServiceAccount',
  ServiceAccountLabel: 'ServiceAccountLabel',
  ServiceAttribute: 'ServiceAttribute',
  ServiceComponentViewDetails: 'ServiceComponentViewDetails',
  ServiceDiscoveryOutput: 'ServiceDiscoveryOutput',
  ServiceInfo: 'ServiceInfo',
  ServiceStatuses: 'ServiceStatuses',
  ServiceToTracingServiceAttributeMap: 'ServiceToTracingServiceAttributeMap',
  ServiceView: 'ServiceView',
  ServicesConnection: 'ServicesConnection',
  Settings: 'Settings',
  SeverityCondition: 'SeverityCondition',
  ShortenedMessage: 'ShortenedMessage',
  SignalGrouping: 'SignalGrouping',
  SignedURL: 'SignedURL',
  SignupInvite: 'SignupInvite',
  SpanFilter: 'SpanFilter',
  StaticList: 'StaticList',
  StoragePolicy: 'StoragePolicy',
  StringFilter: 'StringFilter',
  StringNormalization: 'StringNormalization',
  StringValue: 'StringValue',
  SuppressionMergeRule: 'SuppressionMergeRule',
  TagFilter: 'TagFilter',
  Target: 'Target',
  Team: 'Team',
  TeamBulkUpdate: 'TeamBulkUpdate',
  TeamHomepage: 'TeamHomepage',
  TeamsForUserBulkUpdate: 'TeamsForUserBulkUpdate',
  Template: 'Template',
  TemplateValue: 'TemplateValue',
  Tenant: 'Tenant',
  TenantConfiguration: 'TenantConfiguration',
  TenantSettings: 'TenantSettings',
  Thread: 'Thread',
  ThreadsConnection: 'ThreadsConnection',
  TimeRange: 'TimeRange',
  TimeWindow: 'TimeWindow',
  TimelineCategory: 'TimelineCategory',
  TimestampNormalization: 'TimestampNormalization',
  TraceActiveBehaviorsConnection: 'TraceActiveBehaviorsConnection',
  TraceAggregationFocus: 'TraceAggregationFocus',
  TraceAggregationGroupByKey: 'TraceAggregationGroupByKey',
  TraceAggregationOptions: 'TraceAggregationOptions',
  TraceAggregationShape: 'TraceAggregationShape',
  TraceBehavior: 'TraceBehavior',
  TraceBehaviorActiveAssignment: 'TraceBehaviorActiveAssignment',
  TraceBehaviorConfig: 'TraceBehaviorConfig',
  TraceBehaviorErrorSampleOptions: 'TraceBehaviorErrorSampleOptions',
  TraceBehaviorFastSampleOptions: 'TraceBehaviorFastSampleOptions',
  TraceBehaviorLargeTraceSampleOptions: 'TraceBehaviorLargeTraceSampleOptions',
  TraceBehaviorMainAssignment: 'TraceBehaviorMainAssignment',
  TraceBehaviorOverrideAssignment: 'TraceBehaviorOverrideAssignment',
  TraceBehaviorSlowSampleOptions: 'TraceBehaviorSlowSampleOptions',
  TraceBehaviorSmallTraceSampleOptions: 'TraceBehaviorSmallTraceSampleOptions',
  TraceBehaviorsConnection: 'TraceBehaviorsConnection',
  TraceDatasetConfiguration: 'TraceDatasetConfiguration',
  TraceDatasetEnhancement: 'TraceDatasetEnhancement',
  TraceDiscovery: 'TraceDiscovery',
  TraceFilter: 'TraceFilter',
  TraceJaegerRemoteSamplingStrategy: 'TraceJaegerRemoteSamplingStrategy',
  TraceJaegerRemoteSamplingStrategyConnection: 'TraceJaegerRemoteSamplingStrategyConnection',
  TraceMetricsGroupBy: 'TraceMetricsGroupBy',
  TraceMetricsGroupByKey: 'TraceMetricsGroupByKey',
  TraceMetricsRule: 'TraceMetricsRule',
  TraceMetricsRulesConnection: 'TraceMetricsRulesConnection',
  TraceSearch: 'TraceSearch',
  TraceSearchFilter: 'TraceSearchFilter',
  TraceSearchHistory: 'TraceSearchHistory',
  TraceSearchHistoryConnection: 'TraceSearchHistoryConnection',
  TraceTailSamplingRule: 'TraceTailSamplingRule',
  TraceTailSamplingRules: 'TraceTailSamplingRules',
  TraceTopTag: 'TraceTopTag',
  TraceTopTags: 'TraceTopTags',
  TracingLicenseLimits: 'TracingLicenseLimits',
  TracingServiceAttributeToServiceMap: 'TracingServiceAttributeToServiceMap',
  TracingServiceMapping: 'TracingServiceMapping',
  Transform: 'Transform',
  UsageStatsConfig: 'UsageStatsConfig',
  User: 'User',
  UserSearchHistory: 'UserSearchHistory',
  UserSettings: 'UserSettings',
  ValidationResult: 'ValidationResult',
  ValueDefinition: 'ValueDefinition',
  ValueMapping: 'ValueMapping',
  XRayNodes: 'XRayNodes',
  XRayResult: 'XRayResult',
  eventFilter: 'eventFilter',
  eventFilters: 'eventFilters',
};

export type TypenamesContext = Required<Pick<OperationContext, 'additionalTypenames'>>;

export const GetDashboardJSONContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetActivityDetailContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetCommentsContext: TypenamesContext = {
  additionalTypenames: ['Comment'],
};

export const GetThreadsContext: TypenamesContext = {
  additionalTypenames: ['Thread', 'Comment'],
};

export const GetTargetSummariesContext: TypenamesContext = {
  additionalTypenames: ['Target'],
};

export const LoadAuthorEmailsContext: TypenamesContext = {
  additionalTypenames: ['User'],
};

export const CommentSearchContext: TypenamesContext = {
  additionalTypenames: ['CommentSearchResult'],
};

export const GetPersonalCollectionContext: TypenamesContext = {
  additionalTypenames: [],
};

export const LoadDashboardTagsContext: TypenamesContext = {
  additionalTypenames: ['Label'],
};

export const GetDashboardGeneratedDescriptionContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetMonitorVersionsContext: TypenamesContext = {
  additionalTypenames: ['EntityVersion'],
};

export const GetDashboardVersionsContext: TypenamesContext = {
  additionalTypenames: ['EntityVersion'],
};

export const GetSLOVersionsContext: TypenamesContext = {
  additionalTypenames: ['EntityVersion'],
};

export const ExportSloConfigContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ExportMonitorConfigContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ExportDropRuleConfigContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ExportRollupRuleConfigContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ExportCollectionConfigContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ExportMappingRuleConfigBySlugContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ExportRollupRuleConfigBySlugContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetUpdatedPoolConfigurationContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ExportDashboardConfigContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ExportDatasetConfigBySlugContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ExportDerivedLabelConfigContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ExportConfigContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ExportLogsControlConfigContext: TypenamesContext = {
  additionalTypenames: [],
};

export const TestGetAlertsListContext: TypenamesContext = {
  additionalTypenames: ['Alert'],
};

export const GetMetricDescriptionContext: TypenamesContext = {
  additionalTypenames: [],
};

export const LoadUserSettingsMenuContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetAffectedSlosContext: TypenamesContext = {
  additionalTypenames: ['SLO'],
};

export const LoadNotifiersAutocompleteContext: TypenamesContext = {
  additionalTypenames: [
    'AlertReceiver',
    'AlertReceiverWebhookConfig',
    'AlertReceiverEmailConfig',
    'AlertReceiverSlackConfig',
    'AlertReceiverPagerdutyConfig',
    'AlertReceiverOpsGenieConfig',
    'AlertReceiverVictorOpsConfig',
  ],
};

export const AnalyzeAlertsListContext: TypenamesContext = {
  additionalTypenames: [
    'AlertAnalysisAlert',
    'Label',
    'AlertAnalysisSeverityChangeHistoryEntry',
    'AlertAnalysisMuteActionHistoryEntry',
    'AlertAnalysisNotifierHistoryEntry',
  ],
};

export const LoadAnalyticsContext: TypenamesContext = {
  additionalTypenames: ['Role'],
};

export const DarkModeSettingQueryContext: TypenamesContext = {
  additionalTypenames: [],
};

export const LoadDashboardOptionsContext: TypenamesContext = {
  additionalTypenames: [],
};

export const LoadMonitorOptionsContext: TypenamesContext = {
  additionalTypenames: ['Monitor'],
};

export const LoadCollectionOptionsContext: TypenamesContext = {
  additionalTypenames: ['Collection'],
};

export const GetResourcePoolsContext: TypenamesContext = {
  additionalTypenames: [
    'Label',
    'ResourcePoolAllocationThresholds',
    'ResourcePool',
    'ResourcePoolAllocationFixedValue',
  ],
};

export const GetSearchHistoryContext: TypenamesContext = {
  additionalTypenames: ['UserSearchHistory'],
};

export const ListTeamsWithCollectionsContext: TypenamesContext = {
  additionalTypenames: ['Team', 'Role', 'Collection'],
};

export const GetUsageStatsConfigContext: TypenamesContext = {
  additionalTypenames: [],
};

export const DeaggregateQueryContext: TypenamesContext = {
  additionalTypenames: ['DeaggregatedQuery', 'ReplacementInfo'],
};

export const GetPublicCollectionContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetAllTestScopesContext: TypenamesContext = {
  additionalTypenames: ['Template'],
};

export const GetAlertsListContext: TypenamesContext = {
  additionalTypenames: ['Alert', 'MutingRule', 'Label'],
};

export const GetAlertDetailsContext: TypenamesContext = {
  additionalTypenames: [
    'Annotation',
    'SeverityCondition',
    'MonitorCondition',
    'ConditionOverride',
    'AlertRouteMatcher',
    'MutingRule',
    'Label',
    'SLOBurnRateDefinition',
  ],
};

export const ListEntityAlertsContext: TypenamesContext = {
  additionalTypenames: ['Alert', 'Label'],
};

export const GetPaginatedAlertEventsContext: TypenamesContext = {
  additionalTypenames: ['AlertEvent', 'Label', 'MutingRule'],
};

export const GetAllSettingsQueryContext: TypenamesContext = {
  additionalTypenames: ['RetentionPolicy'],
};

export const CollectionMonitorLinksQueryContext: TypenamesContext = {
  additionalTypenames: ['CollectionLink', 'MonitorSignal', 'MonitorSeries', 'Label'],
};

export const CollectionDashboardLinksQueryContext: TypenamesContext = {
  additionalTypenames: ['CollectionLink', 'Label'],
};

export const ListTeamCollectionsContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ListCollectionsContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ListCollectionHomepageContext: TypenamesContext = {
  additionalTypenames: ['Link'],
};

export const GetPartitionBySlugPathsContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetConsumptionByPartitionContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetDroppedByPartitionContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetChangeOverTimeByPartitionContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetChildPartitionsByPartitionContext: TypenamesContext = {
  additionalTypenames: ['ConsumptionPartition'],
};

export const GetConsumptionContractContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetBudgetByPartitionContext: TypenamesContext = {
  additionalTypenames: ['ConsumptionBudgetThreshold', 'ConsumptionBudgetPriority', 'ConsumptionBudgetFilter'],
};

export const GetConsumptionPartitionTimeSeriesContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ListAllDashboardsContext: TypenamesContext = {
  additionalTypenames: ['Label'],
};

export const DashboardBySlugContext: TypenamesContext = {
  additionalTypenames: ['CollectionLink'],
};

export const ListAllDashboardsForSelectContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetDashboardConfigContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ListDocArtifactsContext: TypenamesContext = {
  additionalTypenames: ['DocArtifact', 'Label'],
};

export const GetDocArtifactContext: TypenamesContext = {
  additionalTypenames: ['Label'],
};

export const GetMonitorOwnershipContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ListMonitorsQueryContext: TypenamesContext = {
  additionalTypenames: [
    'Monitor',
    'Annotation',
    'Label',
    'ScheduleDay',
    'TimeRange',
    'SeverityCondition',
    'MonitorCondition',
    'ConditionOverride',
    'AlertRouteMatcher',
    'CollectionLink',
    'MonitorSignal',
    'MonitorSeries',
  ],
};

export const BasicListMonitorsQueryContext: TypenamesContext = {
  additionalTypenames: ['Monitor'],
};

export const ListNotificationPoliciesQueryContext: TypenamesContext = {
  additionalTypenames: [
    'NotificationPolicy',
    'NotifiersBySeverity',
    'Notifier',
    'NotificationRoutesOverride',
    'AlertRouteMatcher',
  ],
};

export const GetNotificationPolicyQueryContext: TypenamesContext = {
  additionalTypenames: [
    'NotifiersBySeverity',
    'Notifier',
    'AlertReceiverWebhookConfig',
    'AlertReceiverEmailConfig',
    'AlertReceiverSlackConfig',
    'AlertReceiverPagerdutyConfig',
    'AlertReceiverOpsGenieConfig',
    'AlertReceiverVictorOpsConfig',
    'NotificationRoutesOverride',
    'AlertRouteMatcher',
  ],
};

export const GetCollectionNotificationPolicyContext: TypenamesContext = {
  additionalTypenames: [
    'NotificationRule',
    'AlertReceiver',
    'AlertReceiverWebhookConfig',
    'AlertReceiverEmailConfig',
    'AlertReceiverSlackConfig',
    'AlertReceiverPagerdutyConfig',
    'AlertReceiverOpsGenieConfig',
    'AlertReceiverVictorOpsConfig',
    'NotifiersBySeverity',
    'Notifier',
    'NotificationRoutesOverride',
    'AlertRouteMatcher',
  ],
};

export const AvailableScopesQueryContext: TypenamesContext = {
  additionalTypenames: ['Template'],
};

export const SearchContext: TypenamesContext = {
  additionalTypenames: ['Result'],
};

export const ObjectMergeRulesContext: TypenamesContext = {
  additionalTypenames: ['ObjectMergeRule'],
};

export const GetComponentDiscoveryConfigsContext: TypenamesContext = {
  additionalTypenames: ['ComponentDiscoveryConfig', 'DerivedLabelFilter', 'KnownMetric'],
};

export const ListComponentPresentationConfigsContext: TypenamesContext = {
  additionalTypenames: ['ComponentPresentationConfig'],
};

export const ComponentPresentationDetailContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ObjectDiscoveryRulesContext: TypenamesContext = {
  additionalTypenames: ['ObjectDiscoveryRule'],
};

export const GetServiceComponentPresentationContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetDiscoveryPipelineMessagesContext: TypenamesContext = {
  additionalTypenames: ['DiscoveryPipelineStatusMessage', 'Label'],
};

export const ListPaginatedServicesContext: TypenamesContext = {
  additionalTypenames: ['Service', 'ServiceStatuses', 'Component', 'ComponentDiscovery'],
};

export const ListPaginatedServicesAlertContext: TypenamesContext = {
  additionalTypenames: ['Service'],
};

export const GetServiceOverviewContext: TypenamesContext = {
  additionalTypenames: ['LabelConfig', 'ValueMapping', 'Component'],
};

export const ServiceComponentDetailsViewContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ListPaginatedMinimalServicesContext: TypenamesContext = {
  additionalTypenames: ['Service'],
};

export const GetSloListContext: TypenamesContext = {
  additionalTypenames: ['SLO'],
};

export const GetSloDetailsContext: TypenamesContext = {
  additionalTypenames: [
    'Annotation',
    'LabelConfig',
    'ValueMapping',
    'SLOBurnRateDefinition',
    'Label',
    'LabelMatcher',
    'Component',
  ],
};

export const GetSloMutingRulesContext: TypenamesContext = {
  additionalTypenames: ['MutingRule'],
};

export const GetSloSummariesContext: TypenamesContext = {
  additionalTypenames: ['SLO'],
};

export const ServiceDiscoveryMetaContext: TypenamesContext = {
  additionalTypenames: ['ComponentDiscovery', 'SLOErrorCode'],
};

export const ListTeamsContext: TypenamesContext = {
  additionalTypenames: ['Team', 'Role'],
};

export const ListTeamHomepageContext: TypenamesContext = {
  additionalTypenames: ['Role', 'User', 'Link', 'NotificationPolicy'],
};

export const UserSettingsQueryContext: TypenamesContext = {
  additionalTypenames: [],
};

export const LoadUsersContext: TypenamesContext = {
  additionalTypenames: ['User', 'Role', 'ServiceAccount'],
};

export const LoadUsersSidebarContext: TypenamesContext = {
  additionalTypenames: ['User', 'ServiceAccount'],
};

export const LoadUserDetailsContext: TypenamesContext = {
  additionalTypenames: ['Role', 'Team', 'EventLogListItem'],
};

export const LoadMyAccountContext: TypenamesContext = {
  additionalTypenames: [],
};

export const PersonalAccessTokensListContext: TypenamesContext = {
  additionalTypenames: ['PersonalAccessToken'],
};

export const WebhookSigningKeyContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetRollupRulesContext: TypenamesContext = {
  additionalTypenames: ['RollupRule', 'Label', 'GraphiteLabelPolicyReplace', 'RollupRuleLabelReplace'],
};

export const GetMappingRulesContext: TypenamesContext = {
  additionalTypenames: ['MappingRule', 'Label'],
};

export const GetDashboardsBySlugsContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetEventLogByIdContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetEventLogsContext: TypenamesContext = {
  additionalTypenames: ['EventLogListItem'],
};

export const LoadDashboardSettingsContext: TypenamesContext = {
  additionalTypenames: ['Label'],
};

export const LoadDuplicateDashboardSettingsContext: TypenamesContext = {
  additionalTypenames: ['Label'],
};

export const GetDashboardForMigrationContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetDashboardContext: TypenamesContext = {
  additionalTypenames: ['Label', 'CollectionLink'],
};

export const GetDashboardTimestampsContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ListRecentDashboardsContext: TypenamesContext = {
  additionalTypenames: [],
};

export const FetchDerivedLabelsContext: TypenamesContext = {
  additionalTypenames: [
    'DerivedLabel',
    'NameMapping',
    'DerivedLabelFilter',
    'DerivedLabelValueMapping',
    'ValueDefinition',
    'DerivedLabelSpanTagNameMapping',
  ],
};

export const FetchDerivedLabelContext: TypenamesContext = {
  additionalTypenames: [
    'NameMapping',
    'DerivedLabelFilter',
    'DerivedLabelValueMapping',
    'ValueDefinition',
    'DerivedLabelSpanTagNameMapping',
  ],
};

export const PreviewDerivedLabelContext: TypenamesContext = {
  additionalTypenames: ['NameMappingValues'],
};

export const ListRecentlyTriggeredAlertsContext: TypenamesContext = {
  additionalTypenames: ['Alert', 'Label'],
};

export const GetDropRulesContext: TypenamesContext = {
  additionalTypenames: ['DropRule', 'Label'],
};

export const LoadLoggingConsumptionSnapshotContext: TypenamesContext = {
  additionalTypenames: ['LoggingContract'],
};

export const GetLoggedInTestUserIdContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetLogIngestConfigContext: TypenamesContext = {
  additionalTypenames: ['PlaintextParser', 'LogFieldParser', 'LogFieldPath', 'NamedStringNormalization'],
};

export const GetLogIngestConfigDefaultsContext: TypenamesContext = {
  additionalTypenames: ['NamedStringNormalization'],
};

export const ValidateFilterQueryContext: TypenamesContext = {
  additionalTypenames: [],
};

export const LoadLogsControlRulesContext: TypenamesContext = {
  additionalTypenames: ['LogControlRule', 'EmitMetricsLabel', 'ReplaceFieldMappedValuePair'],
};

export const LoadLogLookupTableContext: TypenamesContext = {
  additionalTypenames: [],
};

export const LoadLogLookupTablesContext: TypenamesContext = {
  additionalTypenames: ['LogLookupTable'],
};

export const MetricDDXContext: TypenamesContext = {
  additionalTypenames: [],
};

export const MonitorSignalQueryContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetPaginatedAlertEventsListContext: TypenamesContext = {
  additionalTypenames: ['AlertEvent', 'Label', 'MutingRule'],
};

export const GetTenantDataSourceSettingsContext: TypenamesContext = {
  additionalTypenames: [],
};

export const LoadMonitorEditorContext: TypenamesContext = {
  additionalTypenames: [
    'CollectionLink',
    'Label',
    'Annotation',
    'NotifiersBySeverity',
    'Notifier',
    'NotificationRoutesOverride',
    'AlertRouteMatcher',
    'SeverityCondition',
    'MonitorCondition',
    'ConditionOverride',
    'ScheduleDay',
    'TimeRange',
  ],
};

export const GetFullMonitorContext: TypenamesContext = {
  additionalTypenames: [
    'CollectionLink',
    'AlertRuleLabel',
    'SeverityCondition',
    'MonitorCondition',
    'ConditionOverride',
    'AlertRouteMatcher',
    'NotifiersBySeverity',
    'Notifier',
    'NotificationRoutesOverride',
    'Annotation',
    'Label',
  ],
};

export const GetMutingRulesForMonitorContext: TypenamesContext = {
  additionalTypenames: ['MutingRule', 'LabelMatcher'],
};

export const GetMonitorRoutesAndConditionsContext: TypenamesContext = {
  additionalTypenames: [
    'MatchingMonitorRoutesAndConditions',
    'AlertRuleLabel',
    'SeverityCondition',
    'MonitorCondition',
    'ConditionOverride',
    'AlertRouteMatcher',
    'NotifiersBySeverity',
    'Notifier',
    'NotificationRoutesOverride',
  ],
};

export const GetMonitorEventFiltersContext: TypenamesContext = {
  additionalTypenames: ['eventFilter'],
};

export const GetMonitorGroupingsContext: TypenamesContext = {
  additionalTypenames: ['MonitorSignal', 'Label', 'MonitorSeries'],
};

export const GetMonitorSummariesContext: TypenamesContext = {
  additionalTypenames: ['MonitorSummary'],
};

export const GetMutingRuleDetailsContext: TypenamesContext = {
  additionalTypenames: ['LabelMatcher'],
};

export const GetMutingRulesQueryContext: TypenamesContext = {
  additionalTypenames: ['MutingRule', 'LabelMatcher'],
};

export const GetNotifiersQueryContext: TypenamesContext = {
  additionalTypenames: [
    'AlertReceiver',
    'AlertReceiverWebhookConfig',
    'AlertReceiverSlackConfig',
    'AlertReceiverEmailConfig',
    'AlertReceiverPagerdutyConfig',
    'AlertReceiverOpsGenieConfig',
    'AlertReceiverVictorOpsConfig',
  ],
};

export const GetRecordingRulesQueryContext: TypenamesContext = {
  additionalTypenames: ['RecordingRule', 'AlertRuleLabel'],
};

export const GetRuleEvaluationsQueryContext: TypenamesContext = {
  additionalTypenames: ['RuleEvaluation'],
};

export const GetServiceAccountsContext: TypenamesContext = {
  additionalTypenames: ['ServiceAccount', 'ServiceAccountLabel'],
};

export const GetDiscoveryConfigExpressionContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ServiceDiscoveryPreviewContext: TypenamesContext = {
  additionalTypenames: ['DiscoveredService', 'DiscoveredComponent', 'PresentationComponent'],
};

export const PresentationDiscoveryEligibilityContext: TypenamesContext = {
  additionalTypenames: ['Service'],
};

export const GetRelatedServicesContext: TypenamesContext = {
  additionalTypenames: ['Service'],
};

export const LookupShortUrlContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetSloServiceDashboardsContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ListRecentSlosContext: TypenamesContext = {
  additionalTypenames: ['SLO'],
};

export const GetPreviewSloQueriesContext: TypenamesContext = {
  additionalTypenames: [],
};

export const ListTeamServicesContext: TypenamesContext = {
  additionalTypenames: ['Service', 'ServiceStatuses'],
};

export const ListChangeEventCategoriesContext: TypenamesContext = {
  additionalTypenames: ['TimelineCategory'],
};

export const GetTimelineSearchHistoryContext: TypenamesContext = {
  additionalTypenames: ['UserSearchHistory'],
};

export const GetTraceActiveBehaviorsContext: TypenamesContext = {
  additionalTypenames: ['TraceBehaviorActiveAssignment'],
};

export const GetTraceBehaviorConfigContext: TypenamesContext = {
  additionalTypenames: ['TraceBehaviorMainAssignment', 'TraceBehaviorOverrideAssignment'],
};

export const GetTraceBehaviorsContext: TypenamesContext = {
  additionalTypenames: ['TraceBehavior'],
};

export const GetDatasetContext: TypenamesContext = {
  additionalTypenames: ['SpanFilter', 'TagFilter'],
};

export const GetDatasetsContext: TypenamesContext = {
  additionalTypenames: ['Dataset', 'SpanFilter', 'TagFilter'],
};

export const GetUnassignedDatasetContext: TypenamesContext = {
  additionalTypenames: ['SpanFilter', 'TagFilter'],
};

export const GetTraceHeadSamplingRulesContext: TypenamesContext = {
  additionalTypenames: ['TraceJaegerRemoteSamplingStrategy', 'JaegerRemotePerOperationSamplingStrategy'],
};

export const GetTraceTailSamplingRulesContext: TypenamesContext = {
  additionalTypenames: ['TraceTailSamplingRule', 'SpanFilter', 'TagFilter'],
};

export const GetLinkTemplateContext: TypenamesContext = {
  additionalTypenames: [],
};

export const GetLinkTemplatesContext: TypenamesContext = {
  additionalTypenames: ['LinkTemplate'],
};

export const TracingRecentSearchesContext: TypenamesContext = {
  additionalTypenames: ['TraceSearchHistory', 'SpanFilter', 'TagFilter', 'TraceAggregationGroupByKey'],
};

export const SavedTraceSearchesContext: TypenamesContext = {
  additionalTypenames: ['SavedTraceSearch', 'SpanFilter', 'TagFilter', 'TraceAggregationGroupByKey'],
};

export const FilteredSavedTraceSearchesContext: TypenamesContext = {
  additionalTypenames: ['SavedTraceSearch', 'SpanFilter', 'TagFilter', 'TraceAggregationGroupByKey'],
};

export const GetTraceTopTagsContext: TypenamesContext = {
  additionalTypenames: ['TraceTopTag'],
};

export const TraceMetricsRulesContext: TypenamesContext = {
  additionalTypenames: ['TraceMetricsRule', 'Label', 'TraceMetricsGroupBy', 'SpanFilter', 'TagFilter'],
};

export const GetTracingServiceAttributeMapContext: TypenamesContext = {
  additionalTypenames: ['TracingServiceMapping'],
};

export const GetServiceTracingAttributeMapContext: TypenamesContext = {
  additionalTypenames: ['TracingServiceMapping'],
};

export const LoadUserMembershipDialogContext: TypenamesContext = {
  additionalTypenames: ['Team', 'Role'],
};
